(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 47583:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)"};

/***/ }),

/***/ 65452:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varLinkOnLight":"var(--tkww-union-color-link-on-light, var(--tkww-union-color-additional-01extra-400, #0073E6))"};

/***/ }),

/***/ 28437:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varPrimaryFontFamily":"var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif)","varSecondaryFontFamily":"var(--tkww-union-typography-secondary-font-family, union-secondary-font, union-serif, Georgia, \"Times New Roman\", Times, serif)","varRegularFontWeight":"var(--tkww-union-typography-regular-font-weight, 400)","varBoldFontWeight":"var(--tkww-union-typography-bold-font-weight, 500)","varExtraBoldFontWeight":"var(--tkww-union-typography-extra-bold-font-weight, 800)","var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","varLineHeight100":"var(--tkww-union-typography-scale-100-line-height, 1.34)","varFontSize200":"var(--tkww-union-typography-scale-200-font-size, 0.875rem)","varLineHeight200":"var(--tkww-union-typography-scale-200-line-height, 1.42857)","varFontSize300":"var(--tkww-union-typography-scale-300-font-size, 1rem)","varLineHeight300":"var(--tkww-union-typography-scale-300-line-height, 1.5)","varFontSize400":"var(--tkww-union-typography-scale-400-font-size, 1.125rem)","varLineHeight400":"var(--tkww-union-typography-scale-400-line-height, 1.3333)","varFontSize450":"var(--tkww-union-typography-scale-450-font-size, 1.125rem)","varLineHeight450":"var(--tkww-union-typography-scale-450-line-height, 1.78)","varFontSize500":"var(--tkww-union-typography-scale-500-font-size, 1.25rem)","varLineHeight500":"var(--tkww-union-typography-scale-500-line-height, 1.4)","varFontSize600":"var(--tkww-union-typography-scale-600-font-size, 1.5rem)","varLineHeight600":"var(--tkww-union-typography-scale-600-line-height, 1.333375)","varFontSize700":"var(--tkww-union-typography-scale-700-font-size, 1.75rem)","varLineHeight700":"var(--tkww-union-typography-scale-700-line-height, 1.286)","varFontSize800":"var(--tkww-union-typography-scale-800-font-size, 2rem)","varLineHeight800":"var(--tkww-union-typography-scale-800-line-height, 1.25)","varFontSize900":"var(--tkww-union-typography-scale-900-font-size, 2.25rem)","varLineHeight900":"var(--tkww-union-typography-scale-900-line-height, 1.2225)","var-hero-xl-letter-spacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","varHeroXlLetterSpacing":"var(--tkww-union-typography-category-hero-xl-letter-spacing, -0.02em)","var-hero-xl-font-weight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroXlFontWeight":"var(--tkww-union-typography-category-hero-xl-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-xl-font-family":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroXlFontFamily":"var(--tkww-union-typography-category-hero-xl-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","varHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 5.625rem)","var-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-hero-lg-letter-spacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","varHeroLgLetterSpacing":"var(--tkww-union-typography-category-hero-lg-letter-spacing, -0.02em)","var-hero-lg-font-weight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroLgFontWeight":"var(--tkww-union-typography-category-hero-lg-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-lg-font-family":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroLgFontFamily":"var(--tkww-union-typography-category-hero-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","varHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 3.75rem)","var-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-hero-md-letter-spacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","varHeroMdLetterSpacing":"var(--tkww-union-typography-category-hero-md-letter-spacing, -0.02em)","var-hero-md-font-weight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroMdFontWeight":"var(--tkww-union-typography-category-hero-md-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-md-font-family":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroMdFontFamily":"var(--tkww-union-typography-category-hero-md-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","varHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 3rem)","var-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-hero-sm-letter-spacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","varHeroSmLetterSpacing":"var(--tkww-union-typography-category-hero-sm-letter-spacing, -0.02em)","var-hero-sm-font-weight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","varHeroSmFontWeight":"var(--tkww-union-typography-category-hero-sm-font-weight, var(--tkww-union-typography-extra-bold-font-weight, 800))","var-hero-sm-font-family":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varHeroSmFontFamily":"var(--tkww-union-typography-category-hero-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","varHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 2.125rem)","var-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-h1-font-weight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH1FontWeight":"var(--tkww-union-typography-category-h1-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h1-font-family":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH1FontFamily":"var(--tkww-union-typography-category-h1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","varH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.875rem)","var-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2)","varH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2)","var-h2-font-weight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH2FontWeight":"var(--tkww-union-typography-category-h2-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h2-font-family":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH2FontFamily":"var(--tkww-union-typography-category-h2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","varH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.75rem)","var-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","varH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2142857143)","var-h3-letter-spacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","varH3LetterSpacing":"var(--tkww-union-typography-category-h3-letter-spacing, 0)","var-h3-font-weight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH3FontWeight":"var(--tkww-union-typography-category-h3-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h3-font-family":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH3FontFamily":"var(--tkww-union-typography-category-h3-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","varH3FontSize":"var(--tkww-union-typography-category-h3-font-size, var(--tkww-union-typography-scale-600-font-size, 1.5rem))","var-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-h4-letter-spacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","varH4LetterSpacing":"var(--tkww-union-typography-category-h4-letter-spacing, 0)","var-h4-font-weight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varH4FontWeight":"var(--tkww-union-typography-category-h4-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-h4-font-family":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varH4FontFamily":"var(--tkww-union-typography-category-h4-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-subhead-letter-spacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","varSubheadLetterSpacing":"var(--tkww-union-typography-category-subhead-letter-spacing, 0)","var-subhead-font-family":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varSubheadFontFamily":"var(--tkww-union-typography-category-subhead-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","varSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, var(--tkww-union-typography-scale-500-font-size, 1.25rem))","var-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","varSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, var(--tkww-union-typography-scale-500-line-height, 1.4))","var-editorial-letter-spacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","varEditorialLetterSpacing":"var(--tkww-union-typography-category-editorial-letter-spacing, 0)","var-editorial-font-family":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varEditorialFontFamily":"var(--tkww-union-typography-category-editorial-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-editorial-font-size":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","varEditorialFontSize":"var(--tkww-union-typography-category-editorial-font-size, var(--tkww-union-typography-scale-450-font-size, 1.125rem))","var-editorial-line-height":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","varEditorialLineHeight":"var(--tkww-union-typography-category-editorial-line-height, 1.4444444444)","var-body1-letter-spacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","varBody1LetterSpacing":"var(--tkww-union-typography-category-body1-letter-spacing, 0)","var-body1-font-family":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody1FontFamily":"var(--tkww-union-typography-category-body1-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body1-font-size":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varBody1FontSize":"var(--tkww-union-typography-category-body1-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-body1-line-height":"var(--tkww-union-typography-category-body1-line-height, 1.375)","varBody1LineHeight":"var(--tkww-union-typography-category-body1-line-height, 1.375)","var-body2-letter-spacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","varBody2LetterSpacing":"var(--tkww-union-typography-category-body2-letter-spacing, 0)","var-body2-font-family":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varBody2FontFamily":"var(--tkww-union-typography-category-body2-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-body2-font-size":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varBody2FontSize":"var(--tkww-union-typography-category-body2-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-body2-line-height":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varBody2LineHeight":"var(--tkww-union-typography-category-body2-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-buttonL-letter-spacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","varButtonLLetterSpacing":"var(--tkww-union-typography-category-buttonL-letter-spacing, 0)","var-buttonL-font-weight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonLFontWeight":"var(--tkww-union-typography-category-buttonL-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonL-font-family":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonLFontFamily":"var(--tkww-union-typography-category-buttonL-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonL-font-size":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","varButtonLFontSize":"var(--tkww-union-typography-category-buttonL-font-size, var(--tkww-union-typography-scale-300-font-size, 1rem))","var-buttonL-line-height":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","varButtonLLineHeight":"var(--tkww-union-typography-category-buttonL-line-height, var(--tkww-union-typography-scale-300-line-height, 1.5))","var-buttonM-letter-spacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","varButtonMLetterSpacing":"var(--tkww-union-typography-category-buttonM-letter-spacing, 0)","var-buttonM-font-weight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varButtonMFontWeight":"var(--tkww-union-typography-category-buttonM-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-buttonM-font-family":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varButtonMFontFamily":"var(--tkww-union-typography-category-buttonM-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-buttonM-font-size":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","varButtonMFontSize":"var(--tkww-union-typography-category-buttonM-font-size, var(--tkww-union-typography-scale-200-font-size, 0.875rem))","var-buttonM-line-height":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","varButtonMLineHeight":"var(--tkww-union-typography-category-buttonM-line-height, var(--tkww-union-typography-scale-200-line-height, 1.42857))","var-overline-letter-spacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","varOverlineLetterSpacing":"var(--tkww-union-typography-category-overline-letter-spacing, 2px)","var-overline-text-transform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","varOverlineTextTransform":"var(--tkww-union-typography-category-overline-text-transform, uppercase)","var-overline-font-weight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","varOverlineFontWeight":"var(--tkww-union-typography-category-overline-font-weight, var(--tkww-union-typography-bold-font-weight, 500))","var-overline-font-family":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varOverlineFontFamily":"var(--tkww-union-typography-category-overline-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-overline-font-size":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varOverlineFontSize":"var(--tkww-union-typography-category-overline-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-overline-line-height":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","varOverlineLineHeight":"var(--tkww-union-typography-category-overline-line-height, 1.3333333333)","var-caption-lg-letter-spacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","varCaptionLgLetterSpacing":"var(--tkww-union-typography-category-caption-lg-letter-spacing, 0)","var-caption-lg-font-weight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionLgFontWeight":"var(--tkww-union-typography-category-caption-lg-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-lg-font-family":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionLgFontFamily":"var(--tkww-union-typography-category-caption-lg-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-lg-font-size":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","varCaptionLgFontSize":"var(--tkww-union-typography-category-caption-lg-font-size, var(--tkww-union-typography-scale-100-font-size, 0.75rem))","var-caption-lg-line-height":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","varCaptionLgLineHeight":"var(--tkww-union-typography-category-caption-lg-line-height, 1.3333333333)","var-caption-sm-letter-spacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","varCaptionSmLetterSpacing":"var(--tkww-union-typography-category-caption-sm-letter-spacing, 0)","var-caption-sm-font-weight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","varCaptionSmFontWeight":"var(--tkww-union-typography-category-caption-sm-font-weight, var(--tkww-union-typography-regular-font-weight, 400))","var-caption-sm-font-family":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","varCaptionSmFontFamily":"var(--tkww-union-typography-category-caption-sm-font-family, var(--tkww-union-typography-primary-font-family, union-primary-font, union-sans-serif, -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif))","var-caption-sm-font-size":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","varCaptionSmFontSize":"var(--tkww-union-typography-category-caption-sm-font-size, 0.6875rem)","var-caption-sm-line-height":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","varCaptionSmLineHeight":"var(--tkww-union-typography-category-caption-sm-line-height, 1.4545454545)","var-mobile-hero-xl-font-size":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","varMobileHeroXlFontSize":"var(--tkww-union-typography-category-hero-xl-font-size, 3.75rem)","var-mobile-hero-xl-line-height":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","varMobileHeroXlLineHeight":"var(--tkww-union-typography-category-hero-xl-line-height, 1)","var-mobile-hero-lg-font-size":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","varMobileHeroLgFontSize":"var(--tkww-union-typography-category-hero-lg-font-size, 2.8125rem)","var-mobile-hero-lg-line-height":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","varMobileHeroLgLineHeight":"var(--tkww-union-typography-category-hero-lg-line-height, 1)","var-mobile-hero-md-font-size":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","varMobileHeroMdFontSize":"var(--tkww-union-typography-category-hero-md-font-size, 2.25rem)","var-mobile-hero-md-line-height":"var(--tkww-union-typography-category-hero-md-line-height, 1)","varMobileHeroMdLineHeight":"var(--tkww-union-typography-category-hero-md-line-height, 1)","var-mobile-hero-sm-font-size":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","varMobileHeroSmFontSize":"var(--tkww-union-typography-category-hero-sm-font-size, 1.875rem)","var-mobile-hero-sm-line-height":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","varMobileHeroSmLineHeight":"var(--tkww-union-typography-category-hero-sm-line-height, 1)","var-mobile-h1-font-size":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","varMobileH1FontSize":"var(--tkww-union-typography-category-h1-font-size, 1.75rem)","var-mobile-h1-line-height":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","varMobileH1LineHeight":"var(--tkww-union-typography-category-h1-line-height, 1.2142857143)","var-mobile-h2-font-size":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","varMobileH2FontSize":"var(--tkww-union-typography-category-h2-font-size, 1.625rem)","var-mobile-h2-line-height":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","varMobileH2LineHeight":"var(--tkww-union-typography-category-h2-line-height, 1.2307692308)","var-mobile-h3-font-size":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","varMobileH3FontSize":"var(--tkww-union-typography-category-h3-font-size, 1.5rem)","var-mobile-h3-line-height":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","varMobileH3LineHeight":"var(--tkww-union-typography-category-h3-line-height, 1.1666666667)","var-mobile-h4-font-size":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","varMobileH4FontSize":"var(--tkww-union-typography-category-h4-font-size, 1.375rem)","var-mobile-h4-line-height":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","varMobileH4LineHeight":"var(--tkww-union-typography-category-h4-line-height, 1.1818181818)","var-mobile-subhead-font-size":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","varMobileSubheadFontSize":"var(--tkww-union-typography-category-subhead-font-size, 1.25rem)","var-mobile-subhead-line-height":"var(--tkww-union-typography-category-subhead-line-height, 1.4)","varMobileSubheadLineHeight":"var(--tkww-union-typography-category-subhead-line-height, 1.4)"};

/***/ }),

/***/ 48557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animated":"animated--de112","overlay":"overlay--f7774","not-visible":"not-visible--73d04","notVisible":"not-visible--73d04","not-enabled":"not-enabled--81fe6","notEnabled":"not-enabled--81fe6","color-dark":"color-dark--9a58c","colorDark":"color-dark--9a58c","color-light":"color-light--74535","colorLight":"color-light--74535","fixed-to-relative":"fixed-to-relative--20c20","fixedToRelative":"fixed-to-relative--20c20","fixed-to-page":"fixed-to-page--bc509","fixedToPage":"fixed-to-page--bc509"};

/***/ }),

/***/ 59087:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"varAdditional01Extra400":"var(--tkww-union-color-additional-01extra-400, #0073E6)","size-default":"size-default--0f675","sizeDefault":"size-default--0f675","spinner":"spinner--99554","size-sm":"size-sm--67c12","sizeSm":"size-sm--67c12","size-md":"size-md--e4cb3","sizeMd":"size-md--e4cb3","size-lg":"size-lg--7ac1a","sizeLg":"size-lg--7ac1a","loading":"loading--fadb3","rotate-animation":"rotate-animation--1db20","rotateAnimation":"rotate-animation--1db20","loading--animation":"loading--animation--9f17c","loadingAnimation":"loading--animation--9f17c"};

/***/ }),

/***/ 94943:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {};

/***/ }),

/***/ 63465:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--4ac2d","overlaySpinner":"overlaySpinner--d59de"};

/***/ }),

/***/ 62459:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask--1d999","wrapper":"wrapper--7317a","wrapperBefore":"wrapperBefore--c44f4","loader":"loader--07231","spin":"spin--749ff"};

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(20311);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ TrackingProvider; },
/* harmony export */   "U": function() { return /* binding */ TrackingContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);



var TrackingContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var TrackingProvider = function(param) {
    var memberId = param.memberId, platform = param.platform, product = param.product, children = param.children, referrer = param.referrer;
    var brandedMemberId = (0,_utils_config__WEBPACK_IMPORTED_MODULE_2__/* .isTenant */ .J)("tk") ? memberId : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TrackingContext.Provider, {
        value: {
            affiliation: (0,_utils_config__WEBPACK_IMPORTED_MODULE_2__/* .isTenant */ .J)("tk") ? "tk" : "ww",
            memberId: brandedMemberId !== null && brandedMemberId !== void 0 ? brandedMemberId : null,
            platform: platform,
            product: product,
            referrer: referrer
        },
        children: children
    });
};


/***/ }),

/***/ 78985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ UserContext; },
/* harmony export */   "d": function() { return /* binding */ UserProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);


var UserContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
var UserProvider = function(param) {
    var user = param.user, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserContext.Provider, {
        value: {
            user: user,
            isLoggedIn: !!user
        },
        children: children
    });
};


/***/ }),

/***/ 80207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ categoriesHrefToCategoryMap; },
/* harmony export */   "kq": function() { return /* binding */ guestBooks; }
/* harmony export */ });
/* unused harmony exports saveTheDates, petitesMagnets, changeTheDates, weddingInvitations, allInOneWeddingInvitations, invitations, allInOneInvitations, ceremonyAndReception, holidayCardEnvelopes, holidayCards, thankyou, categoriesSkuToCategoryMap, getInvitationCategoriesIds, getReprintCategoryIds */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
// TK




var saveTheDatesLink = "/save-the-dates";
var changeTheDatesLink = "/change-the-dates";
var invitationsLink = "/invitations";
var ceremonyReceptionLink = "/ceremony-reception";
var thankYousLink = "/thank-yous";
var holidayCardsLink = "/holiday-cards";
var envelopesLink = "/envelopes";
var saveTheDateCards = {
    sku: "SDC",
    name: "Save the Date Cards",
    nameTextOverride: "Standard Cards",
    seoTags: {
        title: "Wedding Save The Dates | The Knot",
        description: "Share the excitement by sending guests customizable save-the-date cards. Choose from hundreds of gorgeous designs, from elegant to rustic.",
        abstract: "Share the excitement by sending guests customizable save-the-date cards. Choose from hundreds of gorgeous designs, from elegant to rustic.",
        robots: null
    },
    href: "".concat(saveTheDatesLink, "?format=standard"),
    alternateHref: "".concat(saveTheDatesLink, "/save-the-date-cards"),
    parentSku: "STDA",
    formats: [
        "postcard",
        "petite",
        "standard",
        "magnet"
    ]
};
var saveTheDatePostCards = {
    sku: "SDP",
    name: "Save the Date Postcards",
    nameTextOverride: "Postcards",
    seoTags: {
        title: "Wedding Save The Date Postcards | The Knot",
        description: "Help guests mark their calendars by sending customizable save-the-date postcards. Choose from hundreds of gorgeous designs, from elegant to rustic.",
        abstract: "Help guests mark their calendars by sending customizable save-the-date postcards. Choose from hundreds of gorgeous designs, from elegant to rustic.",
        robots: null
    },
    href: "".concat(saveTheDatesLink, "?format=postcard"),
    alternateHref: "".concat(saveTheDatesLink, "/save-the-date-postcards"),
    parentSku: "STDA",
    formats: [
        "postcard",
        "petite",
        "standard",
        "magnet"
    ]
};
var saveTheDatePetiteCards = {
    sku: "SDT",
    name: "Save the Date Petite Cards",
    nameTextOverride: "Petite Cards",
    seoTags: {
        title: "Petite Wedding Save the Date Cards | The Knot",
        description: "Petite save the date cards make it easy to stay in budget. Choose from customizable designs ranging from elegant to rustic to match your wedding vision.",
        abstract: "Petite save the date cards make it easy to stay in budget. Choose from customizable designs ranging from elegant to rustic to match your wedding vision.",
        robots: null
    },
    href: "".concat(saveTheDatesLink, "?format=petite"),
    parentSku: "STDA",
    formats: [
        "postcard",
        "petite",
        "standard",
        "magnet"
    ]
};
var savetheDateMagnets = {
    sku: "SDM",
    name: "Save the Date Magnets",
    nameTextOverride: "Magnets",
    seoTags: {
        title: "Wedding Save The Date Magnets | The Knot",
        description: "Announce your wedding with customizable save the date magnets. These magnetic cards stick to your guests' refrigerators for a regular reminder of your big day.",
        abstract: "Announce your wedding with customizable save the date magnets. These magnetic cards stick to your guests' refrigerators for a regular reminder of your big day.",
        robots: null
    },
    href: "".concat(saveTheDatesLink, "?format=magnet"),
    alternateHref: "".concat(saveTheDatesLink, "/save-the-date-magnets"),
    parentSku: "STDA",
    formats: [
        "postcard",
        "petite",
        "standard",
        "magnet"
    ]
};
var changeTheDateCards = {
    sku: "CDC",
    name: "Change the Date Cards",
    nameTextOverride: "Change the Date Cards",
    seoTags: {
        title: "Wedding Change The Date Cards | The Knot",
        description: "Change of plans? Keep guests in the loop with customizable change-the-date cards. Choose from hundreds of affordable designs.",
        abstract: "Change of plans? Keep guests in the loop with customizable change-the-date cards. Choose from hundreds of affordable designs.",
        robots: null
    },
    href: "".concat(changeTheDatesLink, "/change-the-date-cards"),
    parentSku: "CTDA"
};
var changeTheDatePostCards = {
    sku: "CDP",
    name: "Change the Date Postcards",
    nameTextOverride: "Change the Date Postcards",
    seoTags: {
        title: "Wedding Change The Date Postcards | The Knot",
        description: "Share your updated wedding plans in style with change-the-date postcards. Choose your favorite design then customize it to match your style.",
        abstract: "Share your updated wedding plans in style with change-the-date postcards. Choose your favorite design then customize it to match your style.",
        robots: null
    },
    href: "".concat(changeTheDatesLink, "/change-the-date-postcards"),
    parentSku: "CTDA"
};
var saveTheDates = {
    sku: "STDA",
    name: "Save the Dates",
    seoTags: {
        title: "Wedding Save The Dates | Elegant to Rustic Designs | The Knot",
        description: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        abstract: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        robots: null
    },
    href: saveTheDatesLink,
    subCategories: [
        saveTheDateCards,
        saveTheDatePostCards,
        saveTheDatePetiteCards,
        savetheDateMagnets
    ],
    formats: [
        "postcard",
        "petite",
        "standard",
        "magnet"
    ]
};
var petitesMagnets = {
    sku: "STDA",
    name: "Save the Dates",
    seoTags: {
        title: "Wedding Save The Dates | Elegant to Rustic Designs | The Knot",
        description: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        abstract: "Announce your wedding with customizable save-the-date cards. With hundreds of styles, from elegant to rustic, you can find one that matches your wedding vision.",
        robots: null
    },
    href: saveTheDatesLink
};
var changeTheDates = {
    sku: "CTDA",
    name: "Change the Dates",
    seoTags: {
        title: "Change The Dates | Wedding Postponement Stationery | The Knot",
        description: "Change of plans? Update your guests about your wedding postponement in style with affordable, customizable wedding change-the-date cards.",
        abstract: "Change of plans? Update your guests about your wedding postponement in style with affordable, customizable wedding change-the-date cards.",
        robots: null
    },
    href: changeTheDatesLink,
    subCategories: [
        changeTheDateCards,
        changeTheDatePostCards
    ],
    formats: [
        "postcard",
        "standard"
    ]
};
var weddingInvitations = {
    sku: "WIN",
    name: "Wedding Invitations",
    seoTags: {
        title: "Wedding Invitations | The Knot",
        description: "Looking for custom wedding invitations? Discover hundreds of affordable designs made just for you.",
        abstract: "Looking for custom wedding invitations? Discover hundreds of affordable designs made just for you.",
        robots: null
    },
    href: "".concat(invitationsLink, "/wedding"),
    parentSku: "INVI",
    formats: [
        "standard",
        "all-in-one"
    ]
};
var rsvpCards = {
    sku: "RSC",
    name: "RSVP Cards",
    seoTags: {
        title: "Wedding RSVP Cards | The Knot",
        description: "Find affordable wedding RSVP cards that your guests will love. First choose your design, then customize it to match your wedding vision.",
        abstract: "Find affordable wedding RSVP cards that your guests will love. First choose your design, then customize it to match your wedding vision.",
        robots: null
    },
    href: "/rsvp-cards",
    parentSku: "INVI"
};
var enclosureCards = {
    sku: "ENC",
    name: "Enclosure Cards",
    seoTags: {
        title: "Wedding Enclosure Cards | The Knot",
        description: "Give guests the need-to-know details with a stylish wedding enclosure card. Customize and match it to your wedding stationery suite.",
        abstract: "Give guests the need-to-know details with a stylish wedding enclosure card. Customize and match it to your wedding stationery suite.",
        robots: null
    },
    href: "/enclosure-cards",
    parentSku: "INVI"
};
var envelopeLiners = {
    sku: "EVL",
    name: "Envelope Liners",
    seoTags: {
        title: "Envelope Liners | The Knot",
        description: "Surprise guests by selecting envelope liners as a fun finishing touch. Choose your favorite design and customize it to complement your wedding stationery suite.",
        abstract: "Surprise guests by selecting envelope liners as a fun finishing touch. Choose your favorite design and customize it to complement your wedding stationery suite.",
        robots: null
    },
    href: "/envelope-liners",
    parentSku: "INVI"
};
var bridalShowerInvitations = {
    sku: "BRI",
    name: "Bridal Shower Invitations",
    seoTags: {
        title: "Bridal Shower Invitations | The Knot",
        description: "Invite guests to your bridal shower or wedding shower with customizable bridal shower invitations. Choose from hundreds of designs to match your wedding vision.",
        abstract: "Invite guests to your bridal shower or wedding shower with customizable bridal shower invitations. Choose from hundreds of designs to match your wedding vision.",
        robots: null
    },
    href: "".concat(invitationsLink, "/bridal-shower"),
    parentSku: "INVI"
};
var rehearsalDinnerInvitations = {
    sku: "RDI",
    name: "Rehearsal Dinner Invitations",
    seoTags: {
        title: "Rehearsal Dinner Invitations | The Knot",
        description: "Invite guests to kick off your wedding with customizable rehearsal dinner invitations. Choose from hundreds of designs to match your wedding vision.",
        abstract: "Invite guests to kick off your wedding with customizable rehearsal dinner invitations. Choose from hundreds of designs to match your wedding vision.",
        robots: null
    },
    href: "".concat(invitationsLink, "/rehearsal-dinner"),
    parentSku: "INVI"
};
var allInOneWeddingInvitations = {
    sku: "AIO" /* ! not defined in BC */ ,
    name: "All-in-One Wedding Invitations",
    seoTags: {
        title: "All-in-One Wedding Invitations | Seal and Send | The Knot",
        description: "All-in-one invitations make it easy to stay in budget. Get your wedding invitation, RSVP card and envelope in one. All you have to do is seal and send to your guests.",
        abstract: "All-in-one invitations make it easy to stay in budget. Get your wedding invitation, RSVP card and envelope in one. All you have to do is seal and send to your guests.",
        robots: null
    },
    href: "".concat(invitationsLink, "/wedding?format=all-in-one"),
    parentSku: "INVI",
    breadcrumbAs: weddingInvitations,
    formats: [
        "all-in-one",
        "standard"
    ]
};
var invitations = {
    sku: "INVI",
    name: "Invitations",
    seoTags: {
        title: "Wedding Invitations | Elegant to Rustic Designs | The Knot",
        description: "Explore hundreds of affordable wedding invitations that are just your style. From elegant to rustic, customize an invitation designed for your love story.",
        abstract: "Explore hundreds of affordable wedding invitations that are just your style. From elegant to rustic, customize an invitation designed for your love story.",
        robots: null
    },
    href: invitationsLink,
    subCategories: [
        weddingInvitations,
        enclosureCards,
        rsvpCards,
        envelopeLiners,
        bridalShowerInvitations,
        rehearsalDinnerInvitations, 
    ],
    formats: [
        "all-in-one",
        "standard"
    ]
};
var allInOneInvitations = {
    sku: "AIOINV",
    name: "All-in-One Wedding Invitations",
    seoTags: {
        title: "All-in-One Invitations with RSVP Cards | The Knot",
        description: "Budget-friendly and easily customizable. All-in-one wedding invitations include your wedding invitation, RSVP card and envelope. Free guest and return addressing.",
        abstract: "Budget-friendly and easily customizable. All-in-one wedding invitations include your wedding invitation, RSVP card and envelope. Free guest and return addressing.",
        robots: null
    },
    href: "".concat(invitationsLink, "?format=all-in-one"),
    breadcrumbAs: weddingInvitations,
    formats: [
        "all-in-one",
        "standard"
    ]
};
var programs = {
    sku: "PRG",
    name: "Programs",
    seoTags: {
        title: "Wedding Programs | The Knot",
        description: "Keep guests in-the-know by adding wedding programs to your wedding stationery suite. Choose your favorite design, then customize it to highlight your day-of details.",
        abstract: "Keep guests in-the-know by adding wedding programs to your wedding stationery suite. Choose your favorite design, then customize it to highlight your day-of details.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/programs"),
    parentSku: "CERE"
};
var placeCards = {
    sku: "PLC",
    name: "Place Cards",
    seoTags: {
        title: "Wedding Place and Escort Cards | The Knot",
        description: "Let guests know which table is theirs with wedding place and escort cards. Choose from a variety of designs to match your wedding theme, colors and style.",
        abstract: "Let guests know which table is theirs with wedding place and escort cards. Choose from a variety of designs to match your wedding theme, colors and style.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/place-cards"),
    parentSku: "CERE"
};
var menus = {
    sku: "MEN",
    name: "Menus",
    seoTags: {
        title: "Wedding Menus | The Knot",
        description: "Give guests a taste of what's to come with a chic wedding menu. Choose your favorite design and customize it to match your wedding theme, colors and style.",
        abstract: "Give guests a taste of what's to come with a chic wedding menu. Choose your favorite design and customize it to match your wedding theme, colors and style.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/menus"),
    parentSku: "CERE"
};
var tableNumbers = {
    sku: "TNB",
    name: "Table Numbers",
    seoTags: {
        title: "Wedding Table Numbers | The Knot",
        description: "Help guests navigate your wedding reception with wedding table numbers. Choose from a variety of designs to match your wedding theme, colors and style.",
        abstract: "Help guests navigate your wedding reception with wedding table numbers. Choose from a variety of designs to match your wedding theme, colors and style.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/table-numbers"),
    parentSku: "CERE"
};
var stickers = {
    sku: "STK",
    name: "Stickers",
    seoTags: {
        title: "Wedding Stickers | The Knot",
        description: "Affordable and fun, wedding stickers make great wedding favors or envelope additions. Customize a design that showcases your style.",
        abstract: "Affordable and fun, wedding stickers make great wedding favors or envelope additions. Customize a design that showcases your style.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/stickers"),
    parentSku: "CERE"
};
var giftTags = {
    sku: "GFT",
    name: "Gift Tags",
    seoTags: {
        title: "Wedding Gift Tags | The Knot",
        description: "Thank guests in a fun and memorable way with customizable wedding gift tags. Perfect for a variety of wedding favors.",
        abstract: "Thank guests in a fun and memorable way with customizable wedding gift tags. Perfect for a variety of wedding favors.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/gift-tags"),
    parentSku: "CERE"
};
var guestBooks = {
    sku: "GBK",
    name: "Guest Books",
    seoTags: {
        title: "Wedding Guest Books | The Knot",
        description: "Design the perfect keepsake—a wedding guest book. Capture guests' memories and well-wishes in a custom, one-of-a-kind book.",
        abstract: "Design the perfect keepsake—a wedding guest book. Capture guests' memories and well-wishes in a custom, one-of-a-kind book.",
        robots: null
    },
    href: "".concat(ceremonyReceptionLink, "/guest-books"),
    parentSku: "CERE"
};
var ceremonyAndReception = {
    sku: "CERE",
    name: "Ceremony & Reception",
    seoTags: {
        title: "Ceremony, Reception and Wedding Day Stationery | The Knot",
        description: "Wow guests with customizable ceremony and reception stationery. Find memorable touches for your wedding day including programs, menus, guest books and more.",
        abstract: "Wow guests with customizable ceremony and reception stationery. Find memorable touches for your wedding day including programs, menus, guest books and more.",
        robots: null
    },
    href: ceremonyReceptionLink,
    subCategories: [
        programs,
        placeCards,
        guestBooks,
        menus,
        stickers,
        tableNumbers,
        giftTags
    ]
};
var thankyouCards = {
    sku: "TYC",
    name: "Thank You Cards",
    seoTags: {
        title: "Wedding Thank You Cards | The Knot",
        description: "Let guests know how thankful you are with lovely wedding thank-you cards. Completely customizable, showcase photos from your day or match it to your wedding theme.",
        abstract: "Let guests know how thankful you are with lovely wedding thank-you cards. Completely customizable, showcase photos from your day or match it to your wedding theme.",
        robots: null
    },
    href: "".concat(thankYousLink, "/thank-you-cards"),
    parentSku: "TKYS"
};
var thankyouPostCards = {
    sku: "TYP",
    name: "Thank You Postcards",
    seoTags: {
        title: "Wedding Thank You Postcards | The Knot",
        description: "Show guests your gratitude with beautiful wedding thank-you postcards. Available in a variety of designs, from elegant to rustic.",
        abstract: "Show guests your gratitude with beautiful wedding thank-you postcards. Available in a variety of designs, from elegant to rustic.",
        robots: null
    },
    href: "".concat(thankYousLink, "/thank-you-postcards"),
    parentSku: "TKYS"
};
var holidayCardEnvelopes = {
    sku: "HOLENV"
};
var holidayCardsBase = {
    sku: "HOL",
    name: "Holiday Cards",
    seoTags: {
        title: "Holiday Cards | The Knot",
        description: "Send your season's greetings with The Knot's holiday cards. Available in a variety of designs and customizable to match your style.",
        abstract: "Send your season's greetings with The Knot's holiday cards. Available in a variety of designs and customizable to match your style.",
        robots: null
    },
    href: holidayCardsLink
};
var holidayCardsSubCategory = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, holidayCardsBase), {
    name: "New! Holiday Cards"
});
var holidayCards = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, holidayCardsBase), {
    nameTextOverride: "Holiday",
    subCategories: [
        holidayCardsSubCategory
    ]
});
var thankyou = {
    sku: "TKYS",
    name: "Thank Yous",
    seoTags: {
        title: "Wedding Thank You Cards | Elegant to Rustic Designs | The Knot",
        description: "Show guests your love and appreciation with customizable wedding thank-you cards. Available in a variety of designs, from elegant to rustic.",
        abstract: "Show guests your love and appreciation with customizable wedding thank-you cards. Available in a variety of designs, from elegant to rustic.",
        robots: null
    },
    href: thankYousLink,
    subCategories: [
        thankyouCards,
        thankyouPostCards
    ],
    formats: [
        "standard",
        "postcard"
    ]
};
var responseCardEnvelopes = {
    sku: "RSCENV",
    name: "Response Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var weddingInvitationEnvelopes = {
    sku: "WINENV",
    name: "Wedding Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var saveTheDateCardEnvelopes = {
    sku: "SDCENV",
    name: "Save the Date Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var saveTheDateMagnetdEnvelopes = {
    sku: "SDMENV",
    name: "Save the Date Magnet Envelopes",
    href: "",
    parentSku: "ENVE"
};
var saveTheDatePetitedEnvelopes = {
    sku: "SDTENV",
    name: "Save the Date Petite Envelopes",
    href: "",
    parentSku: "ENVE"
};
var bridalShowerInvitationEnvelopes = {
    sku: "BRIENV",
    name: "Bridal Shower Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var rehearsalDinnerInvitationEnvelopes = {
    sku: "RDIENV",
    name: "Rehearsal Dinner Invitation Envelopes",
    href: "",
    parentSku: "ENVE"
};
var thankYouCardEnvelopes = {
    sku: "TYCENV",
    name: "Thank You Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var changeTheDateCardEnvelopes = {
    sku: "CDCENV",
    name: "Change The Date Card Envelopes",
    href: "",
    parentSku: "ENVE"
};
var envelopes = {
    sku: "ENVE",
    name: "Envelopes",
    seoTags: {
        title: "Wedding Invitation and RSVP Envelopes | The Knot",
        description: "Browse our collection of envelopes to put the perfect finishing touch on your wedding invitations and stationery.",
        abstract: "Browse our collection of envelopes to put the perfect finishing touch on your wedding invitations and stationery.",
        robots: null
    },
    href: envelopesLink,
    subCategories: [
        responseCardEnvelopes,
        weddingInvitationEnvelopes,
        saveTheDateCardEnvelopes,
        saveTheDateMagnetdEnvelopes,
        saveTheDatePetitedEnvelopes,
        bridalShowerInvitationEnvelopes,
        rehearsalDinnerInvitationEnvelopes,
        thankYouCardEnvelopes,
        changeTheDateCardEnvelopes, 
    ]
};
var _obj;
var categoriesSkuToCategoryMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, thankyou.sku, thankyou), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, thankyouPostCards.sku, thankyouPostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, thankyouCards.sku, thankyouCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, allInOneInvitations.sku, allInOneInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, allInOneWeddingInvitations.sku, allInOneWeddingInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ceremonyAndReception.sku, ceremonyAndReception), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, guestBooks.sku, guestBooks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, giftTags.sku, giftTags), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, stickers.sku, stickers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, tableNumbers.sku, tableNumbers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, menus.sku, menus), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, placeCards.sku, placeCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, programs.sku, programs), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, invitations.sku, invitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, weddingInvitations.sku, weddingInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, rsvpCards.sku, rsvpCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, enclosureCards.sku, enclosureCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, envelopeLiners.sku, envelopeLiners), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, bridalShowerInvitations.sku, bridalShowerInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, rehearsalDinnerInvitations.sku, rehearsalDinnerInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, changeTheDates.sku, changeTheDates), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, changeTheDateCards.sku, changeTheDateCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, changeTheDatePostCards.sku, changeTheDatePostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, saveTheDates.sku, saveTheDates), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, saveTheDateCards.sku, saveTheDateCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, saveTheDatePostCards.sku, saveTheDatePostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, saveTheDatePetiteCards.sku, saveTheDatePetiteCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, savetheDateMagnets.sku, savetheDateMagnets), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, holidayCards.sku, holidayCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, envelopes.sku, envelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, responseCardEnvelopes.sku, responseCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, weddingInvitationEnvelopes.sku, weddingInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, saveTheDateCardEnvelopes.sku, saveTheDateCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, bridalShowerInvitationEnvelopes.sku, bridalShowerInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, rehearsalDinnerInvitationEnvelopes.sku, rehearsalDinnerInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, thankYouCardEnvelopes.sku, thankYouCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, changeTheDateCardEnvelopes.sku, changeTheDateCardEnvelopes), _obj);
var getInvitationCategoriesIds = function() {
    var ref;
    var ids = invitations.subCategories ? (ref = invitations.subCategories) === null || ref === void 0 ? void 0 : ref.map(function(subcategory) {
        return subcategory.sku;
    }) : [];
    ids.push(invitations.sku);
    return ids;
};
var getReprintCategoryIds = function() {
    var invitationIds = getInvitationCategoriesIds();
    var allowedIds = [
        changeTheDateCards.sku,
        changeTheDatePostCards.sku,
        enclosureCards.sku,
        giftTags.sku,
        guestBooks.sku,
        menus.sku,
        placeCards.sku,
        programs.sku,
        rehearsalDinnerInvitations.sku,
        rsvpCards.sku,
        saveTheDateCards.sku,
        holidayCards.sku,
        saveTheDatePostCards.sku,
        savetheDateMagnets.sku,
        saveTheDatePetiteCards.sku,
        stickers.sku,
        tableNumbers.sku,
        weddingInvitations.sku, 
    ];
    return _to_consumable_array(invitationIds).concat(_to_consumable_array(allowedIds));
};
var _obj1;
var categoriesHrefToCategoryMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, thankyou.href, thankyou), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, thankyouPostCards.href, thankyouPostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, thankyouCards.href, thankyouCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, allInOneInvitations.href, allInOneInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, allInOneWeddingInvitations.href, allInOneWeddingInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, ceremonyAndReception.href, ceremonyAndReception), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, guestBooks.href, guestBooks), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, giftTags.href, giftTags), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, stickers.href, stickers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, tableNumbers.href, tableNumbers), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, menus.href, menus), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, placeCards.href, placeCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, programs.href, programs), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, invitations.href, invitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, weddingInvitations.href, weddingInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, rsvpCards.href, rsvpCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, enclosureCards.href, enclosureCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, envelopeLiners.href, envelopeLiners), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, bridalShowerInvitations.href, bridalShowerInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, rehearsalDinnerInvitations.href, rehearsalDinnerInvitations), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, changeTheDates.href, changeTheDates), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, changeTheDateCards.href, changeTheDateCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, changeTheDatePostCards.href, changeTheDatePostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDates.href, saveTheDates), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDateCards.href, saveTheDateCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDateCards.alternateHref, saveTheDateCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDatePostCards.href, saveTheDatePostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDatePostCards.alternateHref, saveTheDatePostCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDatePetiteCards.href, saveTheDatePetiteCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, savetheDateMagnets.href, savetheDateMagnets), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, savetheDateMagnets.alternateHref, savetheDateMagnets), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, holidayCards.href, holidayCards), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, envelopes.href, envelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, responseCardEnvelopes.href, responseCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, weddingInvitationEnvelopes.href, weddingInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, saveTheDateCardEnvelopes.href, saveTheDateCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, bridalShowerInvitationEnvelopes.href, bridalShowerInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, rehearsalDinnerInvitationEnvelopes.href, rehearsalDinnerInvitationEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, thankYouCardEnvelopes.href, thankYouCardEnvelopes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, changeTheDateCardEnvelopes.href, changeTheDateCardEnvelopes), _obj1);


/***/ }),

/***/ 47459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ getAmount; },
/* harmony export */   "NP": function() { return /* binding */ translateDiscount; },
/* harmony export */   "Xq": function() { return /* binding */ getBadge; },
/* harmony export */   "j3": function() { return /* binding */ toCurrency; },
/* harmony export */   "mE": function() { return /* binding */ getNewTier; },
/* harmony export */   "ux": function() { return /* binding */ getSavings; },
/* harmony export */   "yE": function() { return /* binding */ translatePrice; }
/* harmony export */ });
/* unused harmony exports getDiscount, translateQuantity */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
// eslint-disable-next-line import/no-restricted-paths


function toCurrency(price) {
    return "$".concat(price.toFixed(2));
}
function calculatePercentageDiscount(price, discount) {
    if (discount > 100 || discount < 0) {
        throw new Error("Discount must be between 0 and 100");
    }
    var discountAmount = price * (discount / 100);
    return price - discountAmount;
}
function getDiscount(promotion, price) {
    switch(promotion.type){
        case "percentage":
        default:
            return calculatePercentageDiscount(price, promotion.amount);
    }
}
function getAmount(promotion) {
    switch(promotion.type){
        case "percentage":
        default:
            return "$".concat(promotion.amount);
    }
}
function getSavings(promotion, oldPrice) {
    return oldPrice - getDiscount(promotion, oldPrice);
}
function getNewTier(promotion, price) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, price), {
        totalAmount: getDiscount(promotion, price.totalAmount),
        unitAmount: getDiscount(promotion, price.unitAmount)
    });
}
function translateDiscount(promotion) {
    switch(promotion.type){
        case "percentage":
        default:
            return "-".concat(promotion.amount, "%");
    }
}
function getBadge(promotion) {
    return {
        name: translateDiscount(promotion),
        background: "var(--varPrimary300)",
        textColor: "var(--varNeutralWhite)"
    };
}
function translatePrice(price) {
    return "".concat(toCurrency(price || 0), " ea.");
}
/**
 * Translate quantity to a string i.e. (100qty)
 * @param quantity
 * @returns
 */ function translateQuantity(quantity) {
    return "(".concat(quantity, "qty)");
}


/***/ }),

/***/ 61314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PromotionsProvider; },
/* harmony export */   "E": function() { return /* binding */ usePromotion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var _promotions_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47459);



var Context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)([]);
function PromotionsProvider(param) {
    var promotions = param.promotions, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, {
        value: promotions,
        children: children
    });
}
function usePromotion(param) {
    var oldTier = param.price;
    var promotions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Context);
    var now = new Date().getTime();
    /**
   * currently, we just need to find the first active promotion
   */ var current = promotions.find(function(promotion) {
        var startDate = new Date(promotion.startDate);
        var endDate = new Date(promotion.endDate);
        console.log(now >= startDate.getTime() && now <= endDate.getTime());
        return now >= startDate.getTime() && now <= endDate.getTime();
    }) || null;
    var newTier = current ? (0,_promotions_utils__WEBPACK_IMPORTED_MODULE_2__/* .getNewTier */ .mE)(current, oldTier) : null;
    var savings = current ? (0,_promotions_utils__WEBPACK_IMPORTED_MODULE_2__/* .getSavings */ .ux)(current, oldTier.totalAmount) : 0;
    var amount = current ? (0,_promotions_utils__WEBPACK_IMPORTED_MODULE_2__/* .getAmount */ .Bg)(current) : "";
    return {
        promotion: current,
        oldTier: oldTier,
        newTier: newTier,
        savings: savings,
        amount: amount
    };
}


/***/ }),

/***/ 70014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_l": function() { return /* binding */ storefrontAPIGraphqlRequest; },
/* harmony export */   "s3": function() { return /* binding */ storefrontAPIFetch; },
/* harmony export */   "zQ": function() { return /* binding */ storefrontAPIFetchIgnoreErrors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72730);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96645);
/* harmony import */ var next_dist_server_api_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62490);
/* provided dependency */ var process = __webpack_require__(37082);




var buildHeaders = function() {
    var headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getClientHeaders */ .h3)();
    var requestHeaders = new Headers();
    requestHeaders.set("Content-Type", "application/json");
    requestHeaders.set("x-api-version", "v2");
    requestHeaders.set("x-tenant", "tk" || 0);
    if (headers) {
        if (headers.Cookie) requestHeaders.set("Cookie", headers.Cookie);
        if (headers.cookie) requestHeaders.set("cookie", headers.cookie);
        if (headers.token) requestHeaders.set("token", headers.token);
        if (headers["x-tenant"]) requestHeaders.set("x-tenant", headers["x-tenant"]);
        if (headers["user-agent"]) requestHeaders.set("user-agent", headers["user-agent"]);
        if (headers["User-Agent"]) requestHeaders.set("User-Agent", headers["User-Agent"]);
    }
    return requestHeaders;
};
var storefrontAPIGraphqlRequest = function(query, variables, headers) {
    var _INTERNAL_STOREFRONT_API_URL;
    var serverUrl = (_INTERNAL_STOREFRONT_API_URL = process.env.INTERNAL_STOREFRONT_API_URL) !== null && _INTERNAL_STOREFRONT_API_URL !== void 0 ? _INTERNAL_STOREFRONT_API_URL : "https://storefront-api.paper.theknot.com/graphql" || 0;
    return fetch(serverUrl, {
        method: "POST",
        credentials: "include",
        headers: buildHeaders(headers),
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
};
function storefrontAPIFetchIgnoreErrors(query, variables, headers) {
    return _storefrontAPIFetchIgnoreErrors.apply(this, arguments);
}
function _storefrontAPIFetchIgnoreErrors() {
    _storefrontAPIFetchIgnoreErrors = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(query, variables, headers) {
        var response, responseBody;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        storefrontAPIGraphqlRequest(query, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseBody = _state.sent();
                    if (responseBody.data) {
                        return [
                            2,
                            responseBody.data
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _storefrontAPIFetchIgnoreErrors.apply(this, arguments);
}
function storefrontAPIFetch(query, variables, headers) {
    return _storefrontAPIFetch.apply(this, arguments);
}
function _storefrontAPIFetch() {
    _storefrontAPIFetch = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(query, variables, headers) {
        var response, responseBody, ref, ref1, ref2, messages, firstErrorStatusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        storefrontAPIGraphqlRequest(query, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    responseBody = _state.sent();
                    if (responseBody.errors) {
                        ;
                        messages = responseBody.errors.map(function(error) {
                            return error.message;
                        }).join("\n");
                        firstErrorStatusCode = responseBody === null || responseBody === void 0 ? void 0 : (ref = responseBody.errors) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.extensions) === null || ref2 === void 0 ? void 0 : ref2.status;
                        throw new next_dist_server_api_utils__WEBPACK_IMPORTED_MODULE_0__/* .ApiError */ .MS(firstErrorStatusCode, messages);
                    }
                    return [
                        2,
                        responseBody.data
                    ];
            }
        });
    });
    return _storefrontAPIFetch.apply(this, arguments);
}


/***/ }),

/***/ 31074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cartViewed": function() { return /* binding */ cartViewed; },
/* harmony export */   "checkoutStarted": function() { return /* binding */ checkoutStarted; },
/* harmony export */   "checkoutStepCompleted": function() { return /* binding */ checkoutStepCompleted; },
/* harmony export */   "couponApplied": function() { return /* binding */ couponApplied; },
/* harmony export */   "couponDenied": function() { return /* binding */ couponDenied; },
/* harmony export */   "couponEntered": function() { return /* binding */ couponEntered; },
/* harmony export */   "couponRemoved": function() { return /* binding */ couponRemoved; },
/* harmony export */   "ctaClicked": function() { return /* binding */ ctaClicked; },
/* harmony export */   "customizationInitialized": function() { return /* binding */ customizationInitialized; },
/* harmony export */   "customizationItemAdded": function() { return /* binding */ customizationItemAdded; },
/* harmony export */   "customizationItemChanged": function() { return /* binding */ customizationItemChanged; },
/* harmony export */   "customizationItemRemoved": function() { return /* binding */ customizationItemRemoved; },
/* harmony export */   "customizationReviewInitialized": function() { return /* binding */ customizationReviewInitialized; },
/* harmony export */   "defaultValidationErrorHandler": function() { return /* binding */ defaultValidationErrorHandler; },
/* harmony export */   "draftCreated": function() { return /* binding */ draftCreated; },
/* harmony export */   "draftDeleted": function() { return /* binding */ draftDeleted; },
/* harmony export */   "draftListViewed": function() { return /* binding */ draftListViewed; },
/* harmony export */   "draftUpdated": function() { return /* binding */ draftUpdated; },
/* harmony export */   "experimentStarted": function() { return /* binding */ experimentStarted; },
/* harmony export */   "experimentStarted1": function() { return /* binding */ experimentStarted1; },
/* harmony export */   "footerInteraction": function() { return /* binding */ footerInteraction; },
/* harmony export */   "informationEntered": function() { return /* binding */ informationEntered; },
/* harmony export */   "itemFavorited": function() { return /* binding */ itemFavorited; },
/* harmony export */   "itemUnfavorited": function() { return /* binding */ itemUnfavorited; },
/* harmony export */   "logIn": function() { return /* binding */ logIn; },
/* harmony export */   "logInFormDisplayed": function() { return /* binding */ logInFormDisplayed; },
/* harmony export */   "menuInteraction": function() { return /* binding */ menuInteraction; },
/* harmony export */   "newRegistration": function() { return /* binding */ newRegistration; },
/* harmony export */   "orderCompleted": function() { return /* binding */ orderCompleted; },
/* harmony export */   "pageViewed": function() { return /* binding */ pageViewed; },
/* harmony export */   "productAdded": function() { return /* binding */ productAdded; },
/* harmony export */   "productClicked": function() { return /* binding */ productClicked; },
/* harmony export */   "productConfigured": function() { return /* binding */ productConfigured; },
/* harmony export */   "productListFiltered": function() { return /* binding */ productListFiltered; },
/* harmony export */   "productListViewed": function() { return /* binding */ productListViewed; },
/* harmony export */   "productMoved": function() { return /* binding */ productMoved; },
/* harmony export */   "productQuicklooked": function() { return /* binding */ productQuicklooked; },
/* harmony export */   "productRemoved": function() { return /* binding */ productRemoved; },
/* harmony export */   "productViewed": function() { return /* binding */ productViewed; },
/* harmony export */   "productsSearched": function() { return /* binding */ productsSearched; },
/* harmony export */   "promotionClicked": function() { return /* binding */ promotionClicked; },
/* harmony export */   "promotionViewed": function() { return /* binding */ promotionViewed; },
/* harmony export */   "registrationFormDisplayed": function() { return /* binding */ registrationFormDisplayed; },
/* harmony export */   "searchInitialized": function() { return /* binding */ searchInitialized; },
/* harmony export */   "serversideExperimentStarted": function() { return /* binding */ serversideExperimentStarted; },
/* harmony export */   "serversideExperimentStarted1": function() { return /* binding */ serversideExperimentStarted1; },
/* harmony export */   "setTypewriterOptions": function() { return /* binding */ setTypewriterOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/**
 * This client was automatically generated by Segment Typewriter. ** Do Not Edit **
 */ 

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */ var defaultValidationErrorHandler = function(message, violations) {
    var msg = JSON.stringify({
        type: "Typewriter JSON Schema Validation Error",
        description: "You made an analytics call (".concat(message.event, ") using Typewriter that doesn't match the ") + "Tracking Plan spec.",
        errors: violations
    }, undefined, 2);
    console.warn(msg);
};
var analytics = function() {
    return window.analytics;
};
/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */ function setTypewriterOptions(options) {
    analytics = options.analytics ? function() {
        return options.analytics || window.analytics;
    } : analytics;
}
/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */ function withTypewriterContext() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, message), {
        context: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, message.context || {}), {
            typewriter: {
                language: "typescript",
                version: "7.4.1"
            }
        })
    });
}
/**
 * @typedef ExperimentStarted
 * @property {string} Experiment name - the name of the variant into which the user was bucketed, for that experiment

 * @property {string} Trigger path - 
 * @property {string} Variant name - the name of the experiment to which the user has been exposed

 */ /**
 * @typedef ExperimentStarted1
 * @property {string} Experiment name - the name of the variant into which the user was bucketed, for that experiment

 * @property {string} Trigger path - 
 * @property {string} Variant name - the name of the experiment to which the user has been exposed

 */ /**
 * @typedef CtaClicked
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [category] - 
 * @property {string} [element_clicked] - 
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} [location] - 
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] - 
 * @property {string} [product_id] - Database ID of the product

 * @property {string} [reason] - 
 */ /**
 * @typedef SampleDetailsItem
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} foil_color - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Which printing option did the customer specify?

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductsItem
 * @property {string} category - Product Category displayed in the list

 * @property {string} [coupon] - Coupon code associated with the product

 * @property {string} image_url - Image url of the product in the list

 * @property {string} name - Product Name displayed in the list

 * @property {number} position - Position of product in the list

 * @property {number} price - Product Price displayed in the list

 * @property {string} product_id - Product ID displayed in the list

 * @property {number} quantity - Product quantity displayed in the list

 * @property {SampleDetailsItem[]} sample_details - 
 * @property {string} sku - Sku of the product being viewed

 * @property {string} url - URL of the product page

 * @property {VariantItem[]} variant - Variant of the product

 */ /**
 * @typedef CartViewed
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed
 * @property {string} [coupon] - Coupon code associated with the product
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {ProductsItem[]} products - Products displayed in the product list
 * @property {string} value - Total value of the product after quantity

 */ /**
 * @typedef SampleDetailsItem1
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem1
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} foil_color - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"
 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductsItem1
 * @property {string} category - Product Category displayed in the list

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} image_url - Image url of the product in the list

 * @property {string} name - Product Name displayed in the list

 * @property {string} notes - 
 * @property {number} position - Position of product in the list

 * @property {number} price - Product Price displayed in the list

 * @property {string} product_id - Product ID displayed in the list

 * @property {number} quantity - Product quantity displayed in the list

 * @property {SampleDetailsItem1[]} sample_details - 
 * @property {string} sku - Product SKU displayed in the list

 * @property {string} url - URL of the product page for product in the list

 * @property {VariantItem1[]} variant - Product Variant displayed in the list

 */ /**
 * @typedef CheckoutStarted
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed

 * @property {string} [coupon] - Coupon code associated with the product

 * @property {string} currency - Currency code associated with the transaction

 * @property {number} [discount] - Total discount associated with the transaction

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} order_id - Order/transaction ID

 * @property {string} [platform] - Device captured from user interaction
 * @property {ProductsItem1[]} products - Products displayed in the product list

 * @property {number} revenue - Revenue ($) associated with the transaction

 * @property {string} value - Total value of the product after quantity

 */ /**
 * @typedef CheckoutStepCompleted
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * @typedef CouponApplied
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} coupon_name - Name of the coupon

 * @property {number} discount - Total discount associated with the transaction

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * @typedef CouponDenied
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} [coupon_name] - Name of the coupon

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} reason - Reason the coupon was denied

 */ /**
 * @typedef CouponEntered
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} coupon_name - Name of the coupon

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * @typedef CouponRemoved
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - Cart ID associated with the product displayed

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} coupon_name - Name of the coupon

 * @property {number} discount - Total discount associated with the transaction

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * @typedef SampleDetailsItem2
 * @property {boolean} is_sample -
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem2
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef CustomizationInitialized
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - Product category being viewed

 * @property {string} [editor_version] - Notes the Design Editor Version we are on for Customer Canvas

 * @property {string} [file_type] - Format of the customizer file being initialized
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} [price] - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem2[]} sample_details - Indicates whether the product selected is a sample (true/false)

 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized

 * @property {string} url - URL of the product page for product

 * @property {VariantItem2[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem3
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem3
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef CustomizationItemAdded
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} image_url - Image url of the product in the list

 * @property {string} item_type - This property reflects the type of item added in the design editor. There are 4 types of items that can be added: Text, Images, Shapes and QRCodes. To populate the property, you can be extract this straight from the CustomerCanvas event itself. Potential Values are "PlainTextItem", "BoundedTextItem", "ImageItem", "LineItem","RectangleItem", "EllipseItem", "BarcodeItem"
 * @property {string} [list_id] - Product list being viewed
 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} position - Position of product in the list

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {SampleDetailsItem3[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem3[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem4
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem4
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef CustomizationItemChanged
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} change_type - This property is an array of strings and reflects the customization that a user applies to an existing element within the design.
 * @property {number} count_of_changes - 
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} item_type - This property reflects the type of item added in the design editor. There are 4 types of items that can be added: Text, Images, Shapes and QRCodes. To populate the property, you can be extract this straight from the CustomerCanvas event itself. Potential Values are "PlainTextItem", "BoundedTextItem", "ImageItem", "LineItem","RectangleItem", "EllipseItem", "BarcodeItem"
 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} position - Position of product in the list

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem4[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem4[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem5
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem5
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef CustomizationItemRemoved
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} image_url - Image url of the product in the list

 * @property {string} item_type - This property reflects the type of item added in the design editor. There are 4 types of items that can be added: Text, Images, Shapes and QRCodes. To populate the property, you can be extract this straight from the CustomerCanvas event itself. Potential Values are "PlainTextItem", "BoundedTextItem", "ImageItem", "LineItem","RectangleItem", "EllipseItem", "BarcodeItem"
 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem5[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem5[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem6
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem6
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef CustomizationReviewInitialized
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem6[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized

 * @property {string} url - URL of the product page for product

 * @property {VariantItem6[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem7
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem7
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef DraftCreated
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} draft_id - The identifier for a customer's saved draft
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} price - Price of the product

 * @property {string} [product] - 
 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem7[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized

 * @property {string} url - URL of the product page for product

 * @property {VariantItem7[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem8
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem8
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef DraftDeleted
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} draft_id - The identifier for a customer's saved draft
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem8[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized

 * @property {string} url - URL of the product page for product

 * @property {VariantItem8[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem9
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem9
 * @property {string} color - The color of the product
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.
 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc
 * @property {string} material - Materials of the product
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"
 */ /**
 * @typedef DraftsItem
 * @property {string} image_url - Image url of the product in the list
 * @property {string} name - Product Name displayed in the list
 * @property {number} position - Position of product in the list
 * @property {number} [price] - Product Price displayed in the list
 * @property {string} product_id - Database ID of the product/Product ID displayed in the list
 * @property {number} [quantity] - Product quantity displayed in the list
 * @property {SampleDetailsItem9[]} sample_details -
 * @property {string} sku - Product SKU displayed in the list
 * @property {string} [trim_shape] - Trim shape of the product
 * @property {string} url - URL of the product page for product in the list
 * @property {VariantItem9[]} variant - Product Variant displayed in the list
 */ /**
 * @typedef DraftListViewed
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [category] - Category of the page
 * @property {DraftsItem[]} drafts -
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} list_id - Product list being viewed
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * @typedef SampleDetailsItem10
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem10
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef DraftUpdated
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.

 * @property {string} draft_id - The identifier for a customer's saved draft
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} location - Specifies the relevant section where the CTA interaction occurred, excluding page type

 * @property {string} name - Product Name displayed in the list

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product

 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem10[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized

 * @property {string} url - URL of the product page for product

 * @property {VariantItem10[]} variant - Variant of the product

 */ /**
 * @typedef FooterInteraction
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] - TK product: paper
 * @property {string} [selection] - Footer Element selection
 */ /**
 * @typedef InformationEntered
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - cart ID associated with the product displayed
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} information_type -
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} shipping_method - String representing the shipping method chosen
 */ /**
 * @typedef VariantItem11
 * @property {string} color - The color of the product
 * @property {string} [flap_type] - Indicates the style of envelope flap selected. Primarily used for envelope products to capture preferences in flap type.
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.
 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc
 * @property {string} material - Materials of the product
 * @property {string} [paper_color] - Indicates the color of the paper selected.
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"
 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ItemFavorited
 * @property {string} affiliation - Specifies the brand source - either WW or TK - within Paper, distinguishing the origin for each individual event.
 * @property {string} category - Category of the page
 * @property {string} image_url - The full URL for the product image that is being displayed for the product
 * @property {string} list_id - Identifier for the list of products being viewed/interacted with; see the List IDs tab. If the product is being viewed outside a particular list, pass null for the list_id.
 * @property {string} name - Name of product (Forever Wedding Invitations by Vera Wang)
 * @property {number} position - Position in the product list
 * @property {number} [price] - Unit Price of the product in dollars
 * @property {string} [product_id] - Database ID of the product/Product ID displayed in the list
 * @property {number} [quantity] - Quantity (i.e. number of units) of a product selected by the user
 * @property {string} [sku] - Product SKU displayed in the list
 * @property {string} [url] - URL of the product page without any query parameters
 * @property {VariantItem11[]} variant - Product Variant displayed in the list. Describes the attributes of the sku.
 */ /**
 * @typedef VariantItem12
 * @property {string} color - The color of the product
 * @property {string} [flap_type] - Indicates the style of envelope flap selected. Primarily used for envelope products to capture preferences in flap type.
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.
 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc
 * @property {string} material - Materials of the product
 * @property {string} [paper_color] - Indicates the color of the paper selected.
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"
 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ItemUnfavorited
 * @property {string} affiliation - Specifies the brand source - either WW or TK - within Paper, distinguishing the origin for each individual event.
 * @property {string} category - Category of the page
 * @property {string} image_url - The full URL for the product image that is being displayed for the product
 * @property {string} list_id - Identifier for the list of products being viewed/interacted with; see the List IDs tab. If the product is being viewed outside a particular list, pass null for the list_id.
 * @property {string} [name] - Name of product (Forever Wedding Invitations by Vera Wang)
 * @property {number} position - Position in the product list
 * @property {number} [price] - Unit Price of the product in dollars
 * @property {string} [product_id] - Database ID of the product/Product ID displayed in the list
 * @property {number} [quantity] - Quantity (i.e. number of units) of a product selected by the user
 * @property {string} [sku] - Product SKU displayed in the list
 * @property {string} [url] - URL of the product page without any query parameters
 * @property {VariantItem12[]} variant - Product Variant displayed in the list. Describes the attributes of the sku.
 */ /**
 * @typedef LogIn
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] -
 * @property {string} [reason] -
 * @property {string} [selection] -
 */ /**
 * @typedef LogInFormDisplayed
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [flowType] - Type of flow: proactive
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] - TK product: paper
 * @property {string} [reason] - Reason and location
 * @property {string} [selection] -
 */ /**
 * @typedef MenuInteraction
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [categoryName] - Menu Element selection
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] - TK product: paper
 * @property {string} [selection] -
 * @property {string} [source] -
 */ /**
 * @typedef NewRegistration
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] -
 * @property {string} [reason] -
 * @property {string} [selection] -
 */ /**
 * @typedef SampleDetailsItem11
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem13
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} foil_color - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Which printing option did the customer specify?

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductsItem2
 * @property {string} category - Product Category displayed in the list

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} image_url - Image url of the product in the list

 * @property {string} name - Product Name displayed in the list

 * @property {number} position - Position of product in the list

 * @property {number} price - Product Price displayed in the list

 * @property {string} product_id - Product ID displayed in the list

 * @property {number} quantity - Product quantity displayed in the list

 * @property {SampleDetailsItem11[]} sample_details - 
 * @property {string} sku - Sku of the product being viewed

 * @property {string} url - URL of the product page

 * @property {VariantItem13[]} variant - Variant of the product

 */ /**
 * @typedef OrderCompleted
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [coupon] - Coupon code associated with the product
 * @property {string} [currency] - Currency code associated with the transaction
 * @property {number} [discount] - Total discount associated with the transaction
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} order_id - Order/transaction ID
 * @property {string} [platform] - Device captured from user interaction
 * @property {ProductsItem2[]} products - Products displayed in the product list
 * @property {number} revenue - Revenue ($) associated with the transaction
 * @property {number} shipping - Shipping cost associated with the transaction
 * @property {number} subtotal - Order total after discounts but before taxes and shipping
 * @property {number} tax - Total tax associated with the transaction
 * @property {number} total - Revenue with discounts and coupons added
 */ /**
 * @typedef PageViewed
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [path] -
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [referrer] -
 * @property {string} [resolution] -
 * @property {string} [search] -
 * @property {string} title - Page title
 * @property {string} url - URL of the product page for product in the list
 */ /**
 * @typedef SampleDetailsItem12
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem14
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductAdded
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - cart ID associated with the product displayed
 * @property {string} category - Product category being viewed

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} image_url - Image url of the product
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {SampleDetailsItem12[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem14[]} variant - Variant of the product

 */ /**
 * @typedef VariantItem15
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductClicked
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - Product category being viewed

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} image_url - Image url of the product
 * @property {string} list_id - Product list being viewed
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem15[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem13
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem16
 * @property {string} color - The color of the product
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.
 * @property {string} [format] - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc
 * @property {string} [material] - Materials of the product
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"
 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductConfigured
 * @property {string} [affiliation] - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [cart_id] - cart ID associated with the product displayed
 * @property {string} [category] - Product category being viewed

 * @property {string} [draft_id] - The identifier for a customer's saved draft
 * @property {string} [editor_version] - Notes the Design Editor Version we are on for Customer Canvas
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} [has_design_notes] - Whether a product customization has a design note. If yes, it does. if no, it doesn't 
 * @property {string} [image_url] - Image url of the product
 * @property {string} [name] - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [portfolio_item_id] - Identifier of a customer's created customized product
 * @property {number} [position] - Position of product in the list
 * @property {number} [price] - Price of the product

 * @property {string} [product_id] - Database ID of the product

 * @property {number} [quantity] - Quantity of the product

 * @property {SampleDetailsItem13[]} [sample_details] - 
 * @property {string} [sku] - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized 
 * @property {string} [url] - URL of the product page for product

 * @property {VariantItem16[]} [variant] - Variant of the product

 */ /**
 * @typedef FiltersItem
 * @property {string} click - Specifies the type of clicked element within the filtering system, distinguishing between badge and facet.
 * @property {string} [type] - Id of the filter type that the customer is using
 * @property {string} [value] - Id of the selection that the customer chose
 */ /**
 * @typedef VariantItem17
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} foil_color - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Which printing option did the customer specify?

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductsItem3
 * @property {string} category - Product Category displayed in the list

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} image_url - Image url of the product in the list

 * @property {string} name - Product Name displayed in the list

 * @property {number} position - Position of product in the list

 * @property {number} price - Product Price displayed in the list

 * @property {string} product_id - Product ID displayed in the list

 * @property {number} quantity - Product quantity displayed in the list

 * @property {string} sku - Sku of the product being viewed

 * @property {string} url - URL of the product page

 * @property {VariantItem17[]} variant - Variant of the product

 */ /**
 * @typedef SelectedFilter
 * @property {string} click - Specifies the type of clicked element within the filtering system, distinguishing between badge and facet.
 * @property {string} [flag] - ID of the filter type that the customer is using
 * @property {string} [type] - ID of the filter type that the customer is using
 * @property {string} [value] - ID of the selection that the customer chose
 */ /**
 * @typedef SortsItem
 * @property {string} type - ID of the sort type being used
 * @property {string} [value] - ID of the selection type being used
 */ /**
 * @typedef ProductListFiltered
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [category] - The category of the page, added to the properties object.
 * @property {FiltersItem[]} [filters] - Product filters that the customer is using
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} list_id - Product list being viewed
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {ProductsItem3[]} products - Products displayed in the product list
 * @property {SelectedFilter} [selected_filter] - The latest filter a customer has applied
 * @property {SortsItem[]} [sorts] - Product sorting the customer is using
 */ /**
 * @typedef SampleDetailsItem14
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem18
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} foil_color - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Which printing option did the customer specify?

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductsItem4
 * @property {string} category - Product Category displayed in the list

 * @property {string} coupon - Coupon code associated with the product

 * @property {string} image_url - Image url of the product in the list

 * @property {string} name - Product Name displayed in the list

 * @property {number} position - Position of product in the list

 * @property {number} price - Product Price displayed in the list

 * @property {string} product_id - Product ID displayed in the list

 * @property {number} quantity - Product quantity displayed in the list

 * @property {SampleDetailsItem14[]} sample_details - 
 * @property {string} sku - Sku of the product being viewed

 * @property {string} url - URL of the product page

 * @property {VariantItem18[]} variant - Variant of the product

 */ /**
 * @typedef ProductListViewed
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [category] - The category of the page, added to the properties object.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} list_id - Product list being viewed
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {ProductsItem4[]} products - Products displayed in the product list
 */ /**
 * @typedef SampleDetailsItem15
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)
 * @property {boolean} [personalized] -
 */ /**
 * @typedef VariantItem19
 * @property {string} color - The color of the product

 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductMoved
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - cart ID associated with the product displayed
 * @property {string} category - Product category being viewed

 * @property {string} checkout_id - Shopping cart ID - this is a replicate of the cart_id field
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} has_design_notes - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} image_url - Image url of the product
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} portfolio_item_id - Identifier of a customer's created customized product
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {SampleDetailsItem15[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} [surface] - Name of the paper surface that it's being customized 
 * @property {string} url - URL of the product page for product

 * @property {VariantItem19[]} variant - Variant of the product

 */ /**
 * @typedef VariantItem20
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductQuicklooked
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - Product category being viewed

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} image_url - Image url of the product
 * @property {string} list_id - Product list being viewed
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem20[]} variant - Variant of the product

 */ /**
 * @typedef SampleDetailsItem16
 * @property {boolean} is_sample - Indicates whether the product selected is a sample (true/false)

 * @property {boolean} [personalized] - 
 */ /**
 * @typedef VariantItem21
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductRemoved
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} cart_id - cart ID associated with the product displayed
 * @property {string} category - Product category being viewed

 * @property {string} [coupon] - Coupon code associated with the product
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} has_design_notes - Whether a product customization has a design note. If yes, it does. if no, it doesn't

 * @property {string} image_url - Image url of the product
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {SampleDetailsItem16[]} sample_details - 
 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem21[]} variant - Variant of the product

 */ /**
 * @typedef VariantItem22
 * @property {string} color - The color of the product

 * @property {string} [flap_type] - 
 * @property {string} [foil_color] - Foil Color: Tracks chosen foil options - rose, gold, silver.

 * @property {string} format - Layout and/or material of the product, such as petite card, standard, magnet, all-in-one, etc

 * @property {string} material - Materials of the product

 * @property {string} [paper_color] - 
 * @property {string} [printing_options] - Printing options for an all-in-one or envelopes (if applicable) - "PLN", "BTH", "REC", "RET"

 * @property {string} [trim_shape] - Trim shape of the product
 */ /**
 * @typedef ProductViewed
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - Product category being viewed

 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} image_url - Image url of the product
 * @property {string} name - Name of the product

 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {number} position - Position of product in the list
 * @property {number} price - Price of the product

 * @property {string} product_id - Database ID of the product

 * @property {number} quantity - Quantity of the product

 * @property {string} sku - Sku of the product

 * @property {string} url - URL of the product page for product

 * @property {VariantItem22[]} variant - Variant of the product

 */ /**
 * @typedef ProductsSearched
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} query - Query the user searched with
 */ /**
 * @typedef PromotionClicked
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} creative - User clicked on promotion
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} name - Product Name displayed in the list
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} position - Position of the promotion
 * @property {string} promotion_id - ID of the promotion
 */ /**
 * @typedef PromotionViewed
 * @property {string} affiliation - Store or affiliation from which this transaction occurred

 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} creative - User clicked on promotion
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {string} name - Product Name displayed in the list
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} position - Position of the promotion
 * @property {string} promotion_id - ID of the promotion
 */ /**
 * @typedef RegistrationFormDisplayed
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} [flowType] - Type of flow: proactive
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 * @property {string} [product] - TK product: paper
 * @property {string} [reason] - Reason and location
 * @property {string} [selection] -
 * @property {number} [stepCount] - Step
 * @property {number} [stepNumber] - Step
 */ /**
 * @typedef SearchInitialized
 * @property {string} affiliation - Store or affiliation from which this transaction occurred
 * @property {string} [build_product] - Defines the Product (not ecommerce) that the user was experiencing when the event was triggered.
 * @property {string} category - The category of the page, added to the properties object.
 * @property {string} [ga4_client_id] - Google Analytics client ID pull from the GA cookie. Contains a GA specific user id alongside a timestamp.
 * @property {string} [ga4_session_id] - Google Analytics identifier for the user session. Relevant for session level data in GA4.
 * @property {number} [ga4_session_number] - Number representing whether the active user session is the 1st, 2nd, 3rd, etc successive session associated with the current user.
 * @property {boolean} [non_interaction] - Flag indicating whether this event is interactive or non-interactive. Interactive events are general triggered by explicit user action. Non-interactive events are generally triggered regardless of the user's cursor sitting idle on the application.
 * @property {string} [platform] - Device captured from user interaction
 */ /**
 * Mixpanel experiment
 *
 * @param {ExperimentStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function experimentStarted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("$Experiment Started", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Mixpanel experiment
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function serversideExperimentStarted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("$Serverside Experiment Started", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Mixpanel experiment
 *
 * @param {ExperimentStarted1} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function experimentStarted1(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("$experiment_started", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Mixpanel experiment
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function serversideExperimentStarted1(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("$serverside_experiment_started", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'CTA Clicked' track call.
 *
 * @param {CtaClicked} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function ctaClicked(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("CTA Clicked", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Cart Viewed' track call.
 *
 * @param {CartViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function cartViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Cart Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Checkout Started' track call.
 *
 * @param {CheckoutStarted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function checkoutStarted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Checkout Started", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Checkout Step Completed' track call.
 *
 * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function checkoutStepCompleted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Checkout Step Completed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Coupon was applied on a user’s shopping cart or order

 *
 * @param {CouponApplied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function couponApplied(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Coupon Applied", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Coupon was denied from a user’s shopping cart or order

 *
 * @param {CouponDenied} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function couponDenied(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Coupon Denied", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User entered a coupon on a shopping cart or order

 *
 * @param {CouponEntered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function couponEntered(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Coupon Entered", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User removed a coupon from a cart or order

 *
 * @param {CouponRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function couponRemoved(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Coupon Removed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User started a customization

 *
 * @param {CustomizationInitialized} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function customizationInitialized(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Customization Initialized", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
 *
 * @param {CustomizationItemAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function customizationItemAdded(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Customization Item Added", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
 *
 * @param {CustomizationItemChanged} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function customizationItemChanged(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Customization Item Changed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
 *
 * @param {CustomizationItemRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function customizationItemRemoved(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Customization Item Removed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User saved and completed the current customization
 *
 * @param {CustomizationReviewInitialized} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function customizationReviewInitialized(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Customization Review Initialized", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Draft Created' track call.
 *
 * @param {DraftCreated} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function draftCreated(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Draft Created", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Draft Deleted' track call.
 *
 * @param {DraftDeleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function draftDeleted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Draft Deleted", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Draft List Viewed' track call.
 *
 * @param {DraftListViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function draftListViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Draft List Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Draft Updated' track call.
 *
 * @param {DraftUpdated} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function draftUpdated(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Draft Updated", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Footer Interaction' track call.
 *
 * @param {FooterInteraction} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function footerInteraction(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Footer Interaction", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Information Entered' track call.
 *
 * @param {InformationEntered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function informationEntered(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Information Entered", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fire this event when a visitor favorites a product
 *
 * @param {ItemFavorited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function itemFavorited(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Item Favorited", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fire this event when a visitor unfavorites a variation
 *
 * @param {ItemUnfavorited} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function itemUnfavorited(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Item Unfavorited", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Log In' track call.
 *
 * @param {LogIn} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function logIn(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Log In", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Log In Form Displayed' track call.
 *
 * @param {LogInFormDisplayed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function logInFormDisplayed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Log In Form Displayed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Menu Interaction' track call.
 *
 * @param {MenuInteraction} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function menuInteraction(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Menu Interaction", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'New Registration' track call.
 *
 * @param {NewRegistration} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function newRegistration(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("New Registration", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Order Completed' track call.
 *
 * @param {OrderCompleted} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function orderCompleted(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Order Completed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Page Viewed' track call.
 *
 * @param {PageViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function pageViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Page Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User added a product to their cart
 *
 * @param {ProductAdded} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productAdded(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Added", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User clicked through to a product page
 *
 * @param {ProductClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productClicked(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Clicked", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User updated configuration of product on product detail page
 *
 * @param {ProductConfigured} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productConfigured(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Configured", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User filtered a product list or category
 *
 * @param {ProductListFiltered} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productListFiltered(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product List Filtered", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User filtered a product list or category
 *
 * @param {ProductListViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productListViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product List Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Product is moved from Cart to Drafts
 *
 * @param {ProductMoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productMoved(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Moved", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User clicked a product
 *
 * @param {ProductQuicklooked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productQuicklooked(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Quicklooked", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Product is removed from Cart by clicking "Remove" link located in the Cart
 *
 * @param {ProductRemoved} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productRemoved(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Removed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User views a product
 *
 * @param {ProductViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Product Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User searched for products
 *
 * @param {ProductsSearched} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function productsSearched(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Products Searched", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User clicked on promotion (banner) or a corresponding CTA
 *
 * @param {PromotionClicked} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function promotionClicked(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Promotion Clicked", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * User viewed promotion
 *
 * @param {PromotionViewed} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function promotionViewed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Promotion Viewed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Registration Form Displayed' track call.
 *
 * @param {RegistrationFormDisplayed} [props] - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function registrationFormDisplayed(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Registration Form Displayed", props || {}, withTypewriterContext(options), callback);
    }
}
/**
 * Fires a 'Search Initialized' track call.
 *
 * @param {SearchInitialized} props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */ function searchInitialized(props, options, callback) {
    var a = analytics();
    if (a) {
        a.track("Search Initialized", props || {}, withTypewriterContext(options), callback);
    }
}
var clientAPI = {
    /**
	 * Updates the run-time configuration of this Typewriter client.
	 *
	 * @param {TypewriterOptions} options - the options to upsert
	 *
	 * @typedef {Object} TypewriterOptions
	 * @property {Segment.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
	 * 		calls are forwarded on to. Defaults to window.analytics.
	 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
	 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
	 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
	 * 		will be logged to stderr.
	 */ setTypewriterOptions: setTypewriterOptions,
    /**
	 * Mixpanel experiment
	 *
	 * @param {ExperimentStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ experimentStarted: experimentStarted,
    /**
	 * Mixpanel experiment
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ serversideExperimentStarted: serversideExperimentStarted,
    /**
	 * Mixpanel experiment
	 *
	 * @param {ExperimentStarted1} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ experimentStarted1: experimentStarted1,
    /**
	 * Mixpanel experiment
	 *
	 * @param {Record<string, any>} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ serversideExperimentStarted1: serversideExperimentStarted1,
    /**
	 * Fires a 'CTA Clicked' track call.
	 *
	 * @param {CtaClicked} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ ctaClicked: ctaClicked,
    /**
	 * Fires a 'Cart Viewed' track call.
	 *
	 * @param {CartViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ cartViewed: cartViewed,
    /**
	 * Fires a 'Checkout Started' track call.
	 *
	 * @param {CheckoutStarted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ checkoutStarted: checkoutStarted,
    /**
	 * Fires a 'Checkout Step Completed' track call.
	 *
	 * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ checkoutStepCompleted: checkoutStepCompleted,
    /**
	 * Coupon was applied on a user’s shopping cart or order
	
	 *
	 * @param {CouponApplied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ couponApplied: couponApplied,
    /**
	 * Coupon was denied from a user’s shopping cart or order
	
	 *
	 * @param {CouponDenied} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ couponDenied: couponDenied,
    /**
	 * User entered a coupon on a shopping cart or order
	
	 *
	 * @param {CouponEntered} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ couponEntered: couponEntered,
    /**
	 * User removed a coupon from a cart or order
	
	 *
	 * @param {CouponRemoved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ couponRemoved: couponRemoved,
    /**
	 * User started a customization
	
	 *
	 * @param {CustomizationInitialized} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ customizationInitialized: customizationInitialized,
    /**
	 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
	 *
	 * @param {CustomizationItemAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ customizationItemAdded: customizationItemAdded,
    /**
	 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
	 *
	 * @param {CustomizationItemChanged} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ customizationItemChanged: customizationItemChanged,
    /**
	 * Tracks the action of items (image, text, shape or QR Code) is removed within the design editor. It maps to the event fired by Customer Canvas Platform
	 *
	 * @param {CustomizationItemRemoved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ customizationItemRemoved: customizationItemRemoved,
    /**
	 * User saved and completed the current customization
	 *
	 * @param {CustomizationReviewInitialized} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ customizationReviewInitialized: customizationReviewInitialized,
    /**
	 * Fires a 'Draft Created' track call.
	 *
	 * @param {DraftCreated} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ draftCreated: draftCreated,
    /**
	 * Fires a 'Draft Deleted' track call.
	 *
	 * @param {DraftDeleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ draftDeleted: draftDeleted,
    /**
	 * Fires a 'Draft List Viewed' track call.
	 *
	 * @param {DraftListViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ draftListViewed: draftListViewed,
    /**
	 * Fires a 'Draft Updated' track call.
	 *
	 * @param {DraftUpdated} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ draftUpdated: draftUpdated,
    /**
	 * Fires a 'Footer Interaction' track call.
	 *
	 * @param {FooterInteraction} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ footerInteraction: footerInteraction,
    /**
	 * Fires a 'Information Entered' track call.
	 *
	 * @param {InformationEntered} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ informationEntered: informationEntered,
    /**
	 * Fire this event when a visitor favorites a product
	 *
	 * @param {ItemFavorited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ itemFavorited: itemFavorited,
    /**
	 * Fire this event when a visitor unfavorites a variation
	 *
	 * @param {ItemUnfavorited} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ itemUnfavorited: itemUnfavorited,
    /**
	 * Fires a 'Log In' track call.
	 *
	 * @param {LogIn} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ logIn: logIn,
    /**
	 * Fires a 'Log In Form Displayed' track call.
	 *
	 * @param {LogInFormDisplayed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ logInFormDisplayed: logInFormDisplayed,
    /**
	 * Fires a 'Menu Interaction' track call.
	 *
	 * @param {MenuInteraction} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ menuInteraction: menuInteraction,
    /**
	 * Fires a 'New Registration' track call.
	 *
	 * @param {NewRegistration} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ newRegistration: newRegistration,
    /**
	 * Fires a 'Order Completed' track call.
	 *
	 * @param {OrderCompleted} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ orderCompleted: orderCompleted,
    /**
	 * Fires a 'Page Viewed' track call.
	 *
	 * @param {PageViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ pageViewed: pageViewed,
    /**
	 * User added a product to their cart
	 *
	 * @param {ProductAdded} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productAdded: productAdded,
    /**
	 * User clicked through to a product page
	 *
	 * @param {ProductClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productClicked: productClicked,
    /**
	 * User updated configuration of product on product detail page
	 *
	 * @param {ProductConfigured} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productConfigured: productConfigured,
    /**
	 * User filtered a product list or category
	 *
	 * @param {ProductListFiltered} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productListFiltered: productListFiltered,
    /**
	 * User filtered a product list or category
	 *
	 * @param {ProductListViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productListViewed: productListViewed,
    /**
	 * Product is moved from Cart to Drafts
	 *
	 * @param {ProductMoved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productMoved: productMoved,
    /**
	 * User clicked a product
	 *
	 * @param {ProductQuicklooked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productQuicklooked: productQuicklooked,
    /**
	 * Product is removed from Cart by clicking "Remove" link located in the Cart
	 *
	 * @param {ProductRemoved} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productRemoved: productRemoved,
    /**
	 * User views a product
	 *
	 * @param {ProductViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productViewed: productViewed,
    /**
	 * User searched for products
	 *
	 * @param {ProductsSearched} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ productsSearched: productsSearched,
    /**
	 * User clicked on promotion (banner) or a corresponding CTA
	 *
	 * @param {PromotionClicked} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ promotionClicked: promotionClicked,
    /**
	 * User viewed promotion
	 *
	 * @param {PromotionViewed} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ promotionViewed: promotionViewed,
    /**
	 * Fires a 'Registration Form Displayed' track call.
	 *
	 * @param {RegistrationFormDisplayed} [props] - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ registrationFormDisplayed: registrationFormDisplayed,
    /**
	 * Fires a 'Search Initialized' track call.
	 *
	 * @param {SearchInitialized} props - The analytics properties that will be sent to Segment.
	 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
	 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
	 * 		call is fired.
	 */ searchInitialized: searchInitialized
};
/* harmony default export */ __webpack_exports__["default"] = (new Proxy(clientAPI, {
    get: function get(target, method) {
        if (typeof method === "string" && target.hasOwnProperty(method)) {
            return target[method];
        }
        return function() {
            console.warn("⚠️  You made an analytics call (".concat(String(method), ") that can't be found. Either:\n    a) Re-generate your typewriter client: `npx typewriter`\n    b) Add it to your Tracking Plan: https://app.segment.com/xogrp/protocols/tracking-plans/rs_2l3dxlvAHBSOEvgABQ6e9jk9aov"));
            var a = analytics();
            if (a) {
                a.track("Unknown Analytics Call Fired", {
                    method: method
                }, withTypewriterContext());
            }
        };
    }
}));


/***/ }),

/***/ 44353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ pricingFilterPosition; },
/* harmony export */   "Gt": function() { return /* binding */ filtering; },
/* harmony export */   "Yq": function() { return /* binding */ reviewPrice; },
/* harmony export */   "dM": function() { return /* binding */ fullStoryExisting; },
/* harmony export */   "fo": function() { return /* binding */ pdpDesktopCarouselV2; },
/* harmony export */   "hJ": function() { return /* binding */ fullStoryNew; },
/* harmony export */   "pn": function() { return /* binding */ REVIEW_PRICE_EXPERIMENT_ID; }
/* harmony export */ });
/* unused harmony exports APP_FILTERING_EXPERIMENT_ID, APP_FILTERING_CONTROL_ID, APP_FILTERING_VARIANT_ID, APP_PDP_DESKTOP_CAROUSEL_V2_EXPERIMENT_ID, APP_PDP_DESKTOP_CAROUSEL_V2_CONTROL_ID, APP_PDP_DESKTOP_CAROUSEL_V2_VARIANT_ID, REVIEW_PRICE_CONTROL_ID, REVIEW_PRICE_VARIANT_ID, APP_PRICING_FILTER_POSITION_EXPERIMENT_ID, APP_PRICING_FILTER_POSITION_CONTROL_ID, APP_PRICING_FILTER_POSITION_VARIANT_ID */
/**
 * This Experiments does...
 * RECORDED =
 * NOT RECORDED =
 */ var fullStoryExisting = {
    name: "Full Story Existing",
    routes: /\[...slug\]/i,
    id: String("d1939eab-7ae6-4134-9bdd-7c2e7f748465"),
    names: {
        control: String("8ed74d23-e69d-4bf7-b9d4-d9c23d0849d9"),
        variant1: String("e14bced1-8500-4930-b9ed-c21df8c6e0a6")
    },
    identifier: "member",
    tenant: "tk",
    firstTrigger: true
};
/**
 * This Experiments does...
 * RECORDED =
 * NOT RECORDED =
 */ var fullStoryNew = {
    name: "Full Story New",
    routes: /\[...slug\]/i,
    id: String("bcc2f67d-86ba-4017-b3ac-5217e3160cc3"),
    names: {
        control: String("97a8457b-9cf6-4685-8560-8d9d9173d78f"),
        variant1: String("a38ac374-cc7e-44ba-bae8-8ea267a7148e")
    },
    identifier: "member",
    tenant: "tk",
    firstTrigger: true
};
var APP_FILTERING_EXPERIMENT_ID = String("02ebd05e-5062-416a-b668-6d110e8491ee");
var APP_FILTERING_CONTROL_ID = String("e1aa00ee-58d5-4ed4-9aad-69390b0a3185");
var APP_FILTERING_VARIANT_ID = String("9facc989-20fa-4ee0-8717-35614634357b");
var filtering = {
    name: "Results count and 0 results prevention",
    routes: /\[...slug\]/i,
    id: APP_FILTERING_EXPERIMENT_ID,
    names: {
        control: APP_FILTERING_CONTROL_ID,
        variant1: APP_FILTERING_VARIANT_ID
    },
    identifier: "both",
    tenant: "tk",
    firstTrigger: true
};
var APP_PDP_DESKTOP_CAROUSEL_V2_EXPERIMENT_ID = String("b6521077-34c0-4331-a764-5fa5d35bec9c");
var APP_PDP_DESKTOP_CAROUSEL_V2_CONTROL_ID = String("d3939862-d26f-47c5-8015-8820d6adf94a");
var APP_PDP_DESKTOP_CAROUSEL_V2_VARIANT_ID = String("11d911c0-2a01-4bdd-9f97-9be82c5728ef");
var pdpDesktopCarouselV2 = {
    name: "PDP Carousel Image Gallery Iteration 2",
    routes: /product/i,
    id: APP_PDP_DESKTOP_CAROUSEL_V2_EXPERIMENT_ID,
    names: {
        control: APP_PDP_DESKTOP_CAROUSEL_V2_CONTROL_ID,
        variant1: APP_PDP_DESKTOP_CAROUSEL_V2_VARIANT_ID
    },
    identifier: "guest",
    tenant: "tk",
    firstTrigger: true
};
var REVIEW_PRICE_EXPERIMENT_ID = String("18e1b31b-85cc-4345-8c56-bac41cf65e8c");
var REVIEW_PRICE_CONTROL_ID = String("abf09400-233f-453e-89f8-86c05836ce77");
var REVIEW_PRICE_VARIANT_ID = String("8b334a73-dec5-46ce-b567-9dc1524c5db5");
var reviewPrice = {
    name: "Review Price",
    routes: /review/i,
    id: REVIEW_PRICE_EXPERIMENT_ID,
    names: {
        control: REVIEW_PRICE_CONTROL_ID,
        variant1: REVIEW_PRICE_VARIANT_ID
    },
    identifier: "guest",
    tenant: "tk",
    firstTrigger: true
};
var APP_PRICING_FILTER_POSITION_EXPERIMENT_ID = String("101154de-1906-422a-ad7e-3c38604a1269");
var APP_PRICING_FILTER_POSITION_CONTROL_ID = String("295c35f9-92bf-4848-8e23-5652ac17617c");
var APP_PRICING_FILTER_POSITION_VARIANT_ID = String("27af7b25-fdd5-4db1-ae9d-ca4b05e0f091");
var pricingFilterPosition = {
    name: "Change Pricing Filter Position",
    routes: /\[...slug\]/i,
    id: APP_PRICING_FILTER_POSITION_EXPERIMENT_ID,
    names: {
        control: APP_PRICING_FILTER_POSITION_CONTROL_ID,
        variant1: APP_PRICING_FILTER_POSITION_VARIANT_ID
    },
    identifier: "guest",
    tenant: "tk",
    firstTrigger: true
};


/***/ }),

/***/ 6807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ FlipperProvider; },
/* harmony export */   "c": function() { return /* binding */ FlipperContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var _flipper_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71714);
/* harmony import */ var _utils_analytics_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74504);




var FlipperContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    experiments: _flipper_service__WEBPACK_IMPORTED_MODULE_2__/* .ExperimentService.experiments */ .$.experiments(),
    variants: {}
});
var FlipperProvider = function(param) {
    var children = param.children, _variants = param.variants, variants = _variants === void 0 ? {} : _variants;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        Object.values(variants).filter(function(variant) {
            return variant.firstTrigger;
        }).forEach(function(param) {
            var extraData = param.extraData;
            if (extraData) {
                (0,_utils_analytics_helpers__WEBPACK_IMPORTED_MODULE_3__/* .trackExperimentStarted */ .Qt)({
                    "Experiment name": extraData.experimentName || "",
                    "Variant name": extraData.variantName || "",
                    "Trigger path": extraData.triggerPath || ""
                });
            }
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FlipperContext.Provider, {
        value: {
            experiments: _flipper_service__WEBPACK_IMPORTED_MODULE_2__/* .ExperimentService.experiments */ .$.experiments(),
            variants: variants
        },
        children: children
    });
};


/***/ }),

/***/ 71714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ ExperimentService; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./node_modules/@honeybadger-io/js/dist/browser/honeybadger.js
var honeybadger = __webpack_require__(5417);
var honeybadger_default = /*#__PURE__*/__webpack_require__.n(honeybadger);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(58105);
// EXTERNAL MODULE: ./node_modules/lodash.camelcase/index.js
var lodash_camelcase = __webpack_require__(83245);
var lodash_camelcase_default = /*#__PURE__*/__webpack_require__.n(lodash_camelcase);
;// CONCATENATED MODULE: ./lib/flipper/flipper.client.ts
/* provided dependency */ var process = __webpack_require__(37082);







var API_KEY = String(process.env.EXPERIMENTATION_API_KEY);
var EXPERIMENT_API_URL = String("https://api.experimentation.xogrp.com");
var isJson = function(contentType) {
    return contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json");
};
function getFromAPI(route) {
    return _getFromAPI.apply(this, arguments);
}
function _getFromAPI() {
    _getFromAPI = (0,_async_to_generator/* default */.Z)(function(route) {
        var res, body;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat(EXPERIMENT_API_URL, "/").concat(route), {
                            headers: {
                                "x-api-key": API_KEY,
                                "Accept-Version": "v1"
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        throw new Error("Error occurred while fetching Flipper data: ".concat(res.statusText));
                    }
                    if (!isJson(res.headers.get("content-type"))) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    body = _state.sent();
                    return [
                        2,
                        Object.entries(body).reduce(function(acc, param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, lodash_camelcase_default()(k), v));
                        }, {})
                    ];
            }
        });
    });
    return _getFromAPI.apply(this, arguments);
}

// EXTERNAL MODULE: ./utils/config/config.constants.ts
var config_constants = __webpack_require__(76806);
// EXTERNAL MODULE: ./lib/flipper/Flipper.constants.ts
var Flipper_constants = __webpack_require__(44353);
;// CONCATENATED MODULE: ./lib/flipper/flipper.service.ts














var GUEST_COOKIE = "ajs_anonymous_id";
var MEMBER_COOKIE = "ajs_user_id";
var FLIPPER_COOKIE = "flipperExperiments";
var COOKIE_DOMAIN = String("");
var COOKIE_PATH = String("/paper");
var EXPERIMENTS = [
    Flipper_constants/* fullStoryExisting */.dM,
    Flipper_constants/* fullStoryNew */.hJ,
    Flipper_constants/* filtering */.Gt,
    Flipper_constants/* pdpDesktopCarouselV2 */.fo,
    Flipper_constants/* reviewPrice */.Yq,
    Flipper_constants/* pricingFilterPosition */.$w
];
var experimentService;
var ExperimentService = /*#__PURE__*/ function() {
    "use strict";
    function ExperimentService() {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, ExperimentService);
        this.headers = undefined;
        this.route = "";
        this.realPath = "";
        this.skipExperiments = new Set();
        this.variants = new Map();
        this.variantsCookie = "";
        this.anonymousIdCookie = "";
        this.isInSkipList = function(experiment) {
            return !_this.skipExperiments.has(experiment.id);
        };
        this.filterByRoute = function(experiment) {
            return experiment.routes.test(_this.route);
        };
        this.filterByIdentifier = function(experiment) {
            return !!_this.getBucketingId(experiment.identifier);
        };
        this.filterByTenant = function(experiment) {
            return experiment.tenant === "both" || (0,config_constants/* isTenant */.J)(experiment.tenant);
        };
    }
    var _proto = ExperimentService.prototype;
    _proto.getBucketingId = function getBucketingId(identifier) {
        var cookie = this.cookies[GUEST_COOKIE];
        switch(identifier){
            case "guest":
                var ref;
                cookie = this.cookies[GUEST_COOKIE] || ((ref = this.headers) === null || ref === void 0 ? void 0 : ref["x-anon-id"]);
                break;
            case "member":
                cookie = this.cookies[MEMBER_COOKIE];
                break;
        }
        return (cookie || "").replace(/%22|"/g, "");
    };
    /**
   * Variants
   */ /**
   * Generates a Map from all experiments already set in Cookies
   * @returns
   */ _proto.generateVariants = function generateVariants() {
        var _this = this;
        this.variants.clear();
        if (!this.cookies[FLIPPER_COOKIE]) return;
        var flipperCookie = JSON.parse(this.cookies[FLIPPER_COOKIE]);
        //workaround for PAPER-14135 - preserve in cookie others experiments - delete when fixed
        //if (!this.isFlipperCookieValid(flipperCookie)) return
        Object.entries(flipperCookie).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
            if (_this.skipExperiments.has(k)) return;
            _this.variants.set(k, v);
        });
    };
    _proto.generateVariant = function generateVariant(experiment, variant) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var identifier, experimentId, bucketingId, variantURL, variantInformation, experimentInformation, variantId, variantName, experimentName, firstTrigger, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        identifier = experiment.identifier, experimentId = experiment.id;
                        bucketingId = _this.getBucketingId(identifier);
                        if (!bucketingId || !experimentId) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        variantURL = "experiments/".concat(experimentId, "/").concat(bucketingId);
                        if (!variant) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            getFromAPI("assignments/".concat(experimentId, "/").concat(bucketingId)).catch(function() {
                                variantURL = variantURL + "?variantId=".concat(variant.variantId);
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            getFromAPI(variantURL)
                        ];
                    case 4:
                        variantInformation = _state.sent();
                        return [
                            4,
                            getFromAPI("experiments/".concat(experimentId))
                        ];
                    case 5:
                        experimentInformation = _state.sent();
                        if (!variantInformation || !experimentInformation) {
                            return [
                                2
                            ];
                        }
                        variantId = (variantInformation === null || variantInformation === void 0 ? void 0 : variantInformation.variantId) || "default";
                        variantName = (variantInformation === null || variantInformation === void 0 ? void 0 : variantInformation.variantName) || "default";
                        experimentName = experimentInformation === null || experimentInformation === void 0 ? void 0 : experimentInformation.experimentName;
                        firstTrigger = !variant;
                        return [
                            2,
                            [
                                experimentId,
                                {
                                    variantId: variantId,
                                    bucketingId: bucketingId,
                                    firstTrigger: firstTrigger,
                                    extraData: {
                                        experimentId: experimentId,
                                        variantName: variantName,
                                        experimentName: experimentName
                                    }
                                }
                            ]
                        ];
                    case 6:
                        error = _state.sent();
                        honeybadger_default().notify("FlipperService::generateVariant", {
                            context: {
                                name: experiment.name,
                                experimentId: experimentId,
                                bucketingId: bucketingId,
                                error: error
                            }
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.addCookies = function addCookies(name, value, path) {
        var cookieValue = Array.from(value).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), k = _param[0], v = _param[1];
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, k, {
                bucketingId: v.bucketingId,
                variantId: v.variantId
            }));
        }, {});
        return cookie.serialize(name, JSON.stringify(cookieValue), {
            secure: false,
            httpOnly: false,
            ignoreErrors: true,
            domain: COOKIE_DOMAIN,
            path: path || COOKIE_PATH,
            maxAge: 60 * 60 * 24 * 365,
            sameSite: "Lax",
            encoding: "none"
        });
    };
    _proto.shouldAssign = function shouldAssign(experiment, variant) {
        return this.getBucketingId(experiment.identifier) !== variant.bucketingId;
    };
    _proto.setExperiments = function setExperiments() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, experiment, variant, newExperiment, _variants, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.generateVariants();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        _iterator = _this.activeExperiments[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            6
                        ];
                        experiment = _step.value;
                        variant = _this.variants.get(experiment.id);
                        if (!(!variant || _this.shouldAssign(experiment, variant))) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _this.generateVariant(experiment, variant)
                        ];
                    case 3:
                        newExperiment = _state.sent();
                        if (newExperiment) {
                            ;
                            (_variants = _this.variants).set.apply(_variants, (0,_to_consumable_array/* default */.Z)(newExperiment));
                        } else {
                            _this.variants.delete(experiment.id);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        _this.variants.set(experiment.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                            firstTrigger: false
                        }));
                        _state.label = 5;
                    case 5:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
   * Allows to skip experiment based on runtime conditions
   * Useful for 3rd party integrations with Flipper
   * @param ids : string[] List of experiments id that should be skipped
   */ _proto.addToSkipList = function addToSkipList(ids) {
        var _this = this;
        ids.filter(Boolean).forEach(function(id) {
            return _this.skipExperiments.add(id);
        });
    };
    _proto.initialize = function initialize(headers, route, realPath) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _this.headers = headers;
                        _this.route = route;
                        _this.realPath = realPath;
                        if (!_this.activeExperiments.length || _this.isUserAgentBot || _this.isPrefetch || _this.isAsset) return [
                            2
                        ];
                        return [
                            4,
                            _this.setExperiments()
                        ];
                    case 1:
                        _state.sent();
                        if (!_this.variants.size) return [
                            2
                        ];
                        _this.variantsCookie = _this.addCookies(FLIPPER_COOKIE, _this.variants);
                        return [
                            2,
                            Object.fromEntries(_this.variants)
                        ];
                    case 2:
                        e = _state.sent();
                        console.log(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    ExperimentService.experiments = function experiments() {
        return EXPERIMENTS;
    };
    ExperimentService.cookies = function cookies() {
        if (true) {
            var cookies1 = cookie.parse(document.cookie);
            return cookies1[FLIPPER_COOKIE] ? JSON.parse(cookies1[FLIPPER_COOKIE]) : {};
        }
        return {};
    };
    ExperimentService.forRoot = function forRoot(opts) {
        var experiments = opts.experiments, cookieDomain = opts.cookieDomain, cookiePath = opts.cookiePath, guestCookie = opts.guestCookie, memberCookie = opts.memberCookie, flipperCookie = opts.flipperCookie;
        EXPERIMENTS = experiments || EXPERIMENTS;
        GUEST_COOKIE = guestCookie || GUEST_COOKIE;
        MEMBER_COOKIE = memberCookie || MEMBER_COOKIE;
        FLIPPER_COOKIE = flipperCookie || FLIPPER_COOKIE;
        COOKIE_DOMAIN = cookieDomain || COOKIE_DOMAIN;
        COOKIE_PATH = cookiePath || COOKIE_PATH;
        experimentService = new ExperimentService();
        experimentService.variantsCookie = "";
        return experimentService;
    };
    _createClass(ExperimentService, [
        {
            key: "cookies",
            get: function get() {
                var ref;
                if (!this.headers) return;
                return cookie.parse(((ref = this.headers) === null || ref === void 0 ? void 0 : ref["cookie"]) || "") || {};
            }
        },
        {
            key: "isMobileUserAgent",
            get: function get() {
                var ref, ref1;
                return ((ref = this.headers) === null || ref === void 0 ? void 0 : (ref1 = ref["user-agent"]) === null || ref1 === void 0 ? void 0 : ref1.includes("Mobile")) || false;
            }
        },
        {
            key: "isUserAgentBot",
            get: function get() {
                var _this = this;
                var BOT_USER_AGENT_PATTERNS = [
                    /googlebot/i,
                    /bing/i,
                    /bot/i,
                    /slurp/i,
                    /baidu/i,
                    /duckduck/i,
                    /spider/i,
                    /preview/i,
                    /QATT/i, 
                ];
                return BOT_USER_AGENT_PATTERNS.some(function(re) {
                    var ref;
                    return re.test(((ref = _this.headers) === null || ref === void 0 ? void 0 : ref["user-agent"]) || "");
                });
            }
        },
        {
            key: "isPrefetch",
            get: function get() {
                var ref, ref1, ref2;
                var ref3;
                return (ref3 = ((ref = this.headers) === null || ref === void 0 ? void 0 : ref["purpose"]) === "prefetch" || ((ref1 = this.headers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1["purpose"]) === null || ref2 === void 0 ? void 0 : ref2.includes("prefetch"))) !== null && ref3 !== void 0 ? ref3 : false;
            }
        },
        {
            key: "isAsset",
            get: function get() {
                var ref;
                var ref1;
                return (ref1 = (ref = this.realPath) === null || ref === void 0 ? void 0 : ref.includes("_next/")) !== null && ref1 !== void 0 ? ref1 : false;
            }
        },
        {
            key: "experiments",
            get: function get() {
                return EXPERIMENTS;
            }
        },
        {
            key: "activeExperiments",
            get: function get() {
                var _this = this;
                return this.experiments.filter(function(experiment) {
                    return _this.isInSkipList(experiment) && _this.filterByRoute(experiment) && _this.filterByIdentifier(experiment) && _this.filterByTenant(experiment);
                });
            }
        }
    ]);
    return ExperimentService;
}();


/***/ }),

/***/ 49755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_lru; }
});

;// CONCATENATED MODULE: ./node_modules/lru-cache/dist/esm/index.js
/* provided dependency */ var process = __webpack_require__(37082);
/**
 * @module LRUCache
 */
const perf = typeof performance === 'object' &&
    performance &&
    typeof performance.now === 'function'
    ? performance
    : Date;
const warned = new Set();
/* c8 ignore start */
const PROCESS = (typeof process === 'object' && !!process ? process : {});
/* c8 ignore start */
const emitWarning = (msg, type, code, fn) => {
    typeof PROCESS.emitWarning === 'function'
        ? PROCESS.emitWarning(msg, type, code, fn)
        : console.error(`[${code}] ${type}: ${msg}`);
};
let AC = globalThis.AbortController;
let AS = globalThis.AbortSignal;
/* c8 ignore start */
if (typeof AC === 'undefined') {
    //@ts-ignore
    AS = class AbortSignal {
        onabort;
        _onabort = [];
        reason;
        aborted = false;
        addEventListener(_, fn) {
            this._onabort.push(fn);
        }
    };
    //@ts-ignore
    AC = class AbortController {
        constructor() {
            warnACPolyfill();
        }
        signal = new AS();
        abort(reason) {
            if (this.signal.aborted)
                return;
            //@ts-ignore
            this.signal.reason = reason;
            //@ts-ignore
            this.signal.aborted = true;
            //@ts-ignore
            for (const fn of this.signal._onabort) {
                fn(reason);
            }
            this.signal.onabort?.(reason);
        }
    };
    let printACPolyfillWarning = PROCESS.env?.LRU_CACHE_IGNORE_AC_WARNING !== '1';
    const warnACPolyfill = () => {
        if (!printACPolyfillWarning)
            return;
        printACPolyfillWarning = false;
        emitWarning('AbortController is not defined. If using lru-cache in ' +
            'node 14, load an AbortController polyfill from the ' +
            '`node-abort-controller` package. A minimal polyfill is ' +
            'provided for use by LRUCache.fetch(), but it should not be ' +
            'relied upon in other contexts (eg, passing it to other APIs that ' +
            'use AbortController/AbortSignal might have undesirable effects). ' +
            'You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.', 'NO_ABORT_CONTROLLER', 'ENOTSUP', warnACPolyfill);
    };
}
/* c8 ignore stop */
const shouldWarn = (code) => !warned.has(code);
const TYPE = Symbol('type');
const isPosInt = (n) => n && n === Math.floor(n) && n > 0 && isFinite(n);
/* c8 ignore start */
// This is a little bit ridiculous, tbh.
// The maximum array length is 2^32-1 or thereabouts on most JS impls.
// And well before that point, you're caching the entire world, I mean,
// that's ~32GB of just integers for the next/prev links, plus whatever
// else to hold that many keys and values.  Just filling the memory with
// zeroes at init time is brutal when you get that big.
// But why not be complete?
// Maybe in the future, these limits will have expanded.
const getUintArray = (max) => !isPosInt(max)
    ? null
    : max <= Math.pow(2, 8)
        ? Uint8Array
        : max <= Math.pow(2, 16)
            ? Uint16Array
            : max <= Math.pow(2, 32)
                ? Uint32Array
                : max <= Number.MAX_SAFE_INTEGER
                    ? ZeroArray
                    : null;
/* c8 ignore stop */
class ZeroArray extends Array {
    constructor(size) {
        super(size);
        this.fill(0);
    }
}
class Stack {
    heap;
    length;
    // private constructor
    static #constructing = false;
    static create(max) {
        const HeapCls = getUintArray(max);
        if (!HeapCls)
            return [];
        Stack.#constructing = true;
        const s = new Stack(max, HeapCls);
        Stack.#constructing = false;
        return s;
    }
    constructor(max, HeapCls) {
        /* c8 ignore start */
        if (!Stack.#constructing) {
            throw new TypeError('instantiate Stack using Stack.create(n)');
        }
        /* c8 ignore stop */
        this.heap = new HeapCls(max);
        this.length = 0;
    }
    push(n) {
        this.heap[this.length++] = n;
    }
    pop() {
        return this.heap[--this.length];
    }
}
/**
 * Default export, the thing you're using this module to get.
 *
 * All properties from the options object (with the exception of
 * {@link OptionsBase.max} and {@link OptionsBase.maxSize}) are added as
 * normal public members. (`max` and `maxBase` are read-only getters.)
 * Changing any of these will alter the defaults for subsequent method calls,
 * but is otherwise safe.
 */
class LRUCache {
    // properties coming in from the options of these, only max and maxSize
    // really *need* to be protected. The rest can be modified, as they just
    // set defaults for various methods.
    #max;
    #maxSize;
    #dispose;
    #disposeAfter;
    #fetchMethod;
    /**
     * {@link LRUCache.OptionsBase.ttl}
     */
    ttl;
    /**
     * {@link LRUCache.OptionsBase.ttlResolution}
     */
    ttlResolution;
    /**
     * {@link LRUCache.OptionsBase.ttlAutopurge}
     */
    ttlAutopurge;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnGet}
     */
    updateAgeOnGet;
    /**
     * {@link LRUCache.OptionsBase.updateAgeOnHas}
     */
    updateAgeOnHas;
    /**
     * {@link LRUCache.OptionsBase.allowStale}
     */
    allowStale;
    /**
     * {@link LRUCache.OptionsBase.noDisposeOnSet}
     */
    noDisposeOnSet;
    /**
     * {@link LRUCache.OptionsBase.noUpdateTTL}
     */
    noUpdateTTL;
    /**
     * {@link LRUCache.OptionsBase.maxEntrySize}
     */
    maxEntrySize;
    /**
     * {@link LRUCache.OptionsBase.sizeCalculation}
     */
    sizeCalculation;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnFetchRejection}
     */
    noDeleteOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.noDeleteOnStaleGet}
     */
    noDeleteOnStaleGet;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchAbort}
     */
    allowStaleOnFetchAbort;
    /**
     * {@link LRUCache.OptionsBase.allowStaleOnFetchRejection}
     */
    allowStaleOnFetchRejection;
    /**
     * {@link LRUCache.OptionsBase.ignoreFetchAbort}
     */
    ignoreFetchAbort;
    // computed properties
    #size;
    #calculatedSize;
    #keyMap;
    #keyList;
    #valList;
    #next;
    #prev;
    #head;
    #tail;
    #free;
    #disposed;
    #sizes;
    #starts;
    #ttls;
    #hasDispose;
    #hasFetchMethod;
    #hasDisposeAfter;
    /**
     * Do not call this method unless you need to inspect the
     * inner workings of the cache.  If anything returned by this
     * object is modified in any way, strange breakage may occur.
     *
     * These fields are private for a reason!
     *
     * @internal
     */
    static unsafeExposeInternals(c) {
        return {
            // properties
            starts: c.#starts,
            ttls: c.#ttls,
            sizes: c.#sizes,
            keyMap: c.#keyMap,
            keyList: c.#keyList,
            valList: c.#valList,
            next: c.#next,
            prev: c.#prev,
            get head() {
                return c.#head;
            },
            get tail() {
                return c.#tail;
            },
            free: c.#free,
            // methods
            isBackgroundFetch: (p) => c.#isBackgroundFetch(p),
            backgroundFetch: (k, index, options, context) => c.#backgroundFetch(k, index, options, context),
            moveToTail: (index) => c.#moveToTail(index),
            indexes: (options) => c.#indexes(options),
            rindexes: (options) => c.#rindexes(options),
            isStale: (index) => c.#isStale(index),
        };
    }
    // Protected read-only members
    /**
     * {@link LRUCache.OptionsBase.max} (read-only)
     */
    get max() {
        return this.#max;
    }
    /**
     * {@link LRUCache.OptionsBase.maxSize} (read-only)
     */
    get maxSize() {
        return this.#maxSize;
    }
    /**
     * The total computed size of items in the cache (read-only)
     */
    get calculatedSize() {
        return this.#calculatedSize;
    }
    /**
     * The number of items stored in the cache (read-only)
     */
    get size() {
        return this.#size;
    }
    /**
     * {@link LRUCache.OptionsBase.fetchMethod} (read-only)
     */
    get fetchMethod() {
        return this.#fetchMethod;
    }
    /**
     * {@link LRUCache.OptionsBase.dispose} (read-only)
     */
    get dispose() {
        return this.#dispose;
    }
    /**
     * {@link LRUCache.OptionsBase.disposeAfter} (read-only)
     */
    get disposeAfter() {
        return this.#disposeAfter;
    }
    constructor(options) {
        const { max = 0, ttl, ttlResolution = 1, ttlAutopurge, updateAgeOnGet, updateAgeOnHas, allowStale, dispose, disposeAfter, noDisposeOnSet, noUpdateTTL, maxSize = 0, maxEntrySize = 0, sizeCalculation, fetchMethod, noDeleteOnFetchRejection, noDeleteOnStaleGet, allowStaleOnFetchRejection, allowStaleOnFetchAbort, ignoreFetchAbort, } = options;
        if (max !== 0 && !isPosInt(max)) {
            throw new TypeError('max option must be a nonnegative integer');
        }
        const UintArray = max ? getUintArray(max) : Array;
        if (!UintArray) {
            throw new Error('invalid max value: ' + max);
        }
        this.#max = max;
        this.#maxSize = maxSize;
        this.maxEntrySize = maxEntrySize || this.#maxSize;
        this.sizeCalculation = sizeCalculation;
        if (this.sizeCalculation) {
            if (!this.#maxSize && !this.maxEntrySize) {
                throw new TypeError('cannot set sizeCalculation without setting maxSize or maxEntrySize');
            }
            if (typeof this.sizeCalculation !== 'function') {
                throw new TypeError('sizeCalculation set to non-function');
            }
        }
        if (fetchMethod !== undefined &&
            typeof fetchMethod !== 'function') {
            throw new TypeError('fetchMethod must be a function if specified');
        }
        this.#fetchMethod = fetchMethod;
        this.#hasFetchMethod = !!fetchMethod;
        this.#keyMap = new Map();
        this.#keyList = new Array(max).fill(undefined);
        this.#valList = new Array(max).fill(undefined);
        this.#next = new UintArray(max);
        this.#prev = new UintArray(max);
        this.#head = 0;
        this.#tail = 0;
        this.#free = Stack.create(max);
        this.#size = 0;
        this.#calculatedSize = 0;
        if (typeof dispose === 'function') {
            this.#dispose = dispose;
        }
        if (typeof disposeAfter === 'function') {
            this.#disposeAfter = disposeAfter;
            this.#disposed = [];
        }
        else {
            this.#disposeAfter = undefined;
            this.#disposed = undefined;
        }
        this.#hasDispose = !!this.#dispose;
        this.#hasDisposeAfter = !!this.#disposeAfter;
        this.noDisposeOnSet = !!noDisposeOnSet;
        this.noUpdateTTL = !!noUpdateTTL;
        this.noDeleteOnFetchRejection = !!noDeleteOnFetchRejection;
        this.allowStaleOnFetchRejection = !!allowStaleOnFetchRejection;
        this.allowStaleOnFetchAbort = !!allowStaleOnFetchAbort;
        this.ignoreFetchAbort = !!ignoreFetchAbort;
        // NB: maxEntrySize is set to maxSize if it's set
        if (this.maxEntrySize !== 0) {
            if (this.#maxSize !== 0) {
                if (!isPosInt(this.#maxSize)) {
                    throw new TypeError('maxSize must be a positive integer if specified');
                }
            }
            if (!isPosInt(this.maxEntrySize)) {
                throw new TypeError('maxEntrySize must be a positive integer if specified');
            }
            this.#initializeSizeTracking();
        }
        this.allowStale = !!allowStale;
        this.noDeleteOnStaleGet = !!noDeleteOnStaleGet;
        this.updateAgeOnGet = !!updateAgeOnGet;
        this.updateAgeOnHas = !!updateAgeOnHas;
        this.ttlResolution =
            isPosInt(ttlResolution) || ttlResolution === 0
                ? ttlResolution
                : 1;
        this.ttlAutopurge = !!ttlAutopurge;
        this.ttl = ttl || 0;
        if (this.ttl) {
            if (!isPosInt(this.ttl)) {
                throw new TypeError('ttl must be a positive integer if specified');
            }
            this.#initializeTTLTracking();
        }
        // do not allow completely unbounded caches
        if (this.#max === 0 && this.ttl === 0 && this.#maxSize === 0) {
            throw new TypeError('At least one of max, maxSize, or ttl is required');
        }
        if (!this.ttlAutopurge && !this.#max && !this.#maxSize) {
            const code = 'LRU_CACHE_UNBOUNDED';
            if (shouldWarn(code)) {
                warned.add(code);
                const msg = 'TTL caching without ttlAutopurge, max, or maxSize can ' +
                    'result in unbounded memory consumption.';
                emitWarning(msg, 'UnboundedCacheWarning', code, LRUCache);
            }
        }
    }
    /**
     * Return the remaining TTL time for a given entry key
     */
    getRemainingTTL(key) {
        return this.#keyMap.has(key) ? Infinity : 0;
    }
    #initializeTTLTracking() {
        const ttls = new ZeroArray(this.#max);
        const starts = new ZeroArray(this.#max);
        this.#ttls = ttls;
        this.#starts = starts;
        this.#setItemTTL = (index, ttl, start = perf.now()) => {
            starts[index] = ttl !== 0 ? start : 0;
            ttls[index] = ttl;
            if (ttl !== 0 && this.ttlAutopurge) {
                const t = setTimeout(() => {
                    if (this.#isStale(index)) {
                        this.delete(this.#keyList[index]);
                    }
                }, ttl + 1);
                // unref() not supported on all platforms
                /* c8 ignore start */
                if (t.unref) {
                    t.unref();
                }
                /* c8 ignore stop */
            }
        };
        this.#updateItemAge = index => {
            starts[index] = ttls[index] !== 0 ? perf.now() : 0;
        };
        this.#statusTTL = (status, index) => {
            if (ttls[index]) {
                const ttl = ttls[index];
                const start = starts[index];
                /* c8 ignore next */
                if (!ttl || !start)
                    return;
                status.ttl = ttl;
                status.start = start;
                status.now = cachedNow || getNow();
                const age = status.now - start;
                status.remainingTTL = ttl - age;
            }
        };
        // debounce calls to perf.now() to 1s so we're not hitting
        // that costly call repeatedly.
        let cachedNow = 0;
        const getNow = () => {
            const n = perf.now();
            if (this.ttlResolution > 0) {
                cachedNow = n;
                const t = setTimeout(() => (cachedNow = 0), this.ttlResolution);
                // not available on all platforms
                /* c8 ignore start */
                if (t.unref) {
                    t.unref();
                }
                /* c8 ignore stop */
            }
            return n;
        };
        this.getRemainingTTL = key => {
            const index = this.#keyMap.get(key);
            if (index === undefined) {
                return 0;
            }
            const ttl = ttls[index];
            const start = starts[index];
            if (!ttl || !start) {
                return Infinity;
            }
            const age = (cachedNow || getNow()) - start;
            return ttl - age;
        };
        this.#isStale = index => {
            const s = starts[index];
            const t = ttls[index];
            return !!t && !!s && (cachedNow || getNow()) - s > t;
        };
    }
    // conditionally set private methods related to TTL
    #updateItemAge = () => { };
    #statusTTL = () => { };
    #setItemTTL = () => { };
    /* c8 ignore stop */
    #isStale = () => false;
    #initializeSizeTracking() {
        const sizes = new ZeroArray(this.#max);
        this.#calculatedSize = 0;
        this.#sizes = sizes;
        this.#removeItemSize = index => {
            this.#calculatedSize -= sizes[index];
            sizes[index] = 0;
        };
        this.#requireSize = (k, v, size, sizeCalculation) => {
            // provisionally accept background fetches.
            // actual value size will be checked when they return.
            if (this.#isBackgroundFetch(v)) {
                return 0;
            }
            if (!isPosInt(size)) {
                if (sizeCalculation) {
                    if (typeof sizeCalculation !== 'function') {
                        throw new TypeError('sizeCalculation must be a function');
                    }
                    size = sizeCalculation(v, k);
                    if (!isPosInt(size)) {
                        throw new TypeError('sizeCalculation return invalid (expect positive integer)');
                    }
                }
                else {
                    throw new TypeError('invalid size value (must be positive integer). ' +
                        'When maxSize or maxEntrySize is used, sizeCalculation ' +
                        'or size must be set.');
                }
            }
            return size;
        };
        this.#addItemSize = (index, size, status) => {
            sizes[index] = size;
            if (this.#maxSize) {
                const maxSize = this.#maxSize - sizes[index];
                while (this.#calculatedSize > maxSize) {
                    this.#evict(true);
                }
            }
            this.#calculatedSize += sizes[index];
            if (status) {
                status.entrySize = size;
                status.totalCalculatedSize = this.#calculatedSize;
            }
        };
    }
    #removeItemSize = _i => { };
    #addItemSize = (_i, _s, _st) => { };
    #requireSize = (_k, _v, size, sizeCalculation) => {
        if (size || sizeCalculation) {
            throw new TypeError('cannot set size without setting maxSize or maxEntrySize on cache');
        }
        return 0;
    };
    *#indexes({ allowStale = this.allowStale } = {}) {
        if (this.#size) {
            for (let i = this.#tail; true;) {
                if (!this.#isValidIndex(i)) {
                    break;
                }
                if (allowStale || !this.#isStale(i)) {
                    yield i;
                }
                if (i === this.#head) {
                    break;
                }
                else {
                    i = this.#prev[i];
                }
            }
        }
    }
    *#rindexes({ allowStale = this.allowStale } = {}) {
        if (this.#size) {
            for (let i = this.#head; true;) {
                if (!this.#isValidIndex(i)) {
                    break;
                }
                if (allowStale || !this.#isStale(i)) {
                    yield i;
                }
                if (i === this.#tail) {
                    break;
                }
                else {
                    i = this.#next[i];
                }
            }
        }
    }
    #isValidIndex(index) {
        return (index !== undefined &&
            this.#keyMap.get(this.#keyList[index]) === index);
    }
    /**
     * Return a generator yielding `[key, value]` pairs,
     * in order from most recently used to least recently used.
     */
    *entries() {
        for (const i of this.#indexes()) {
            if (this.#valList[i] !== undefined &&
                this.#keyList[i] !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield [this.#keyList[i], this.#valList[i]];
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.entries}
     *
     * Return a generator yielding `[key, value]` pairs,
     * in order from least recently used to most recently used.
     */
    *rentries() {
        for (const i of this.#rindexes()) {
            if (this.#valList[i] !== undefined &&
                this.#keyList[i] !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield [this.#keyList[i], this.#valList[i]];
            }
        }
    }
    /**
     * Return a generator yielding the keys in the cache,
     * in order from most recently used to least recently used.
     */
    *keys() {
        for (const i of this.#indexes()) {
            const k = this.#keyList[i];
            if (k !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield k;
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.keys}
     *
     * Return a generator yielding the keys in the cache,
     * in order from least recently used to most recently used.
     */
    *rkeys() {
        for (const i of this.#rindexes()) {
            const k = this.#keyList[i];
            if (k !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield k;
            }
        }
    }
    /**
     * Return a generator yielding the values in the cache,
     * in order from most recently used to least recently used.
     */
    *values() {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            if (v !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield this.#valList[i];
            }
        }
    }
    /**
     * Inverse order version of {@link LRUCache.values}
     *
     * Return a generator yielding the values in the cache,
     * in order from least recently used to most recently used.
     */
    *rvalues() {
        for (const i of this.#rindexes()) {
            const v = this.#valList[i];
            if (v !== undefined &&
                !this.#isBackgroundFetch(this.#valList[i])) {
                yield this.#valList[i];
            }
        }
    }
    /**
     * Iterating over the cache itself yields the same results as
     * {@link LRUCache.entries}
     */
    [Symbol.iterator]() {
        return this.entries();
    }
    /**
     * Find a value for which the supplied fn method returns a truthy value,
     * similar to Array.find().  fn is called as fn(value, key, cache).
     */
    find(fn, getOptions = {}) {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            if (fn(value, this.#keyList[i], this)) {
                return this.get(this.#keyList[i], getOptions);
            }
        }
    }
    /**
     * Call the supplied function on each item in the cache, in order from
     * most recently used to least recently used.  fn is called as
     * fn(value, key, cache).  Does not update age or recenty of use.
     * Does not iterate over stale values.
     */
    forEach(fn, thisp = this) {
        for (const i of this.#indexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * The same as {@link LRUCache.forEach} but items are iterated over in
     * reverse order.  (ie, less recently used items are iterated over first.)
     */
    rforEach(fn, thisp = this) {
        for (const i of this.#rindexes()) {
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined)
                continue;
            fn.call(thisp, value, this.#keyList[i], this);
        }
    }
    /**
     * Delete any stale entries. Returns true if anything was removed,
     * false otherwise.
     */
    purgeStale() {
        let deleted = false;
        for (const i of this.#rindexes({ allowStale: true })) {
            if (this.#isStale(i)) {
                this.delete(this.#keyList[i]);
                deleted = true;
            }
        }
        return deleted;
    }
    /**
     * Return an array of [key, {@link LRUCache.Entry}] tuples which can be
     * passed to cache.load()
     */
    dump() {
        const arr = [];
        for (const i of this.#indexes({ allowStale: true })) {
            const key = this.#keyList[i];
            const v = this.#valList[i];
            const value = this.#isBackgroundFetch(v)
                ? v.__staleWhileFetching
                : v;
            if (value === undefined || key === undefined)
                continue;
            const entry = { value };
            if (this.#ttls && this.#starts) {
                entry.ttl = this.#ttls[i];
                // always dump the start relative to a portable timestamp
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = perf.now() - this.#starts[i];
                entry.start = Math.floor(Date.now() - age);
            }
            if (this.#sizes) {
                entry.size = this.#sizes[i];
            }
            arr.unshift([key, entry]);
        }
        return arr;
    }
    /**
     * Reset the cache and load in the items in entries in the order listed.
     * Note that the shape of the resulting cache may be different if the
     * same options are not used in both caches.
     */
    load(arr) {
        this.clear();
        for (const [key, entry] of arr) {
            if (entry.start) {
                // entry.start is a portable timestamp, but we may be using
                // node's performance.now(), so calculate the offset, so that
                // we get the intended remaining TTL, no matter how long it's
                // been on ice.
                //
                // it's ok for this to be a bit slow, it's a rare operation.
                const age = Date.now() - entry.start;
                entry.start = perf.now() - age;
            }
            this.set(key, entry.value, entry);
        }
    }
    /**
     * Add a value to the cache.
     *
     * Note: if `undefined` is specified as a value, this is an alias for
     * {@link LRUCache#delete}
     */
    set(k, v, setOptions = {}) {
        if (v === undefined) {
            this.delete(k);
            return this;
        }
        const { ttl = this.ttl, start, noDisposeOnSet = this.noDisposeOnSet, sizeCalculation = this.sizeCalculation, status, } = setOptions;
        let { noUpdateTTL = this.noUpdateTTL } = setOptions;
        const size = this.#requireSize(k, v, setOptions.size || 0, sizeCalculation);
        // if the item doesn't fit, don't do anything
        // NB: maxEntrySize set to maxSize by default
        if (this.maxEntrySize && size > this.maxEntrySize) {
            if (status) {
                status.set = 'miss';
                status.maxEntrySizeExceeded = true;
            }
            // have to delete, in case something is there already.
            this.delete(k);
            return this;
        }
        let index = this.#size === 0 ? undefined : this.#keyMap.get(k);
        if (index === undefined) {
            // addition
            index = (this.#size === 0
                ? this.#tail
                : this.#free.length !== 0
                    ? this.#free.pop()
                    : this.#size === this.#max
                        ? this.#evict(false)
                        : this.#size);
            this.#keyList[index] = k;
            this.#valList[index] = v;
            this.#keyMap.set(k, index);
            this.#next[this.#tail] = index;
            this.#prev[index] = this.#tail;
            this.#tail = index;
            this.#size++;
            this.#addItemSize(index, size, status);
            if (status)
                status.set = 'add';
            noUpdateTTL = false;
        }
        else {
            // update
            this.#moveToTail(index);
            const oldVal = this.#valList[index];
            if (v !== oldVal) {
                if (this.#hasFetchMethod && this.#isBackgroundFetch(oldVal)) {
                    oldVal.__abortController.abort(new Error('replaced'));
                    const { __staleWhileFetching: s } = oldVal;
                    if (s !== undefined && !noDisposeOnSet) {
                        if (this.#hasDispose) {
                            this.#dispose?.(s, k, 'set');
                        }
                        if (this.#hasDisposeAfter) {
                            this.#disposed?.push([s, k, 'set']);
                        }
                    }
                }
                else if (!noDisposeOnSet) {
                    if (this.#hasDispose) {
                        this.#dispose?.(oldVal, k, 'set');
                    }
                    if (this.#hasDisposeAfter) {
                        this.#disposed?.push([oldVal, k, 'set']);
                    }
                }
                this.#removeItemSize(index);
                this.#addItemSize(index, size, status);
                this.#valList[index] = v;
                if (status) {
                    status.set = 'replace';
                    const oldValue = oldVal && this.#isBackgroundFetch(oldVal)
                        ? oldVal.__staleWhileFetching
                        : oldVal;
                    if (oldValue !== undefined)
                        status.oldValue = oldValue;
                }
            }
            else if (status) {
                status.set = 'update';
            }
        }
        if (ttl !== 0 && !this.#ttls) {
            this.#initializeTTLTracking();
        }
        if (this.#ttls) {
            if (!noUpdateTTL) {
                this.#setItemTTL(index, ttl, start);
            }
            if (status)
                this.#statusTTL(status, index);
        }
        if (!noDisposeOnSet && this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
        return this;
    }
    /**
     * Evict the least recently used item, returning its value or
     * `undefined` if cache is empty.
     */
    pop() {
        try {
            while (this.#size) {
                const val = this.#valList[this.#head];
                this.#evict(true);
                if (this.#isBackgroundFetch(val)) {
                    if (val.__staleWhileFetching) {
                        return val.__staleWhileFetching;
                    }
                }
                else if (val !== undefined) {
                    return val;
                }
            }
        }
        finally {
            if (this.#hasDisposeAfter && this.#disposed) {
                const dt = this.#disposed;
                let task;
                while ((task = dt?.shift())) {
                    this.#disposeAfter?.(...task);
                }
            }
        }
    }
    #evict(free) {
        const head = this.#head;
        const k = this.#keyList[head];
        const v = this.#valList[head];
        if (this.#hasFetchMethod && this.#isBackgroundFetch(v)) {
            v.__abortController.abort(new Error('evicted'));
        }
        else if (this.#hasDispose || this.#hasDisposeAfter) {
            if (this.#hasDispose) {
                this.#dispose?.(v, k, 'evict');
            }
            if (this.#hasDisposeAfter) {
                this.#disposed?.push([v, k, 'evict']);
            }
        }
        this.#removeItemSize(head);
        // if we aren't about to use the index, then null these out
        if (free) {
            this.#keyList[head] = undefined;
            this.#valList[head] = undefined;
            this.#free.push(head);
        }
        if (this.#size === 1) {
            this.#head = this.#tail = 0;
            this.#free.length = 0;
        }
        else {
            this.#head = this.#next[head];
        }
        this.#keyMap.delete(k);
        this.#size--;
        return head;
    }
    /**
     * Check if a key is in the cache, without updating the recency of use.
     * Will return false if the item is stale, even though it is technically
     * in the cache.
     *
     * Will not update item age unless
     * {@link LRUCache.OptionsBase.updateAgeOnHas} is set.
     */
    has(k, hasOptions = {}) {
        const { updateAgeOnHas = this.updateAgeOnHas, status } = hasOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v) &&
                v.__staleWhileFetching === undefined) {
                return false;
            }
            if (!this.#isStale(index)) {
                if (updateAgeOnHas) {
                    this.#updateItemAge(index);
                }
                if (status) {
                    status.has = 'hit';
                    this.#statusTTL(status, index);
                }
                return true;
            }
            else if (status) {
                status.has = 'stale';
                this.#statusTTL(status, index);
            }
        }
        else if (status) {
            status.has = 'miss';
        }
        return false;
    }
    /**
     * Like {@link LRUCache#get} but doesn't update recency or delete stale
     * items.
     *
     * Returns `undefined` if the item is stale, unless
     * {@link LRUCache.OptionsBase.allowStale} is set.
     */
    peek(k, peekOptions = {}) {
        const { allowStale = this.allowStale } = peekOptions;
        const index = this.#keyMap.get(k);
        if (index === undefined ||
            (!allowStale && this.#isStale(index))) {
            return;
        }
        const v = this.#valList[index];
        // either stale and allowed, or forcing a refresh of non-stale value
        return this.#isBackgroundFetch(v) ? v.__staleWhileFetching : v;
    }
    #backgroundFetch(k, index, options, context) {
        const v = index === undefined ? undefined : this.#valList[index];
        if (this.#isBackgroundFetch(v)) {
            return v;
        }
        const ac = new AC();
        const { signal } = options;
        // when/if our AC signals, then stop listening to theirs.
        signal?.addEventListener('abort', () => ac.abort(signal.reason), {
            signal: ac.signal,
        });
        const fetchOpts = {
            signal: ac.signal,
            options,
            context,
        };
        const cb = (v, updateCache = false) => {
            const { aborted } = ac.signal;
            const ignoreAbort = options.ignoreFetchAbort && v !== undefined;
            if (options.status) {
                if (aborted && !updateCache) {
                    options.status.fetchAborted = true;
                    options.status.fetchError = ac.signal.reason;
                    if (ignoreAbort)
                        options.status.fetchAbortIgnored = true;
                }
                else {
                    options.status.fetchResolved = true;
                }
            }
            if (aborted && !ignoreAbort && !updateCache) {
                return fetchFail(ac.signal.reason);
            }
            // either we didn't abort, and are still here, or we did, and ignored
            const bf = p;
            if (this.#valList[index] === p) {
                if (v === undefined) {
                    if (bf.__staleWhileFetching) {
                        this.#valList[index] = bf.__staleWhileFetching;
                    }
                    else {
                        this.delete(k);
                    }
                }
                else {
                    if (options.status)
                        options.status.fetchUpdated = true;
                    this.set(k, v, fetchOpts.options);
                }
            }
            return v;
        };
        const eb = (er) => {
            if (options.status) {
                options.status.fetchRejected = true;
                options.status.fetchError = er;
            }
            return fetchFail(er);
        };
        const fetchFail = (er) => {
            const { aborted } = ac.signal;
            const allowStaleAborted = aborted && options.allowStaleOnFetchAbort;
            const allowStale = allowStaleAborted || options.allowStaleOnFetchRejection;
            const noDelete = allowStale || options.noDeleteOnFetchRejection;
            const bf = p;
            if (this.#valList[index] === p) {
                // if we allow stale on fetch rejections, then we need to ensure that
                // the stale value is not removed from the cache when the fetch fails.
                const del = !noDelete || bf.__staleWhileFetching === undefined;
                if (del) {
                    this.delete(k);
                }
                else if (!allowStaleAborted) {
                    // still replace the *promise* with the stale value,
                    // since we are done with the promise at this point.
                    // leave it untouched if we're still waiting for an
                    // aborted background fetch that hasn't yet returned.
                    this.#valList[index] = bf.__staleWhileFetching;
                }
            }
            if (allowStale) {
                if (options.status && bf.__staleWhileFetching !== undefined) {
                    options.status.returnedStale = true;
                }
                return bf.__staleWhileFetching;
            }
            else if (bf.__returned === bf) {
                throw er;
            }
        };
        const pcall = (res, rej) => {
            const fmp = this.#fetchMethod?.(k, v, fetchOpts);
            if (fmp && fmp instanceof Promise) {
                fmp.then(v => res(v === undefined ? undefined : v), rej);
            }
            // ignored, we go until we finish, regardless.
            // defer check until we are actually aborting,
            // so fetchMethod can override.
            ac.signal.addEventListener('abort', () => {
                if (!options.ignoreFetchAbort ||
                    options.allowStaleOnFetchAbort) {
                    res(undefined);
                    // when it eventually resolves, update the cache.
                    if (options.allowStaleOnFetchAbort) {
                        res = v => cb(v, true);
                    }
                }
            });
        };
        if (options.status)
            options.status.fetchDispatched = true;
        const p = new Promise(pcall).then(cb, eb);
        const bf = Object.assign(p, {
            __abortController: ac,
            __staleWhileFetching: v,
            __returned: undefined,
        });
        if (index === undefined) {
            // internal, don't expose status.
            this.set(k, bf, { ...fetchOpts.options, status: undefined });
            index = this.#keyMap.get(k);
        }
        else {
            this.#valList[index] = bf;
        }
        return bf;
    }
    #isBackgroundFetch(p) {
        if (!this.#hasFetchMethod)
            return false;
        const b = p;
        return (!!b &&
            b instanceof Promise &&
            b.hasOwnProperty('__staleWhileFetching') &&
            b.__abortController instanceof AC);
    }
    async fetch(k, fetchOptions = {}) {
        const { 
        // get options
        allowStale = this.allowStale, updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet = this.noDeleteOnStaleGet, 
        // set options
        ttl = this.ttl, noDisposeOnSet = this.noDisposeOnSet, size = 0, sizeCalculation = this.sizeCalculation, noUpdateTTL = this.noUpdateTTL, 
        // fetch exclusive options
        noDeleteOnFetchRejection = this.noDeleteOnFetchRejection, allowStaleOnFetchRejection = this.allowStaleOnFetchRejection, ignoreFetchAbort = this.ignoreFetchAbort, allowStaleOnFetchAbort = this.allowStaleOnFetchAbort, context, forceRefresh = false, status, signal, } = fetchOptions;
        if (!this.#hasFetchMethod) {
            if (status)
                status.fetch = 'get';
            return this.get(k, {
                allowStale,
                updateAgeOnGet,
                noDeleteOnStaleGet,
                status,
            });
        }
        const options = {
            allowStale,
            updateAgeOnGet,
            noDeleteOnStaleGet,
            ttl,
            noDisposeOnSet,
            size,
            sizeCalculation,
            noUpdateTTL,
            noDeleteOnFetchRejection,
            allowStaleOnFetchRejection,
            allowStaleOnFetchAbort,
            ignoreFetchAbort,
            status,
            signal,
        };
        let index = this.#keyMap.get(k);
        if (index === undefined) {
            if (status)
                status.fetch = 'miss';
            const p = this.#backgroundFetch(k, index, options, context);
            return (p.__returned = p);
        }
        else {
            // in cache, maybe already fetching
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                const stale = allowStale && v.__staleWhileFetching !== undefined;
                if (status) {
                    status.fetch = 'inflight';
                    if (stale)
                        status.returnedStale = true;
                }
                return stale ? v.__staleWhileFetching : (v.__returned = v);
            }
            // if we force a refresh, that means do NOT serve the cached value,
            // unless we are already in the process of refreshing the cache.
            const isStale = this.#isStale(index);
            if (!forceRefresh && !isStale) {
                if (status)
                    status.fetch = 'hit';
                this.#moveToTail(index);
                if (updateAgeOnGet) {
                    this.#updateItemAge(index);
                }
                if (status)
                    this.#statusTTL(status, index);
                return v;
            }
            // ok, it is stale or a forced refresh, and not already fetching.
            // refresh the cache.
            const p = this.#backgroundFetch(k, index, options, context);
            const hasStale = p.__staleWhileFetching !== undefined;
            const staleVal = hasStale && allowStale;
            if (status) {
                status.fetch = isStale ? 'stale' : 'refresh';
                if (staleVal && isStale)
                    status.returnedStale = true;
            }
            return staleVal ? p.__staleWhileFetching : (p.__returned = p);
        }
    }
    /**
     * Return a value from the cache. Will update the recency of the cache
     * entry found.
     *
     * If the key is not found, get() will return `undefined`.
     */
    get(k, getOptions = {}) {
        const { allowStale = this.allowStale, updateAgeOnGet = this.updateAgeOnGet, noDeleteOnStaleGet = this.noDeleteOnStaleGet, status, } = getOptions;
        const index = this.#keyMap.get(k);
        if (index !== undefined) {
            const value = this.#valList[index];
            const fetching = this.#isBackgroundFetch(value);
            if (status)
                this.#statusTTL(status, index);
            if (this.#isStale(index)) {
                if (status)
                    status.get = 'stale';
                // delete only if not an in-flight background fetch
                if (!fetching) {
                    if (!noDeleteOnStaleGet) {
                        this.delete(k);
                    }
                    if (status && allowStale)
                        status.returnedStale = true;
                    return allowStale ? value : undefined;
                }
                else {
                    if (status &&
                        allowStale &&
                        value.__staleWhileFetching !== undefined) {
                        status.returnedStale = true;
                    }
                    return allowStale ? value.__staleWhileFetching : undefined;
                }
            }
            else {
                if (status)
                    status.get = 'hit';
                // if we're currently fetching it, we don't actually have it yet
                // it's not stale, which means this isn't a staleWhileRefetching.
                // If it's not stale, and fetching, AND has a __staleWhileFetching
                // value, then that means the user fetched with {forceRefresh:true},
                // so it's safe to return that value.
                if (fetching) {
                    return value.__staleWhileFetching;
                }
                this.#moveToTail(index);
                if (updateAgeOnGet) {
                    this.#updateItemAge(index);
                }
                return value;
            }
        }
        else if (status) {
            status.get = 'miss';
        }
    }
    #connect(p, n) {
        this.#prev[n] = p;
        this.#next[p] = n;
    }
    #moveToTail(index) {
        // if tail already, nothing to do
        // if head, move head to next[index]
        // else
        //   move next[prev[index]] to next[index] (head has no prev)
        //   move prev[next[index]] to prev[index]
        // prev[index] = tail
        // next[tail] = index
        // tail = index
        if (index !== this.#tail) {
            if (index === this.#head) {
                this.#head = this.#next[index];
            }
            else {
                this.#connect(this.#prev[index], this.#next[index]);
            }
            this.#connect(this.#tail, index);
            this.#tail = index;
        }
    }
    /**
     * Deletes a key out of the cache.
     * Returns true if the key was deleted, false otherwise.
     */
    delete(k) {
        let deleted = false;
        if (this.#size !== 0) {
            const index = this.#keyMap.get(k);
            if (index !== undefined) {
                deleted = true;
                if (this.#size === 1) {
                    this.clear();
                }
                else {
                    this.#removeItemSize(index);
                    const v = this.#valList[index];
                    if (this.#isBackgroundFetch(v)) {
                        v.__abortController.abort(new Error('deleted'));
                    }
                    else if (this.#hasDispose || this.#hasDisposeAfter) {
                        if (this.#hasDispose) {
                            this.#dispose?.(v, k, 'delete');
                        }
                        if (this.#hasDisposeAfter) {
                            this.#disposed?.push([v, k, 'delete']);
                        }
                    }
                    this.#keyMap.delete(k);
                    this.#keyList[index] = undefined;
                    this.#valList[index] = undefined;
                    if (index === this.#tail) {
                        this.#tail = this.#prev[index];
                    }
                    else if (index === this.#head) {
                        this.#head = this.#next[index];
                    }
                    else {
                        const pi = this.#prev[index];
                        this.#next[pi] = this.#next[index];
                        const ni = this.#next[index];
                        this.#prev[ni] = this.#prev[index];
                    }
                    this.#size--;
                    this.#free.push(index);
                }
            }
        }
        if (this.#hasDisposeAfter && this.#disposed?.length) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
        return deleted;
    }
    /**
     * Clear the cache entirely, throwing away all values.
     */
    clear() {
        for (const index of this.#rindexes({ allowStale: true })) {
            const v = this.#valList[index];
            if (this.#isBackgroundFetch(v)) {
                v.__abortController.abort(new Error('deleted'));
            }
            else {
                const k = this.#keyList[index];
                if (this.#hasDispose) {
                    this.#dispose?.(v, k, 'delete');
                }
                if (this.#hasDisposeAfter) {
                    this.#disposed?.push([v, k, 'delete']);
                }
            }
        }
        this.#keyMap.clear();
        this.#valList.fill(undefined);
        this.#keyList.fill(undefined);
        if (this.#ttls && this.#starts) {
            this.#ttls.fill(0);
            this.#starts.fill(0);
        }
        if (this.#sizes) {
            this.#sizes.fill(0);
        }
        this.#head = 0;
        this.#tail = 0;
        this.#free.length = 0;
        this.#calculatedSize = 0;
        this.#size = 0;
        if (this.#hasDisposeAfter && this.#disposed) {
            const dt = this.#disposed;
            let task;
            while ((task = dt?.shift())) {
                this.#disposeAfter?.(...task);
            }
        }
    }
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./lib/lru/index.tsx

// Strategy: keep the 24h most popular 1000 records
var cacheConfig = {
    max: 1000,
    ttlAutopurge: true,
    updateAgeOnGet: true,
    ttl: 3600 * 1000 * 24
};
if (!__webpack_require__.g.lru) {
    __webpack_require__.g.lru = new LRUCache(cacheConfig);
}
lru = __webpack_require__.g.lru;
/* harmony default export */ var lib_lru = (lru);


/***/ }),

/***/ 21170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bT": function() { return /* binding */ createAnalyticsUrl; },
/* harmony export */   "qZ": function() { return /* binding */ createAnalyticsDraft; },
/* harmony export */   "uX": function() { return /* binding */ createAnalyticsProduct; },
/* harmony export */   "zc": function() { return /* binding */ createAnalyticsIntegrations; }
/* harmony export */ });
/* unused harmony exports analyticsProductsHelper, createAnalyticsUserData, mergeSampleFields, useTrackProductsViewed */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _data_updatedCategoryHierarchyData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80207);
/* harmony import */ var _utils_analytics_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74504);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96645);












var PRODUCT_PATH = "/product" || 0;
var mergeSampleFields = function(product, variation) {
    var ref;
    return _object_spread_props(_object_spread({}, product), {
        variationId: variation.id,
        paperType: variation === null || variation === void 0 ? void 0 : variation.paperType,
        foilId: variation === null || variation === void 0 ? void 0 : (ref = variation.foil) === null || ref === void 0 ? void 0 : ref.id
    });
};
var createAnalyticsUserData = function() {
    var ref, ref1;
    var userId = getCookieByName((ref = window.document) === null || ref === void 0 ? void 0 : ref.cookie, "ajs_user_id") || "unidentified";
    var anonymousId = getCookieByName((ref1 = window.document) === null || ref1 === void 0 ? void 0 : ref1.cookie, "ajs_anonymous_id") || "unidentified";
    var ref2, ref3;
    return {
        userId: (ref2 = userId.replace(/["]/g, "")) !== null && ref2 !== void 0 ? ref2 : "",
        anonymousId: (ref3 = anonymousId.replace(/["]/g, "")) !== null && ref3 !== void 0 ? ref3 : ""
    };
};
var createAnalyticsIntegrations = function() {
    var ref;
    var gaCookie = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getCookieByName */ .A7)((ref = window.document) === null || ref === void 0 ? void 0 : ref.cookie, "_ga").split(".").slice(-2).join(".");
    return {
        integrations: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "Google Universal Analytics", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "clientId", gaCookie))
    };
};
var createAnalyticsUrl = function(slug) {
    if (!slug) return "";
    return "".concat("https://www.theknot.com").concat("/paper").concat(PRODUCT_PATH, "/").concat((0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__/* .removeQueryParamsFromPathUrl */ .$P)(slug));
};
var createAnalyticsDraft = function(draft, location, item) {
    var position = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var ref, ref1, ref2;
    var optionValues = draft.variation.optionValues;
    var productCode = (item === null || item === void 0 ? void 0 : (ref = item.variation) === null || ref === void 0 ? void 0 : ref.product.productFormat.name) || "";
    var isPersonalizedSample = draft.variation.isSample && !!((ref1 = draft.portfolioItem) === null || ref1 === void 0 ? void 0 : ref1.customizer) || undefined;
    return {
        category: draft.variation.catalogProduct.catalogProductType.name,
        image_url: draft.image || "",
        name: draft.variation.catalogProduct.name,
        price: ((ref2 = item.price) === null || ref2 === void 0 ? void 0 : ref2.basePrice) || 0,
        position: position,
        product_id: draft.variation.catalogProduct.externalId,
        quantity: draft.quantity,
        sample_details: [
            {
                is_sample: draft.variation.isSample,
                personalized: isPersonalizedSample
            }
        ],
        sku: draft.variation.id,
        location: location,
        url: createAnalyticsUrl((item === null || item === void 0 ? void 0 : item.slug) || ""),
        variant: (0,_utils_analytics_helpers__WEBPACK_IMPORTED_MODULE_2__/* .createAnalyticsVariant */ .V4)(optionValues, productCode),
        hasDesign: !!draft.portfolioItem.notes
    };
};
var createAnalyticsProduct = function(_param) {
    var _position = _param.position, position = _position === void 0 ? 0 : _position, productData = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "position"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var product = productData.product, selectedVariant = productData.selectedVariant, imageUri = productData.imageUri, isSample = productData.isSample;
    var format = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getProductFormats */ .WQ)(product);
    var category = Array.isArray(product.categoryName) ? product.categoryName[product.categoryName.length - 1] : product.categoryName;
    var quantity = isSample || category === _data_updatedCategoryHierarchyData__WEBPACK_IMPORTED_MODULE_4__/* .guestBooks.name */ .kq.name ? 1 : 100;
    return {
        position: position,
        price: product.unitPriceAt100 || NaN,
        product_id: product.id,
        sku: selectedVariant.id,
        category: category,
        name: product.name,
        quantity: quantity,
        image_url: imageUri,
        sample_details: [
            {
                is_sample: isSample,
                personalized: isSample ? false : undefined
            }
        ],
        variant: [
            {
                color: (ref = selectedVariant.colorway) === null || ref === void 0 ? void 0 : ref.name,
                material: (ref1 = selectedVariant.paperType) === null || ref1 === void 0 ? void 0 : ref1.name,
                format: format,
                foil_color: (ref2 = selectedVariant.foil) === null || ref2 === void 0 ? void 0 : ref2.name,
                paper_color: (ref3 = selectedVariant.paperColor) === null || ref3 === void 0 ? void 0 : ref3.name,
                flap_type: (ref4 = selectedVariant.flapType) === null || ref4 === void 0 ? void 0 : ref4.name
            }, 
        ],
        url: createAnalyticsUrl(product.slug)
    };
};
var analyticsProductsHelper = function(products) {
    return products.map(function(product, i) {
        var ref;
        return createAnalyticsProduct({
            product: product,
            isSample: false,
            selectedVariant: product.variations[0],
            imageUri: buildImageURL(((ref = product.variations[0].heroImagePath) === null || ref === void 0 ? void 0 : ref.slice(1)) || ""),
            position: i
        });
    });
};
var useTrackProductsViewed = function() {
    var ref = useCatalogAnalytics(), location = ref.location, category = ref.category;
    var trackingData = useTracking();
    return function(products, listId) {
        var analyticsProductsList = analyticsProductsHelper(products);
        var options = _object_spread({
            category: category,
            location: location,
            products: analyticsProductsList,
            list_id: listId
        }, trackingData);
        trackInteraction("Product List Viewed", options);
    };
};



/***/ }),

/***/ 17380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$M": function() { return /* binding */ MembershipProvider; },
/* harmony export */   "F$": function() { return /* binding */ fetchMember; },
/* harmony export */   "L3": function() { return /* binding */ useMembershipState; },
/* harmony export */   "e7": function() { return /* binding */ useMembership; },
/* harmony export */   "ni": function() { return /* binding */ logOut; }
/* harmony export */ });
/* unused harmony exports membershipReducer, syncMembershipStateAndToken */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72730);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48069);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58105);
//  This context is responsible for state mgmt on the front-end
// Context like these solves the problem of passing state, as well as state crud hooks, down to any children component








var MembershipStateContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var MembershipDispatchContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var initialState = {
    member: null,
    authenticated: false,
    fetched: false
};
var membershipFetchReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "memberFetchSuccess":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    member: action.payload,
                    authenticated: true
                });
            }
        case "memberFetchFailed":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    member: null,
                    authenticated: false
                });
            }
        case "memberFetchStatus":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    fetched: action.payload.fetched
                });
            }
        default:
            {
                return null;
            }
    }
};
var membershipLogoutReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "logoutSuccess":
            {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                    member: null,
                    authenticated: false
                });
            }
        case "logoutFailed":
            {
                return state;
            }
        default:
            {
                return null;
            }
    }
};
// Exported only for testing
var membershipReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var reducers = [
        membershipFetchReducer,
        membershipLogoutReducer
    ];
    var newState = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = reducers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var reducer = _step.value;
            newState = reducer(state, action);
            if (newState) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return newState || initialState;
};
var fetchMember = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(dispatch) {
        var membershipServiceClient, response, payload, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    dispatch({
                        type: "memberFetchStatus",
                        payload: {
                            fetched: false
                        }
                    });
                    return [
                        4,
                        Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(7239), __webpack_require__.e(4991), __webpack_require__.e(4511), __webpack_require__.e(8157), __webpack_require__.e(6338), __webpack_require__.e(9549)]).then(__webpack_require__.bind(__webpack_require__, 13841))
                    ];
                case 1:
                    membershipServiceClient = _state.sent().default;
                    return [
                        4,
                        membershipServiceClient.getMember()
                    ];
                case 2:
                    response = _state.sent();
                    payload = response.body.members;
                    dispatch({
                        type: "memberFetchSuccess",
                        payload: payload
                    });
                    return [
                        2,
                        payload
                    ];
                case 3:
                    error = _state.sent();
                    dispatch({
                        type: "memberFetchFailed"
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    dispatch({
                        type: "memberFetchStatus",
                        payload: {
                            fetched: true
                        }
                    });
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchMember(dispatch) {
        return _ref.apply(this, arguments);
    };
}();
var logOut = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(dispatch) {
        var membershipServiceClient, refreshClientSession, currentRoute, shouldRedirect, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(7239), __webpack_require__.e(4991), __webpack_require__.e(4511), __webpack_require__.e(8157), __webpack_require__.e(6338), __webpack_require__.e(9549)]).then(__webpack_require__.bind(__webpack_require__, 13841))
                    ];
                case 1:
                    membershipServiceClient = _state.sent().default;
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 1363).then(__webpack_require__.bind(__webpack_require__, 21363))
                    ];
                case 2:
                    refreshClientSession = _state.sent().refreshClientSession;
                    return [
                        4,
                        membershipServiceClient.logOut()
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        refreshClientSession()
                    ];
                case 4:
                    _state.sent();
                    document.cookie = "xo-session-token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                    dispatch({
                        type: "logoutSuccess"
                    });
                    currentRoute = (next_router__WEBPACK_IMPORTED_MODULE_2___default().asPath);
                    shouldRedirect = /canvas|review/.test(currentRoute);
                    next_router__WEBPACK_IMPORTED_MODULE_2___default().replace(shouldRedirect ? "/products" : (next_router__WEBPACK_IMPORTED_MODULE_2___default().asPath));
                    return [
                        3,
                        6
                    ];
                case 5:
                    err = _state.sent();
                    dispatch({
                        type: "logoutFailed"
                    });
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function logOut(dispatch) {
        return _ref.apply(this, arguments);
    };
}();
var syncMembershipStateAndToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(cookies, state, dispatch) {
        var hasToken, parsedCookies, tkToken, wwToken;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    hasToken = false;
                    if (cookies) {
                        parsedCookies = (0,cookie__WEBPACK_IMPORTED_MODULE_3__.parse)(cookies);
                        tkToken = parsedCookies["xo-session-token"], wwToken = parsedCookies["tkww-access-token"];
                        hasToken = !!tkToken || !!wwToken;
                    }
                    if (hasToken === state.authenticated) {
                        return [
                            2
                        ];
                    }
                    if (!hasToken) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchMember(dispatch)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        logOut(dispatch)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function syncMembershipStateAndToken(cookies, state, dispatch) {
        return _ref.apply(this, arguments);
    };
}();
var MembershipProvider = function(param) {
    var children = param.children, cookies = param.cookies;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(membershipReducer, initialState), state = ref[0], dispatch = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        void syncMembershipStateAndToken(cookies, state, dispatch);
    }, [
        cookies
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MembershipStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MembershipDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
/* context wrapping, convenience hooks, 
 so components don't have to do `useContext(X)`
 simply use the hooks and extract the context data providing a state hook like interface
*/ var useMembershipState = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MembershipStateContext);
    if (context === undefined) {
        throw new Error("useMembershipState must be used within a MembershipProvider");
    }
    return context;
};
var useMembershipDispatch = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(MembershipDispatchContext);
    if (context === undefined) {
        throw new Error("useMembershipDispatch must be used within a MembershipProvider");
    }
    return context;
};
// This Hook simply returns both the state & the dispatch contexts
var useMembership = function() {
    try {
        return [
            useMembershipState(),
            useMembershipDispatch()
        ];
    } catch (e) {
        throw new Error("useMembership hook  must be used within a MembershipProvider");
    }
};


/***/ }),

/***/ 30380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ initializeTracking; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _generated_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31074);



function initializeTracking() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        enforce: "desktop web",
        log: false
    }, enforce = ref.enforce, log = ref.log;
    var ref1, ref2, ref3;
    var window1 = __webpack_require__.g.window;
    if (!window1) return;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - ios webview tracking
    if (enforce === "mobile app ios" || ((ref1 = window1.webkit) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.messageHandlers) === null || ref2 === void 0 ? void 0 : ref2.trackAppEvent)) {
        setupIOSTracking({
            log: log
        });
        return;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - android webview tracking
    if (enforce === "mobile app android" || (window1 === null || window1 === void 0 ? void 0 : (ref3 = window1.PlannerAndroid) === null || ref3 === void 0 ? void 0 : ref3.trackAppEvent)) {
        setupAndroidTracking({
            log: log
        });
        return;
    }
}
var mergeBaseWebviewOptions = function(props) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, props), {
        section: "paper"
    });
};
function titleCase(text) {
    var result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}
function setupAndroidTracking() {
    var log = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        log: false
    }).log;
    var track = function track(event, properties, callback) {
        var msg = JSON.stringify(mergeBaseWebviewOptions(properties));
        try {
            var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            ref;
            window === null || window === void 0 ? void 0 : (ref = window.PlannerAndroid) === null || ref === void 0 ? void 0 : ref.trackAppEvent(event, msg);
            if (typeof callback === "function") callback();
        } catch (e) {
            console.error(e);
        } finally{
            if (log) {
                console.log("Using Android webview tracking");
                console.log("window.PlannerAndroid.trackAppEvent", event, msg);
            }
        }
    };
    patchTypewriter(track);
    window.analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, window.analytics || {}), {
        track: track
    });
}
function setupIOSTracking() {
    var log = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        log: false
    }).log;
    var track = function track(event, properties, callback) {
        var msg = event + "+" + JSON.stringify(mergeBaseWebviewOptions(properties));
        try {
            var // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            ref, ref1;
            (ref = window.webkit) === null || ref === void 0 ? void 0 : (ref1 = ref.messageHandlers) === null || ref1 === void 0 ? void 0 : ref1.trackAppEvent.postMessage(msg);
            if (typeof callback === "function") callback();
        } catch (e) {
            console.error(e);
        } finally{
            if (log) {
                console.log("Using iOS webview tracking");
                console.log("window.webkit.messageHandlers.trackAppEvent.postMessage", msg);
            }
        }
    };
    patchTypewriter(track);
    window.analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, window.analytics || {}), {
        track: track
    });
}
function patchTypewriter(trackFn) {
    Object.keys(_generated_analytics__WEBPACK_IMPORTED_MODULE_2__["default"]).filter(function(key) {
        return !key.includes("setTypewriterOptions");
    }).forEach(function(k) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _generated_analytics__WEBPACK_IMPORTED_MODULE_2__["default"][k] = function(properties, _options, callback) {
            trackFn(titleCase(k), properties, callback);
        };
    });
}


/***/ }),

/***/ 69354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5417);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__);

var IGNORED_MESSAGES = [
    "Unauthorized Exception"
];
_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().configure({
    apiKey: "11ca040e" || 0,
    environment: "foundation-production" || 0,
    developmentEnvironments: [
        "dev",
        "development",
        "development-ww",
        "qa"
    ],
    breadcrumbsEnabled: {
        dom: true,
        network: true,
        navigation: true,
        console: false
    }
});
_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().beforeNotify(function(notice) {
    if ((notice === null || notice === void 0 ? void 0 : notice.message) && IGNORED_MESSAGES.includes(notice.message)) return false;
    return true;
});
var honeybadger = (_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default());
/* harmony default export */ __webpack_exports__["default"] = (honeybadger);


/***/ }),

/***/ 58314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PH": function() { return /* binding */ useImpactIdentify; },
/* harmony export */   "bj": function() { return /* binding */ trackConversionToImpact; },
/* harmony export */   "dm": function() { return /* binding */ useImpactIdentifyCallback; }
/* harmony export */ });
/* unused harmony exports identifyUserToImpact, impactUniversalTrackingTag */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76806);


var impactUniversalTrackingTag = "\n(function(a,b,c,d,e,f,g){e['ire_o']=c;e[c]=e[c]||function(){(e[c].a=e[c].a||[]).push(arguments)};f=d.createElement(b);g=d.getElementsByTagName(b)[0];f.async=1;f.src=a;g.parentNode.insertBefore(f,g);})('//d.impactradius-event.com/A2418572-9a1d-44c3-a1ba-e8780964b8a41.js','script','ire',document,window);\n";
var IMPACT_SAMPLE_ACTION_ID = 22099;
var IMPACT_NO_SAMPLE_ACTION_ID = 22100;
function encodeEmail(email) {
    var regex = new RegExp(/[^@.]/gm);
    return email.replace(regex, "*");
}
var identifyUserToImpact = function(userId, email) {
    try {
        if ((0,_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .isTenant */ .J)("ww")) return;
        var customerId = userId;
        var customerEmail = encodeEmail(email || "");
        window.ire("identify", {
            customerId: customerId,
            customerEmail: customerEmail
        });
    } catch (e) {
        console.log(e);
    }
};
var useImpactIdentify = function() {
    var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", email = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        identifyUserToImpact(id, email);
    }, [
        email,
        id
    ]);
};
var useImpactIdentifyCallback = function(member) {
    var email = (member === null || member === void 0 ? void 0 : member.email) || "";
    var id = (member === null || member === void 0 ? void 0 : member.id) || "";
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        identifyUserToImpact(id, email);
    }, [
        id,
        email
    ]);
};
var trackConversionToImpact = function(data, customerId, customerStatus) {
    if ((0,_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .isTenant */ .J)("ww")) return;
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        var hasSamples = data.products.some(function(product) {
            return product.sample;
        });
        var actionTrackerId = hasSamples ? IMPACT_SAMPLE_ACTION_ID : IMPACT_NO_SAMPLE_ACTION_ID;
        var conversionActionEvent = {
            orderId: data.order_id,
            customerId: customerId,
            //@ts-expect-error customerEmail is not defined in the interface
            customerEmail: encodeEmail(data.email || ""),
            customerStatus: customerStatus,
            currencyCode: data.currency,
            orderPromoCode: data.coupon,
            orderDiscount: data.discount,
            items: data.products.map(function(product) {
                return {
                    subTotal: product.price,
                    category: product.category,
                    // sku parameter has been omitted on foundation
                    sku: "",
                    quantity: product.quantity,
                    name: product.name
                };
            })
        };
        window.ire("trackConversion", actionTrackerId, conversionActionEvent);
    } catch (err) {
        console.error(err);
    }
};



/***/ }),

/***/ 31459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h6": function() { return /* binding */ FEATURES; },
/* harmony export */   "m8": function() { return /* binding */ FeatureToggleProvider; },
/* harmony export */   "pj": function() { return /* binding */ cast; },
/* harmony export */   "zh": function() { return /* binding */ FeatureToggleContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);



var cast = function(env) {
    return env && !!+env || false;
};
var FEATURES = {
    productDesigner: cast("1"),
    collectionsSubnav: cast("1"),
    seasonalCollectionSubnavLink: cast("1"),
    myDrafts: cast("1"),
    nativeLinks: false,
    cmp: cast("1")
};
var FeatureToggleContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(FEATURES);
var FeatureToggleProvider = function(param) {
    var children = param.children, _features = param.features, features = _features === void 0 ? {} : _features;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeatureToggleContext.Provider, {
        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, FEATURES, features),
        children: children
    });
};


/***/ }),

/***/ 7339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(88779)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(32109)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(84937)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(99084));
var _loadable = _interop_require_default(__webpack_require__(87671));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 78054:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(84937)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(99084));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 87671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(80581)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(47897)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(32109)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(84937)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(99084));
var _loadableContext = __webpack_require__(78054);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(9118)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 20311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "partialCommonPageProps": function() { return /* binding */ partialCommonPageProps; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(72491);
// EXTERNAL MODULE: ./lib/flipper/FlipperProvider.tsx
var FlipperProvider = __webpack_require__(6807);
// EXTERNAL MODULE: ./lib/flipper/flipper.service.ts + 2 modules
var flipper_service = __webpack_require__(71714);
// EXTERNAL MODULE: ./modules/core/services/honeybadger.service.ts
var honeybadger_service = __webpack_require__(69354);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./components/Tracking/TrackingProvider/TrackingProvider.tsx
var TrackingProvider = __webpack_require__(82725);
// EXTERNAL MODULE: ./modules/shared/Feature/FeatureToggle/FeatureToggleContext.tsx
var FeatureToggleContext = __webpack_require__(31459);
;// CONCATENATED MODULE: ./modules/shared/Context/index.tsx





var AppProviders = function(param) {
    var children = param.children, features = param.features, _platform = param.platform, platform = _platform === void 0 ? "desktop web" : _platform, user = param.user, referrer = param.referrer;
    var baseTracking = {
        memberId: user ? user.id : null,
        platform: platform,
        product: "paper",
        referrer: referrer
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingProvider/* TrackingProvider */.L, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseTracking), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureToggleContext/* FeatureToggleProvider */.m8, {
            features: features,
            children: children
        })
    }));
};


// EXTERNAL MODULE: ./utils/pages/index.ts
var pages = __webpack_require__(59837);
// EXTERNAL MODULE: ./node_modules/@honeybadger-io/react/dist/honeybadger-react.esm.js
var honeybadger_react_esm = __webpack_require__(37627);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(41414);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(48069);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
// EXTERNAL MODULE: ./components/User/UserProvider/UserProvider.tsx
var UserProvider = __webpack_require__(78985);
// EXTERNAL MODULE: ./modules/core/services/analytics/tracker.ts
var tracker = __webpack_require__(30380);
// EXTERNAL MODULE: ./utils/config/config.constants.ts
var config_constants = __webpack_require__(76806);
// EXTERNAL MODULE: ./styles/global.scss
var global = __webpack_require__(94943);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-typography/lib/globals.css
var globals = __webpack_require__(28437);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-links/lib/globals.css
var lib_globals = __webpack_require__(65452);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-ui-essentials/lib/reset.globals.css
var reset_globals = __webpack_require__(47583);
;// CONCATENATED MODULE: ./node_modules/@xo-union/tk-ui-essentials/lib/globals.js



// EXTERNAL MODULE: ./modules/core/contexts/membershipAuth/index.tsx
var membershipAuth = __webpack_require__(17380);
;// CONCATENATED MODULE: ./domains/core/promotions/promotions.constants.ts
var PROMOTIONS = [
    {
        name: "25% off Entire Site",
        code: "CHEERS25",
        type: "percentage",
        amount: 25,
        startDate: String("2025-04-21T07:00:00.000Z"),
        endDate: String("2025-04-30T06:59:59.000Z"),
        productTypeCodes: []
    }, 
];

// EXTERNAL MODULE: ./domains/core/promotions/usePromotions.tsx
var usePromotions = __webpack_require__(61314);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs + 1 modules
var esm = __webpack_require__(70024);
// EXTERNAL MODULE: ./ui/OverlaySpinner/overlaySpinner.atom.tsx
var overlaySpinner_atom = __webpack_require__(96399);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-overlay/lib/Overlay.js
var Overlay = __webpack_require__(30301);
// EXTERNAL MODULE: ./node_modules/@xo-union/tk-component-spinner/lib/components/Spinner/index.js
var Spinner = __webpack_require__(15771);
// EXTERNAL MODULE: ./ui/OverlaySpinner/tk/overlaySpinnerTK.module.scss
var overlaySpinnerTK_module = __webpack_require__(63465);
var overlaySpinnerTK_module_default = /*#__PURE__*/__webpack_require__.n(overlaySpinnerTK_module);
;// CONCATENATED MODULE: ./ui/OverlaySpinner/tk/OverlaySpinnerTK.tsx




var OverlaySpinnerTK = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* Overlay */.a, {
        className: (overlaySpinnerTK_module_default()).overlay,
        color: "light",
        "data-testid": "overlay-spinner-tk",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
            className: (overlaySpinnerTK_module_default()).overlaySpinner
        })
    });
};
/* harmony default export */ var tk_OverlaySpinnerTK = (OverlaySpinnerTK);

// EXTERNAL MODULE: ./ui/OverlaySpinner/ww/overlaySpinnerWW.module.scss
var overlaySpinnerWW_module = __webpack_require__(62459);
var overlaySpinnerWW_module_default = /*#__PURE__*/__webpack_require__.n(overlaySpinnerWW_module);
;// CONCATENATED MODULE: ./ui/OverlaySpinner/ww/OverlaySpinnerWW.tsx


var OverlaySpinnerWW = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (overlaySpinnerWW_module_default()).mask,
        "data-testid": "overlay-spinner-ww",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (overlaySpinnerWW_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (overlaySpinnerWW_module_default()).wrapperBefore,
                    style: {
                        backgroundImage: "url(".concat("https://media-api.xogrp.com", "/images/86cd24d3-6963-4043-a3f4-696b6c903335)")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (overlaySpinnerWW_module_default()).loader
                })
            ]
        })
    });
};
/* harmony default export */ var ww_OverlaySpinnerWW = (OverlaySpinnerWW);

;// CONCATENATED MODULE: ./ui/OverlaySpinner/OverlaySpinner.tsx








var OverlayModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4511), __webpack_require__.e(6593), __webpack_require__.e(6444)]).then(__webpack_require__.bind(__webpack_require__, 36444)).then(function(m) {
        return m.OverlayModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36444)
            ];
        }
    }
});
var OverlaySpinner_Spinner = (0,config_constants/* isTenant */.J)("ww") ? ww_OverlaySpinnerWW : tk_OverlaySpinnerTK;
var OverlaySpinner = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(overlaySpinner_atom/* isSpinnerShownAtom */.nD), 1), isShown = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,esm/* useAtom */.KO)(overlaySpinner_atom/* spinnerElementAtom */.oj), 1), element = ref1[0];
    if (!isShown) return null;
    return element ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayModal, {
        children: element
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySpinner_Spinner, {});
};

// EXTERNAL MODULE: ./utils/analytics/helpers.ts
var helpers = __webpack_require__(74504);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(20158);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/defaultJsonSerializer.js
const defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/helpers.js
const uppercase = (str) => str.toUpperCase();
/**
 * Convert Headers instance into regular object
 */
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/parseArgs.js
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseArgs_parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document
        ? urlOrOptions
        : {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
const parseArgs_parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query
        ? urlOrOptions
        : {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=parseArgs.js.map
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/ast.mjs
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));



;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/kinds.mjs
/**
 * The set of allowed kind values for AST nodes.
 */
var kinds_Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(kinds_Kind || (kinds_Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/characterClasses.mjs
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/blockString.mjs

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/inspect.mjs
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds_Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds_Kind.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds_Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds_Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds_Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds_Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds_Kind.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds_Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds_Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds_Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds_Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds_Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds_Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds_Kind.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds_Kind.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds_Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds_Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds_Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds_Kind.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds_Kind.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds_Kind.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds_Kind.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds_Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds_Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds_Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds_Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds_Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds_Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds_Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds_Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds_Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds_Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds_Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds_Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds_Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds_Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds_Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds_Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds_Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds_Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

;// CONCATENATED MODULE: ./node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(kinds_Kind)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      isNode(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if (isNode(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? printBlockString(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/resolveRequestDocument.js

/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = operationDefinitions[0]?.name?.value;
    }
    return operationName;
};
const resolveRequestDocument = (document) => {
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = parse(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: print(document), operationName };
};
//# sourceMappingURL=resolveRequestDocument.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/types.js
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
//# sourceMappingURL=types.js.map
// EXTERNAL MODULE: ./node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(26367);
var browser_ponyfill_namespaceObject = /*#__PURE__*/__webpack_require__.t(browser_ponyfill, 2);
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/graphql-ws.js
/* eslint-disable */


// import type WebSocket from 'ws'
const CONNECTION_INIT = `connection_init`;
const CONNECTION_ACK = `connection_ack`;
const PING = `ping`;
const PONG = `pong`;
const SUBSCRIBE = `subscribe`;
const NEXT = `next`;
const ERROR = `error`;
const COMPLETE = `complete`;
class GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = { type: this.type };
        if (this.id != null && this.id != undefined)
            result.id = this.id;
        if (this.payload != null && this.payload != undefined)
            result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type, payload, id } = JSON.parse(data);
        return new GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class GraphQLWebSocketClient {
    constructor(socket, { onInit, onAcknowledged, onPing, onPong }) {
        this.socketState = { acknowledged: false, lastRequestId: 0, subscriptions: {} };
        this.socket = socket;
        socket.addEventListener(`open`, async (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send(ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e) => {
            console.error(e);
        });
        socket.addEventListener(`message`, (e) => {
            try {
                const message = parseMessage(e.data);
                switch (message.type) {
                    case CONNECTION_ACK: {
                        if (this.socketState.acknowledged) {
                            console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        }
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged)
                                onAcknowledged(message.payload);
                        }
                        return;
                    }
                    case PING: {
                        if (onPing)
                            onPing(message.payload).then((r) => socket.send(Pong(r).text));
                        else
                            socket.send(Pong(null).text);
                        return;
                    }
                    case PONG: {
                        if (onPong)
                            onPong(message.payload);
                        return;
                    }
                }
                if (!this.socketState.acknowledged) {
                    // Web-socket connection not acknowledged
                    return;
                }
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) {
                    // No subscription identifer or subscription indentifier is not found
                    return;
                }
                const { query, variables, subscriber } = this.socketState.subscriptions[message.id];
                switch (message.type) {
                    case NEXT: {
                        if (!message.payload.errors && message.payload.data) {
                            subscriber.next && subscriber.next(message.payload.data);
                        }
                        if (message.payload.errors) {
                            subscriber.error &&
                                subscriber.error(new ClientError({ ...message.payload, status: 200 }, { query, variables }));
                        }
                        else {
                        }
                        return;
                    }
                    case ERROR: {
                        subscriber.error &&
                            subscriber.error(new ClientError({ errors: message.payload, status: 200 }, { query, variables }));
                        return;
                    }
                    case COMPLETE: {
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                    }
                }
            }
            catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = { query, variables, subscriber };
        this.socket.send(Subscribe(subscriptionId, { query, operationName, variables }).text);
        return () => {
            this.socket.send(Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions) => (result = { data, extensions }),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.subscribe(document, {
                next: (data) => (result = data),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query, operationName } = resolveRequestDocument(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send(Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;

// Helper functions
function parseMessage(data, f = (a) => a) {
    const m = GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function ConnectionInit(payload) {
    return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
    return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
    return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
    return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
    return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}
//# sourceMappingURL=graphql-ws.js.map
;// CONCATENATED MODULE: ./node_modules/graphql-request/build/esm/index.js






/**
 * Convert the given headers configuration into a plain object.
 */
const resolveHeaders = (headers) => {
    let oHeaders = {};
    if (headers) {
        if ((typeof Headers !== `undefined` && headers instanceof Headers) ||
            (browser_ponyfill_namespaceObject && browser_ponyfill.Headers && headers instanceof browser_ponyfill.Headers)) {
            oHeaders = HeadersInstanceToPlainObject(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(([name, value]) => {
                if (name && value !== undefined) {
                    oHeaders[name] = value;
                }
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */
const buildRequestConfig = (params) => {
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [`query=${encodeURIComponent(cleanQuery(params_.query))}`];
        if (params.variables) {
            search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        }
        if (params_.operationName) {
            search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        }
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) {
        throw new Error(`Cannot create query with given variable type, array expected`);
    }
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index) => {
        acc.push({
            query: cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined,
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const createHttpMethodFetcher = (method) => async (params) => {
    const { url, query, variables, operationName, fetch, fetchOptions, middleware } = params;
    const headers = { ...params.headers };
    let queryParams = ``;
    let body = undefined;
    if (method === `POST`) {
        body = createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
        if (typeof body === `string`) {
            // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        }
    }
    else {
        // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = buildRequestConfig({
            query,
            variables,
            operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? defaultJsonSerializer,
        });
    }
    const init = {
        method,
        headers,
        body,
        ...fetchOptions,
    };
    let urlResolved = url;
    let initResolved = init;
    if (middleware) {
        const result = await Promise.resolve(middleware({ ...init, url, operationName, variables }));
        const { url: urlNew, ...initNew } = result;
        urlResolved = urlNew;
        initResolved = initNew;
    }
    if (queryParams) {
        urlResolved = `${urlResolved}?${queryParams}`;
    }
    return await fetch(urlResolved, initResolved);
};
/**
 * GraphQL Client.
 */
class GraphQLClient {
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */
        this.rawRequest = async (...args) => {
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = parseRawRequestArgs(queryOrOptions, variables, requestHeaders);
            const { headers, fetch = browser_ponyfill, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url } = this;
            if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
            }
            const { operationName } = resolveRequestDocument(rawRequestOptions.query);
            return makeRequest({
                url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...resolveHeaders(callOrIdentity(headers)),
                    ...resolveHeaders(rawRequestOptions.requestHeaders),
                },
                operationName,
                fetch,
                method,
                fetchOptions,
                middleware: requestMiddleware,
            })
                .then((response) => {
                if (responseMiddleware) {
                    responseMiddleware(response);
                }
                return response;
            })
                .catch((error) => {
                if (responseMiddleware) {
                    responseMiddleware(error);
                }
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = parseRequestArgs(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = browser_ponyfill, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const { query, operationName } = resolveRequestDocument(requestOptions.document);
        return makeRequest({
            url,
            query,
            variables: requestOptions.variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(requestOptions.requestHeaders),
            },
            operationName,
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        })
            .then((response) => {
            if (responseMiddleware) {
                responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (responseMiddleware) {
                responseMiddleware(error);
            }
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = parseBatchRequestArgs(documentsOrOptions, requestHeaders);
        const { headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const queries = batchRequestOptions.documents.map(({ document }) => resolveRequestDocument(document).query);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        return makeRequest({
            url: this.url,
            query: queries,
            // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(batchRequestOptions.requestHeaders),
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? browser_ponyfill,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        })
            .then((response) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(error);
            }
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
const makeRequest = async (params) => {
    const { query, variables, fetchOptions } = params;
    const fetcher = createHttpMethodFetcher(uppercase(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await getResult(response, fetchOptions.jsonSerializer ?? defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result)
        ? !result.some(({ data }) => !data)
        : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) ||
        !result.errors ||
        (Array.isArray(result.errors) && !result.errors.length) ||
        fetchOptions.errorPolicy === `all` ||
        fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? { data } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status,
        };
    }
    else {
        const errorResult = typeof result === `string`
            ? {
                error: result,
            }
            : result;
        throw new ClientError(
        // @ts-expect-error TODO
        { ...errorResult, status: response.status, headers: response.headers }, { query, variables });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = parseRawRequestExtendedArgs(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
// prettier-ignore
// eslint-disable-next-line
async function request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = parseRequestExtendedArgs(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const createRequestBody = (query, variables, operationName, jsonSerializer) => {
    const jsonSerializer_ = jsonSerializer ?? defaultJsonSerializer;
    if (!Array.isArray(query)) {
        return jsonSerializer_.stringify({ query, variables, operationName });
    }
    if (typeof variables !== `undefined` && !Array.isArray(variables)) {
        throw new Error(`Cannot create request body with given variable type, array expected`);
    }
    // Batch support
    const payload = query.reduce((acc, currentQuery, index) => {
        acc.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const getResult = async (response, jsonSerializer) => {
    let contentType;
    response.headers.forEach((value, key) => {
        if (key.toLowerCase() === `content-type`) {
            contentType = value;
        }
    });
    if (contentType &&
        (contentType.toLowerCase().startsWith(`application/json`) ||
            contentType.toLowerCase().startsWith(`application/graphql+json`) ||
            contentType.toLowerCase().startsWith(`application/graphql-response+json`))) {
        return jsonSerializer.parse(await response.text());
    }
    else {
        return response.text();
    }
};
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
const gql = (chunks, ...variables) => {
    return chunks.reduce((acc, chunk, index) => `${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};



/* harmony default export */ var build_esm = ((/* unused pure expression or super */ null && (request)));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function lib_gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: lib_gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(lib_gql || (lib_gql = {}));
lib_gql["default"] = lib_gql;
/* harmony default export */ var lib = (lib_gql);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./domains/core/storefront/generated/index.ts


function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    fragment Variation on CartDetailsItem {\n  variation: displayVariation {\n    id\n    isSample\n    catalogProductTypeCode\n    images {\n      url\n      role\n    }\n    priceTiers: friendlyPriceTiers {\n      quantity\n      totalAmount\n    }\n    optionValues {\n      optionId\n      valueId\n      name\n    }\n    catalogProduct {\n      name\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    fragment Portfolio on CartDetailsItem {\n  portfolio: portfolioItem {\n    id\n    customizer {\n      urlProofs {\n        url\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        '\n    fragment Accessories on CartDetailsItem {\n  accessories {\n    liner {\n      catalogProductSlug\n      id\n      catalogProduct {\n        name\n      }\n      images(input: {role: {equal: "front"}}) {\n        role\n        url\n      }\n    }\n    plainEnvelope {\n      catalogProductSlug\n      id\n    }\n    printedEnvelope {\n      catalogProductSlug\n      id\n      catalogProduct {\n        name\n      }\n      images(input: {role: {equal: "front"}}) {\n        role\n        url\n      }\n    }\n  }\n}\n    '
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    fragment Pagination on PaginationData {\n  page\n  perPage\n  total\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    query getCart {\n  cart {\n    details {\n      storeCartId\n      items {\n        id\n        quantity\n        totalAmount\n        parentId\n        productTypeName\n        ...Portfolio\n        ...Variation\n        ...Accessories\n      }\n    }\n  }\n}\n    ",
        "\n",
        "\n",
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    query getMenu($menuCode: String!) {\n  menu(filter: {code: {eq: $menuCode}}) {\n    code\n    name\n    treeStructure\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    query getDraftsCount($filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType, $paginate: PaginatorInputArgs, $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType) {\n  draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {\n    items {\n      portfolioItem {\n        isCustomized\n      }\n    }\n    pagination {\n      ...Pagination\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    query getAllDrafts($filter: CatalogProductDraftCollectionResolver_GetDraftCollection_FilterInputType, $paginate: PaginatorInputArgs, $sort: CatalogProductDraftCollectionResolver_GetDraftCollection_SortingInputType) {\n  draftCollection(filter: $filter, paginate: $paginate, sort: $sort) {\n    items {\n      id\n      draftGroupId\n      image\n      price\n      quantity\n      userId\n      updatedAt\n      portfolioItem {\n        id\n        memberId\n        notes\n        tenant\n        customizer {\n          stateId\n          urlPrint\n          urlProofs {\n            position\n            url\n          }\n          userId\n        }\n        isCustomized\n      }\n      variation {\n        id\n        catalogProduct {\n          externalId\n          catalogProductTypeCode\n          name\n          slug\n          catalogProductType {\n            name\n          }\n        }\n        catalogProductSuiteCode\n        images {\n          url\n          order\n          role\n        }\n        optionValues {\n          name\n          optionId\n          valueId\n        }\n        isSample\n      }\n    }\n    pagination {\n      ...Pagination\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    query getProductDetail($input: FindOneProductInput!) {\n  product {\n    findOne(input: $input) {\n      name\n      description\n      slug\n      catalogProductId\n      variations\n      isLive\n      suite {\n        name\n        sku\n        slug\n        collection {\n          name\n          title\n          slug\n          isInBadge\n          isInTitle\n          isInBreadcrumbs\n          isInMatchingSuites\n          color\n          imageUrl\n        }\n        hideProductDetailPages\n      }\n      type {\n        name\n        sku\n        slug\n      }\n      category {\n        name\n        slug\n      }\n      displayOptions {\n        designedBy\n        size {\n          height\n          width\n        }\n      }\n      relatedProducts {\n        index\n        name\n        slug\n        format: productFormat {\n          sku\n          name\n        }\n        variations {\n          colorThemeSku\n          flapTypeSku\n          foilThemeSku\n          paperColorSku\n          paperTypeSku\n          thumbnail\n          variationId\n          optionValues {\n            optionId\n            valueId\n            name\n          }\n        }\n        type {\n          sku\n          name\n          slug\n        }\n      }\n      options {\n        colors {\n          colorHex\n          name\n          slug\n          sku\n        }\n      }\n      productOptions: variationOptions {\n        name\n        optionId\n        values {\n          optionId\n          valueId\n          name\n        }\n      }\n      summary\n      isLive\n      selectedVariant {\n        colorThemeCode\n        envelopePrintingOptionCode\n        foilCode\n        paperTypeCode\n        paperColorCode\n        flapTypeCode\n      }\n      foilSampleVariation {\n        variationId\n        foilTheme\n        paperType\n        colorTheme\n      }\n      productTypeSiblings {\n        name\n        iconUrl\n        priceNotation\n        sizeShortText\n        sku\n        slug\n      }\n      productFormat {\n        name\n        iconUrl\n        priceNotation\n        sizeShortText\n        sku\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    mutation addToDraft($input: InitCanvasInput!) {\n  canvas {\n    initCanvas(input: $input) {\n      id\n      draftId\n    }\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    mutation addToCart($input: AddItemToCartInput!) {\n  cart {\n    addItem(input: $input) {\n      item {\n        portfolioItem {\n          id\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    mutation addItemToCart($input: AddItemToCartInput!) {\n  cart {\n    addItem(input: $input) {\n      cart {\n        storeCartId\n      }\n      item {\n        portfolioItem {\n          id\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    query getAccessories($input: FindOneProductInput!) {\n  product {\n    findOne(input: $input) {\n      suite {\n        name\n        sku\n        slug\n        collection {\n          name\n          title\n          slug\n          isInBadge\n          isInTitle\n          isInBreadcrumbs\n          isInMatchingSuites\n          color\n          imageUrl\n        }\n      }\n      selectedVariant {\n        colorThemeCode\n        foilCode\n        colorThemeCode\n        envelopePrintingOptionCode\n        paperTypeCode\n        paperColorCode\n      }\n      relatedProducts {\n        index\n        name\n        slug\n        format: productFormat {\n          sku\n          name\n        }\n        variations {\n          colorThemeSku\n          flapTypeSku\n          foilThemeSku\n          paperColorSku\n          paperTypeSku\n          thumbnail\n          variationId\n          optionValues {\n            optionId\n            valueId\n            name\n          }\n        }\n        type {\n          sku\n          name\n          slug\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

var Orientation;
(function(Orientation) {
    Orientation["Horizontal"] = "horizontal";
    Orientation["Vertical"] = "vertical";
})(Orientation || (Orientation = {}));
var PortfolioItemFileType;
(function(PortfolioItemFileType) {
    PortfolioItemFileType["Idml"] = "IDML";
    PortfolioItemFileType["Psd"] = "PSD";
})(PortfolioItemFileType || (PortfolioItemFileType = {}));
var SortType;
(function(SortType) {
    SortType["Asc"] = "ASC";
    SortType["Desc"] = "DESC";
})(SortType || (SortType = {}));
var TemplateStatus;
(function(TemplateStatus) {
    TemplateStatus["Archived"] = "ARCHIVED";
    TemplateStatus["Draft"] = "DRAFT";
    TemplateStatus["Published"] = "PUBLISHED";
})(TemplateStatus || (TemplateStatus = {}));
var Tenant;
(function(Tenant) {
    Tenant["Test"] = "TEST";
    Tenant["Tk"] = "TK";
    Tenant["Ww"] = "WW";
})(Tenant || (Tenant = {}));
var VariationFragmentDoc = lib(_templateObject());
var PortfolioFragmentDoc = lib(_templateObject1());
var AccessoriesFragmentDoc = lib(_templateObject2());
var PaginationFragmentDoc = lib(_templateObject3());
var GetCartDocument = lib(_templateObject4(), PortfolioFragmentDoc, VariationFragmentDoc, AccessoriesFragmentDoc);
var GetMenuDocument = lib(_templateObject5());
var GetDraftsCountDocument = lib(_templateObject6(), PaginationFragmentDoc);
var GetAllDraftsDocument = lib(_templateObject7(), PaginationFragmentDoc);
var GetProductDetailDocument = lib(_templateObject8());
var AddToDraftDocument = lib(_templateObject9());
var AddToCartDocument = lib(_templateObject10());
var AddItemToCartDocument = lib(_templateObject11());
var GetAccessoriesDocument = lib(_templateObject12());
var defaultWrapper = function(action, _operationName, _operationType, _variables) {
    return action();
};
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        getCart: function getCart(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetCartDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getCart", "query", variables);
        },
        getMenu: function getMenu(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetMenuDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getMenu", "query", variables);
        },
        getDraftsCount: function getDraftsCount(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetDraftsCountDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getDraftsCount", "query", variables);
        },
        getAllDrafts: function getAllDrafts(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetAllDraftsDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getAllDrafts", "query", variables);
        },
        getProductDetail: function getProductDetail(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetProductDetailDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getProductDetail", "query", variables);
        },
        addToDraft: function addToDraft(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(AddToDraftDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "addToDraft", "mutation", variables);
        },
        addToCart: function addToCart(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(AddToCartDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "addToCart", "mutation", variables);
        },
        addItemToCart: function addItemToCart(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(AddItemToCartDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "addItemToCart", "mutation", variables);
        },
        getAccessories: function getAccessories(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request(GetAccessoriesDocument, variables, (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders));
            }, "getAccessories", "query", variables);
        }
    };
}

;// CONCATENATED MODULE: ./domains/core/storefront/storefront.client.ts
/* provided dependency */ var process = __webpack_require__(37082);


var _INTERNAL_STOREFRONT_API_URL;
var URL = (_INTERNAL_STOREFRONT_API_URL = process.env.INTERNAL_STOREFRONT_API_URL) !== null && _INTERNAL_STOREFRONT_API_URL !== void 0 ? _INTERNAL_STOREFRONT_API_URL : "https://storefront-api.paper.theknot.com/graphql";
var client = new GraphQLClient(URL, {
    credentials: "include",
    headers: {
        "x-tenant": "tk"
    }
});
var storefront = getSdk(client);

// EXTERNAL MODULE: ./lib/lru/index.tsx + 1 modules
var lru = __webpack_require__(49755);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var zod_lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./domains/core/storefront/subnav/subnav.schema.ts

var MenuItem = zod_lib.z.object({
    text: zod_lib.z.string(),
    url: zod_lib.z.string(),
    linkAttributes: zod_lib.z.string().optional(),
    badge: zod_lib.z.object({
        text: zod_lib.z.string()
    }).optional()
});
var BaseTreeItem = zod_lib.z.object({
    menuItem: MenuItem
});
var TreeItem = BaseTreeItem.extend({
    children: zod_lib.z.lazy(function() {
        return zod_lib.z.array(TreeItem);
    }).optional()
});
var Menu = zod_lib.z.object({
    code: zod_lib.z.string().default("subnav"),
    name: zod_lib.z.string().default("Subnav"),
    treeStructure: zod_lib.z.array(TreeItem).default([])
});

;// CONCATENATED MODULE: ./domains/core/storefront/subnav/subnav.query.ts





function getSubnav(params) {
    return _getSubnav.apply(this, arguments);
}
function _getSubnav() {
    _getSubnav = (0,_async_to_generator/* default */.Z)(function(params) {
        var menuCode, cache, data, menuStructure;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    menuCode = params.menuCode;
                    cache = lru/* default.get */.Z.get(menuCode);
                    if (cache) {
                        return [
                            2,
                            cache
                        ];
                    }
                    return [
                        4,
                        storefront.getMenu({
                            menuCode: menuCode
                        })
                    ];
                case 1:
                    data = _state.sent();
                    menuStructure = Menu.safeParse(data.menu);
                    if (menuStructure.success) {
                        lru/* default.set */.Z.set(menuCode, menuStructure.data);
                        return [
                            2,
                            menuStructure.data
                        ];
                    } else {
                        throw new Error("Invalid menu structure: ".concat(menuStructure.error.message));
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _getSubnav.apply(this, arguments);
}

;// CONCATENATED MODULE: ./pages/_app.tsx



var ref;





















var WebviewTag = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1006).then(__webpack_require__.bind(__webpack_require__, 61006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61006)
            ];
        }
    },
    ssr: true
});
var Web = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(6884), __webpack_require__.e(5089), __webpack_require__.e(7239), __webpack_require__.e(4511), __webpack_require__.e(1471), __webpack_require__.e(2018), __webpack_require__.e(3458), __webpack_require__.e(3020), __webpack_require__.e(198), __webpack_require__.e(5042), __webpack_require__.e(8157), __webpack_require__.e(7361), __webpack_require__.e(6593), __webpack_require__.e(8018), __webpack_require__.e(7155), __webpack_require__.e(2311), __webpack_require__.e(8535), __webpack_require__.e(9916), __webpack_require__.e(3023), __webpack_require__.e(9951), __webpack_require__.e(2573), __webpack_require__.e(2775), __webpack_require__.e(1963)]).then(__webpack_require__.bind(__webpack_require__, 11913)).then(function(m) {
        return m.Web;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11913)
            ];
        }
    },
    ssr: true
});
var Webview = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(6884), __webpack_require__.e(5089), __webpack_require__.e(7239), __webpack_require__.e(4511), __webpack_require__.e(1471), __webpack_require__.e(2018), __webpack_require__.e(3458), __webpack_require__.e(3020), __webpack_require__.e(198), __webpack_require__.e(5042), __webpack_require__.e(8157), __webpack_require__.e(7361), __webpack_require__.e(6593), __webpack_require__.e(8018), __webpack_require__.e(7155), __webpack_require__.e(2311), __webpack_require__.e(8535), __webpack_require__.e(9916), __webpack_require__.e(3023), __webpack_require__.e(9951), __webpack_require__.e(2573), __webpack_require__.e(2775), __webpack_require__.e(3989)]).then(__webpack_require__.bind(__webpack_require__, 23989)).then(function(m) {
        return m.Webview;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23989)
            ];
        }
    },
    ssr: true
});
var TKVariables = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 768).then(__webpack_require__.bind(__webpack_require__, 60768));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60768)
            ];
        }
    },
    ssr: true
});
var WWVariables = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9582).then(__webpack_require__.bind(__webpack_require__, 59582));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59582)
            ];
        }
    },
    ssr: true
});
var CosmoBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6826).then(__webpack_require__.bind(__webpack_require__, 6826)).then(function(m) {
        return m.CosmoBox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6826)
            ];
        }
    }
});
var PageNotFoundComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6884), __webpack_require__.e(4511), __webpack_require__.e(3020), __webpack_require__.e(198), __webpack_require__.e(5042), __webpack_require__.e(7361), __webpack_require__.e(6593), __webpack_require__.e(347), __webpack_require__.e(6943)]).then(__webpack_require__.bind(__webpack_require__, 96943)).then(function(mod) {
        return (0,config_constants/* isTenant */.J)("tk") ? mod.default : mod.PageNotFoundWW;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96943)
            ];
        }
    },
    ssr: true
});
var appEnv = ((ref = "foundation-production") === null || ref === void 0 ? void 0 : ref.toUpperCase()) || "DEVELOPMENT";
if (false) {}
var GlobalVariables = (0,config_constants/* isTenant */.J)("tk") ? TKVariables : WWVariables;
var BaseApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref, ref1;
    var deviceMode = pageProps.deviceMode, layout = pageProps.layout, error = pageProps.error, seoTags = pageProps.seoTags, userProfile = pageProps.userProfile, isApp = pageProps.isApp, shouldReloadPage = pageProps.shouldReloadPage, variants = pageProps.variants, features = pageProps.features, cookies = pageProps.cookies, referrer = pageProps.referrer, pencil = pageProps.pencil, subNav = pageProps.subNav;
    var ref2 = (0,router.useRouter)(), replace = ref2.replace, asPath = ref2.asPath;
    // Enforce the right tracking mechanism
    // Change the "enforce" value to "mobile app ios" or "mobile app android" for mobile app issues :)
    (0,tracker/* initializeTracking */.e)({
        enforce: deviceMode,
        log: /(development|foundation-staging|qa)/i.test(appEnv)
    });
    (0,react.useEffect)(function() {
        if (shouldReloadPage) {
            replace(asPath);
        }
    }, [
        asPath,
        replace,
        shouldReloadPage
    ]);
    (0,react.useEffect)(function() {
        if (/(development)/i.test(appEnv)) {
            globalThis.window.fbq = function() {
                return console.warn("fbq is being mocked");
            };
        }
    }, []);
    if (error && !shouldReloadPage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNotFoundComponent, {
            userProfile: userProfile
        });
    }
    var Layout = (layout === null || layout === void 0 ? void 0 : layout.name) === pages.Layouts.WebView ? Webview : Web;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(membershipAuth/* MembershipProvider */.$M, {
        cookies: cookies,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(honeybadger_react_esm/* HoneybadgerErrorBoundary */.t, {
            honeybadger: honeybadger_service["default"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                    children: (layout === null || layout === void 0 ? void 0 : (ref = layout.snippets) === null || ref === void 0 ? void 0 : ref.commerceDataSnippet) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WebviewTag, {
                        webviewDataJson: layout === null || layout === void 0 ? void 0 : (ref1 = layout.snippets) === null || ref1 === void 0 ? void 0 : ref1.commerceDataSnippet
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppProviders, {
                    features: features,
                    platform: deviceMode,
                    user: userProfile,
                    referrer: referrer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CosmoBox, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlipperProvider/* FlipperProvider */.Q, {
                            variants: variants,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProvider/* UserProvider */.d, {
                                user: userProfile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalVariables, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(usePromotions/* PromotionsProvider */.C, {
                                            promotions: PROMOTIONS,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                Component: Component,
                                                deviceMode: deviceMode,
                                                layout: layout,
                                                seoTags: seoTags,
                                                userProfile: userProfile,
                                                isApp: isApp,
                                                shouldReloadPage: shouldReloadPage,
                                                features: features,
                                                pageProps: pageProps,
                                                pencil: pencil,
                                                subNav: subNav
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlaySpinner, {})
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var partialCommonPageProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ctx, ref, req, res, isServerSide, experimentService, cookies, cosmoBoxBrand, referrer, variants, features, shouldReloadPage, layout, deviceMode, isApp, ref1, ref2, ref3, ref4, ref5, ref6, fullstory, refreshSession, ref7, isWeddingWireApp, getLayout, isAndroidApp, isIOSWebview, refresh, ref8, getAllFeatures, excludedIncludedPromise, fullVariants, _layout, ref9, featuresResolved, ref10, excluded, included, setCookie, cookiesToSet, fs, subNav;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx;
                    req = ctx.req, res = ctx.res;
                    isServerSide = !!req && !!res;
                    experimentService = flipper_service/* ExperimentService.forRoot */.$.forRoot({});
                    cookies = (req === null || req === void 0 ? void 0 : req.headers.cookie) || "";
                    cosmoBoxBrand = config_constants/* CONFIG.tenant.shortName.toUpperCase */.k.tenant.shortName.toUpperCase() || "TK";
                    referrer = undefined;
                    variants = flipper_service/* ExperimentService.cookies */.$.cookies();
                    features = {};
                    shouldReloadPage = false;
                    layout = undefined;
                    deviceMode = "desktop web";
                    isApp = false;
                    if (!isServerSide) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        Promise.all([
                            Promise.all(/* import() */[__webpack_require__.e(4023), __webpack_require__.e(7239), __webpack_require__.e(4991), __webpack_require__.e(4511), __webpack_require__.e(8157), __webpack_require__.e(6338), __webpack_require__.e(744)]).then(__webpack_require__.bind(__webpack_require__, 30409)).then(function(m) {
                                return m.fullstory;
                            }),
                            __webpack_require__.e(/* import() */ 1363).then(__webpack_require__.bind(__webpack_require__, 21363)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59837))
                        ])
                    ];
                case 1:
                    ref6 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), fullstory = ref6[0], refreshSession = ref6[1].refreshSession, ref7 = ref6[2], isWeddingWireApp = ref7.isWeddingWireApp, getLayout = ref7.getLayout, isAndroidApp = ref7.isAndroidApp, isIOSWebview = ref7.isIOSWebview;
                    return [
                        4,
                        refreshSession(ctx)
                    ];
                case 2:
                    refresh = _state.sent();
                    //Calculate which device is loading the page and set the Layout conditions.
                    isApp = isWeddingWireApp(req === null || req === void 0 ? void 0 : req.headers);
                    deviceMode = function() {
                        var ref;
                        if (isIOSWebview(req === null || req === void 0 ? void 0 : req.headers)) return "mobile app ios";
                        if (isAndroidApp(req === null || req === void 0 ? void 0 : req.headers)) return "mobile app android";
                        if ((0,helpers/* isMobileUserAgent */.r3)(req === null || req === void 0 ? void 0 : (ref = req.headers) === null || ref === void 0 ? void 0 : ref["user-agent"])) return "mobile web";
                        return "desktop web";
                    }();
                    if (deviceMode === "mobile app ios" || deviceMode === "mobile app android") {
                        referrer = req === null || req === void 0 ? void 0 : req.headers.referer;
                    }
                    return [
                        4,
                        Promise.all([
                            Promise.all(/* import() */[__webpack_require__.e(4991), __webpack_require__.e(5363), __webpack_require__.e(5453), __webpack_require__.e(8648)]).then(__webpack_require__.bind(__webpack_require__, 88648)).then(function(m) {
                                return m.getAllFeatures;
                            }),
                            fullstory.initExperiment(((ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.headers) === null || ref2 === void 0 ? void 0 : ref2.cookie) || ""),
                            experimentService.initialize((ref3 = ctx.req) === null || ref3 === void 0 ? void 0 : ref3.headers, ctx.pathname, ctx.asPath),
                            getLayout(req === null || req === void 0 ? void 0 : req.headers)
                        ])
                    ];
                case 3:
                    ref8 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), getAllFeatures = ref8[0], excludedIncludedPromise = ref8[1], fullVariants = ref8[2], _layout = ref8[3];
                    layout = _layout;
                    variants = fullVariants;
                    return [
                        4,
                        Promise.all([
                            getAllFeatures((ref4 = ctx.req) === null || ref4 === void 0 ? void 0 : ref4.headers.cookie),
                            excludedIncludedPromise
                        ])
                    ];
                case 4:
                    ref9 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), featuresResolved = ref9[0], ref10 = ref9[1], excluded = ref10.excluded, included = ref10.included;
                    features = featuresResolved;
                    experimentService.addToSkipList(excluded);
                    //Set cookies
                    shouldReloadPage = refresh.shouldReloadPage;
                    setCookie = refresh.setCookie;
                    cookiesToSet = [
                        setCookie,
                        experimentService.variantsCookie,
                        experimentService.anonymousIdCookie
                    ].filter(Boolean);
                    fs = fullVariants === null || fullVariants === void 0 ? void 0 : fullVariants[included];
                    if (fs) {
                        cookiesToSet.push(fullstory.setCookie(fs.variantId));
                    }
                    (ref5 = ctx.res) === null || ref5 === void 0 ? void 0 : ref5.setHeader("Set-Cookie", cookiesToSet);
                    return [
                        3,
                        6
                    ];
                case 5:
                    if (window === null || window === void 0 ? void 0 : (ref = window.navigator) === null || ref === void 0 ? void 0 : ref.userAgent) {
                        if ((0,helpers/* isMobileUserAgent */.r3)(window.navigator.userAgent)) {
                            deviceMode = "mobile web";
                        } else {
                            deviceMode = "desktop web";
                        }
                    }
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        getSubnav({
                            menuCode: "MainMenuWithDayOf"
                        })
                    ];
                case 7:
                    subNav = _state.sent();
                    return [
                        2,
                        {
                            pageProps: {
                                deviceMode: deviceMode,
                                layout: layout || {},
                                isApp: isApp,
                                shouldReloadPage: shouldReloadPage,
                                variants: variants,
                                cookies: cookies,
                                features: features,
                                cosmoboxProps: {
                                    brand: cosmoBoxBrand,
                                    country: "US"
                                },
                                referrer: referrer,
                                subNav: subNav
                            }
                        }
                    ];
            }
        });
    });
    return function partialCommonPageProps(_) {
        return _ref.apply(this, arguments);
    };
}();
BaseApp.getInitialProps = partialCommonPageProps;
/* harmony default export */ var _app = (BaseApp);


/***/ }),

/***/ 55288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TB": function() { return /* binding */ getCartDraftsCounters; },
  "PX": function() { return /* binding */ moveDraftToCart; },
  "hG": function() { return /* binding */ removeDraft; },
  "Cn": function() { return /* binding */ upsertDraftItem; }
});

// UNUSED EXPORTS: fetchAllDrafts, getDraftItemCount, moveCartItemToDrafts

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var src_instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(72730);
// EXTERNAL MODULE: ./domains/core/storefront/legacy/index.ts
var legacy = __webpack_require__(70014);
;// CONCATENATED MODULE: ./graphql/drafts.ts
var RemoveDraftGroup = "\n  mutation RemoveDraftGroup($input: DeleteDraftGroupInput!) {\n    drafts {\n      removeItemsByDraftGroup(input: $input) {\n        count\n      }\n    }\n  }\n";
var RemoveDraft = "\n  mutation RemoveDraft($input: DeleteDraftsItemInput!) {\n    drafts {\n      removeItem(input: $input) {\n        id\n      }\n    }\n  }\n";
var drafts_DraftsCount = "\n  query getDraftsCount {\n    drafts {\n      findAllForUser {\n        count\n      }\n    }\n  }\n";
var drafts_FindAllDrafts = "\n  query findAllDrafts {\n    drafts {\n      findAllForUser {\n        count\n        items {\n          id\n          draftGroupId\n          image\n          updatedAt\n          portfolioItem {\n            id\n            memberId\n            notes\n            tenant\n            customizer {\n              stateId\n              urlPrint\n              urlProofs {\n                position\n                url\n              }\n              userId\n            }\n            variation {\n              id\n              catalogProductId\n              colorThemeCode\n              optionValues {\n                name\n                valueId\n                optionId\n              }\n              envelopePrintingOptionCode\n              flapTypeCode\n              foilCode\n              isSample\n              paperColorCode\n              paperTypeCode\n              productCode\n              suiteCode\n              tenant\n              variationImages {\n                imageUrl\n                tag\n              }\n              product {\n                name\n                slug\n                type {\n                  name\n                }\n              }\n            }\n          }\n          price\n          quantity\n        }\n      }\n    }\n  }\n";
var MoveToCart = "\n  mutation moveToCart($input: AddDraftToCartInput!) {\n    draftCart {\n      moveDraftItemToCart(input: $input) {\n        cart {\n          currencyCode\n          storeCartId\n          totalAmount\n          items {\n            id\n            quantity\n            price {\n              basePrice\n            }\n          }\n        }\n        item {\n          catalogProductId\n          collectionName\n          colorThemeName\n          envelopePrintingName\n          foilThemeName\n          id\n          paperTypeName\n          parentId\n          productName\n          productTypeName\n          slug\n          price {\n            basePrice\n          }\n          portfolioItem {\n            customizer {\n              urlProofs {\n                url\n              }\n            }\n          }\n          variation {\n            id\n            catalogProductId\n            colorThemeName\n            colorThemeCode\n            envelopePrintingOptionCode\n            envelopePrintingOptionName\n            flapTypeCode\n            foilCode\n            foilName\n            isSample\n            paperColorCode\n            paperTypeCode\n            paperTypeName\n            productCode\n            suiteCode\n            tenant\n            product {\n              name\n              productFormat {\n                name\n              }\n            }\n            optionValues {\n              name\n              optionId\n              valueId\n            }\n          }\n        }\n      }\n    }\n  }\n";
var drafts_MoveToDraft = "\n  mutation MoveToDraft($itemId: String!) {\n    draftCart {\n      moveCartItemToDrafts(itemId: $itemId) {\n        cart {\n          storeCartId\n        }\n        draft {\n          id\n        }\n      }\n    }\n  }\n";
var UpsertDraftItem = "\n  mutation UpsertDraftItem($input: UpsertItemToDraftsInput!) {\n    drafts {\n      upsertItem(input: $input) {\n        id\n      }\n    }\n  }\n";

;// CONCATENATED MODULE: ./graphql/general.ts
var CartDraftsCounters = "\n  query getCartDraftsCounters($includeDrafts: Boolean!) {\n    cart {\n      itemCount\n    }\n    drafts @include(if: $includeDrafts) {\n      findAllForUser {\n        count\n      }\n    }\n  }\n";
var CartCounter = "\n  query getCartCounter {\n    cart {\n      itemCount\n    }\n  }\n";

// EXTERNAL MODULE: ./utils/config/config.constants.ts
var config_constants = __webpack_require__(76806);
// EXTERNAL MODULE: ./node_modules/@honeybadger-io/js/dist/browser/honeybadger.js
var honeybadger = __webpack_require__(5417);
var honeybadger_default = /*#__PURE__*/__webpack_require__.n(honeybadger);
;// CONCATENATED MODULE: ./services/storefront/drafts/drafts.ts








function getGuestCounters(headers) {
    return _getGuestCounters.apply(this, arguments);
}
function _getGuestCounters() {
    _getGuestCounters = //Guest or WW user
    (0,src_async_to_generator/* default */.Z)(function(headers) {
        var ref, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(CartCounter, null, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            cart: (response === null || response === void 0 ? void 0 : (ref = response.cart) === null || ref === void 0 ? void 0 : ref.itemCount) || 0,
                            drafts: 0
                        }
                    ];
            }
        });
    });
    return _getGuestCounters.apply(this, arguments);
}
function getMemberCounters(variables, headers) {
    return _getMemberCounters.apply(this, arguments);
}
function _getMemberCounters() {
    _getMemberCounters = (0,src_async_to_generator/* default */.Z)(function(variables, headers) {
        var ref, ref1, ref2, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(CartDraftsCounters, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            cart: (response === null || response === void 0 ? void 0 : (ref = response.cart) === null || ref === void 0 ? void 0 : ref.itemCount) || 0,
                            drafts: (response === null || response === void 0 ? void 0 : (ref1 = response.drafts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.findAllForUser) === null || ref2 === void 0 ? void 0 : ref2.count) || 0
                        }
                    ];
            }
        });
    });
    return _getMemberCounters.apply(this, arguments);
}
function getCartDraftsCounters(includeDrafts, headers) {
    return _getCartDraftsCounters.apply(this, arguments);
}
function _getCartDraftsCounters() {
    _getCartDraftsCounters = (0,src_async_to_generator/* default */.Z)(function(includeDrafts, headers) {
        var counters, variables, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    counters = {
                        cart: 0,
                        drafts: 0
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    if (!(includeDrafts && (0,config_constants/* isTenant */.J)("tk"))) return [
                        3,
                        3
                    ];
                    variables = {
                        includeDrafts: includeDrafts
                    };
                    return [
                        4,
                        getMemberCounters(variables, headers)
                    ];
                case 2:
                    counters = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        getGuestCounters(headers)
                    ];
                case 4:
                    counters = _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    e = _state.sent();
                    honeybadger_default().notify(e, {
                        name: "getCartDraftsCountersError: ".concat(e === null || e === void 0 ? void 0 : e.message),
                        message: e === null || e === void 0 ? void 0 : e.message,
                        context: {
                            headers: headers,
                            includeDrafts: includeDrafts
                        }
                    });
                    return [
                        3,
                        8
                    ];
                case 7:
                    // eslint-disable-next-line no-unsafe-finally
                    return [
                        2,
                        counters
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _getCartDraftsCounters.apply(this, arguments);
}
function fetchAllDrafts(headers) {
    return _fetchAllDrafts.apply(this, arguments);
}
function _fetchAllDrafts() {
    _fetchAllDrafts = _async_to_generator(function(headers) {
        var ref, response, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        storefrontAPIFetch(FindAllDrafts, null, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        (response === null || response === void 0 ? void 0 : (ref = response.drafts) === null || ref === void 0 ? void 0 : ref.findAllForUser) || {}
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    if (!_instanceof(e, Error)) return [
                        2,
                        null
                    ];
                    Honeybadger.notify(e, {
                        name: "fetchAllDrafts @ modules/core/services/api/drafts.ts",
                        message: e === null || e === void 0 ? void 0 : e.message
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _fetchAllDrafts.apply(this, arguments);
}
function removeDraft(id, headers) {
    return _removeDraft.apply(this, arguments);
}
function _removeDraft() {
    _removeDraft = (0,src_async_to_generator/* default */.Z)(function(id, headers) {
        var variables, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    variables = {
                        input: {
                            itemId: id
                        }
                    };
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(RemoveDraft, variables, headers)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    if (!(0,src_instanceof/* default */.Z)(e, Error)) return [
                        2,
                        null
                    ];
                    console.error(e);
                    honeybadger_default().notify(e, {
                        name: "moveToCart @ modules/core/services/api/drafts.ts",
                        message: e === null || e === void 0 ? void 0 : e.message
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _removeDraft.apply(this, arguments);
}
function moveDraftToCart(input, headers) {
    return _moveDraftToCart.apply(this, arguments);
}
function _moveDraftToCart() {
    _moveDraftToCart = (0,src_async_to_generator/* default */.Z)(function(input, headers) {
        var variables, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    variables = {
                        input: input
                    };
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(MoveToCart, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            cart: response.draftCart.moveDraftItemToCart.cart,
                            item: response.draftCart.moveDraftItemToCart.item
                        }
                    ];
            }
        });
    });
    return _moveDraftToCart.apply(this, arguments);
}
function moveCartItemToDrafts(itemId) {
    return _moveCartItemToDrafts.apply(this, arguments);
}
function _moveCartItemToDrafts() {
    _moveCartItemToDrafts = _async_to_generator(function(itemId) {
        var variables;
        return _ts_generator(this, function(_state) {
            variables = {
                itemId: itemId
            };
            return [
                2,
                storefrontAPIFetch(MoveToDraft, variables)
            ];
        });
    });
    return _moveCartItemToDrafts.apply(this, arguments);
}
function getDraftItemCount(headers) {
    return _getDraftItemCount.apply(this, arguments);
}
function _getDraftItemCount() {
    _getDraftItemCount = _async_to_generator(function(headers) {
        var ref, response, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        storefrontAPIFetch(DraftsCount, null, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        ((ref = response.drafts) === null || ref === void 0 ? void 0 : ref.findAllForUser.count) || 0
                    ];
                case 2:
                    e = _state.sent();
                    console.error(e);
                    if (!_instanceof(e, Error)) return [
                        2,
                        0
                    ];
                    Honeybadger.notify(e, {
                        name: "fetchAllDrafts @ modules/core/services/api/drafts.ts",
                        message: e === null || e === void 0 ? void 0 : e.message
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        0
                    ];
            }
        });
    });
    return _getDraftItemCount.apply(this, arguments);
}
function upsertDraftItem(variables, headers) {
    return _upsertDraftItem.apply(this, arguments);
}
function _upsertDraftItem() {
    _upsertDraftItem = (0,src_async_to_generator/* default */.Z)(function(variables, headers) {
        var response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,legacy/* storefrontAPIFetch */.s3)(UpsertDraftItem, variables, headers)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.drafts.upsertItem
                    ];
                case 2:
                    e = _state.sent();
                    if ((0,src_instanceof/* default */.Z)(e, Error)) {
                        honeybadger_default().notify("Failed to upsert draft item", {
                            message: e.message,
                            context: {
                                variables: variables
                            }
                        });
                    }
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _upsertDraftItem.apply(this, arguments);
}


/***/ }),

/***/ 96399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sg": function() { return /* binding */ useOverlaySpinner; },
/* harmony export */   "nD": function() { return /* binding */ isSpinnerShownAtom; },
/* harmony export */   "oj": function() { return /* binding */ spinnerElementAtom; }
/* harmony export */ });
/* unused harmony export spinnerActionsAtom */
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70024);

var isSpinnerShownAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(false);
var spinnerElementAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null);
// Writeable atom to handle showing/hiding the spinner
var spinnerActionsAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(null, function(get, set, param) {
    var show = param.show, element = param.element;
    set(isSpinnerShownAtom, show);
    set(spinnerElementAtom, show ? element || null : null);
});
function useOverlaySpinner() {
    var setSpinner = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .useSetAtom */ .b9)(spinnerActionsAtom);
    return {
        setSpinner: setSpinner
    };
}


/***/ }),

/***/ 74504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ trackNewRegistration; },
/* harmony export */   "Eu": function() { return /* binding */ trackDraftDeleted; },
/* harmony export */   "I0": function() { return /* binding */ typewriterErrorHandler; },
/* harmony export */   "Ix": function() { return /* binding */ trackCtaClickedReview; },
/* harmony export */   "L_": function() { return /* binding */ trackingString; },
/* harmony export */   "O2": function() { return /* binding */ trackCouponDenied; },
/* harmony export */   "Oy": function() { return /* binding */ trackRegistrationFormDisplayed; },
/* harmony export */   "QG": function() { return /* binding */ trackCouponApplied; },
/* harmony export */   "Qt": function() { return /* binding */ trackExperimentStarted; },
/* harmony export */   "Rf": function() { return /* binding */ trackOrderCompleted; },
/* harmony export */   "V$": function() { return /* binding */ trackProductsSearched; },
/* harmony export */   "V4": function() { return /* binding */ createAnalyticsVariant; },
/* harmony export */   "Wg": function() { return /* binding */ trackShippingInfoEntered; },
/* harmony export */   "bQ": function() { return /* binding */ trackLogIn; },
/* harmony export */   "bg": function() { return /* binding */ trackCouponRemoved; },
/* harmony export */   "fg": function() { return /* binding */ trackDraftListViewed; },
/* harmony export */   "g_": function() { return /* binding */ trackLogInFormDisplayed; },
/* harmony export */   "kK": function() { return /* binding */ trackMenuInteraction; },
/* harmony export */   "l9": function() { return /* binding */ trackProductAdded; },
/* harmony export */   "lG": function() { return /* binding */ trackCtaClicked; },
/* harmony export */   "oX": function() { return /* binding */ trackPromotionViewed; },
/* harmony export */   "qY": function() { return /* binding */ trackCouponEntered; },
/* harmony export */   "r3": function() { return /* binding */ isMobileUserAgent; },
/* harmony export */   "xn": function() { return /* binding */ trackPromotionClicked; },
/* harmony export */   "yv": function() { return /* binding */ trackMovetoCartFromDrafts; },
/* harmony export */   "z1": function() { return /* binding */ trackCustomizationReviewInitialized; }
/* harmony export */ });
/* unused harmony exports createAnalyticsUserData, createHeroImageUrl, trackAddPlainEnvelopes, trackCartAddPlainEnvelopes, trackCartViewed, trackCheckoutStarted, trackProductDelete, trackProductMoved, trackQuickLook */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72730);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96645);
/* harmony import */ var _modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31074);
/* harmony import */ var _modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21170);
/* harmony import */ var _modules_core_services_impact__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58314);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5417);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__);











var BASE_PROPERTIES = {
    selection: "paper"
};
function trackingString(text) {
    if (!text) return "";
    return text.replace(/\s/g, "_").toLowerCase();
}
function createAnalyticsUserData() {
    var ref, ref1;
    var userId = getCookieByName((ref = window.document) === null || ref === void 0 ? void 0 : ref.cookie, "ajs_user_id") || "unidentified";
    var anonymousId = getCookieByName((ref1 = window.document) === null || ref1 === void 0 ? void 0 : ref1.cookie, "ajs_anonymous_id") || "unidentified";
    var ref2, ref3;
    return {
        userId: (ref2 = userId.replace(/["]/g, "")) !== null && ref2 !== void 0 ? ref2 : "",
        anonymousId: (ref3 = anonymousId.replace(/["]/g, "")) !== null && ref3 !== void 0 ? ref3 : ""
    };
}
function typewriterErrorHandler(event, data) {
    try {
        event.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(data));
    } catch (e) {
        var errorName = "TypewriterError";
        _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().notify(e, {
            name: errorName,
            fingerprint: errorName,
            context: {
                event: event.name,
                data: data
            },
            message: e === null || e === void 0 ? void 0 : e.message
        });
    }
}
function trackCartViewed(eventData) {
    var data = _object_spread({}, eventData);
    typewriterErrorHandler(typewriter.cartViewed, [
        data
    ]);
}
function trackCheckoutStarted(eventData) {
    var data = _object_spread({}, eventData);
    typewriterErrorHandler(typewriter.checkoutStarted, [
        data
    ]);
}
function trackLogIn(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        selection: "save draft",
        platform: (eventData === null || eventData === void 0 ? void 0 : eventData.platform) || ""
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].logIn, [
        data
    ]);
}
function trackLogInFormDisplayed(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        platform: (eventData === null || eventData === void 0 ? void 0 : eventData.platform) || ""
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].logInFormDisplayed, [
        data
    ]);
}
function trackNewRegistration(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        selection: "save draft",
        platform: (eventData === null || eventData === void 0 ? void 0 : eventData.platform) || ""
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].newRegistration, [
        data
    ]);
}
function trackRegistrationFormDisplayed(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        platform: (eventData === null || eventData === void 0 ? void 0 : eventData.platform) || ""
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].registrationFormDisplayed, [
        data
    ]);
}
function trackAddPlainEnvelopes(eventData) {
    var data = _object_spread({
        category: "Plain Wedding Invitations Envelopes",
        price: 0
    }, eventData);
    typewriterErrorHandler(typewriter.productAdded, [
        data
    ]);
}
function trackCartAddPlainEnvelopes(eventData) {
    var data = _object_spread({
        price: 0,
        location: "cart"
    }, eventData);
    typewriterErrorHandler(typewriter.productAdded, [
        data
    ]);
}
function trackMovetoCartFromDrafts(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        source: "drafts"
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].productAdded, [
        data
    ]);
}
function trackProductAdded(eventData) {
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].productAdded, [
        eventData
    ]);
}
function trackProductMoved(eventData) {
    var data = _object_spread({
        destination: "drafts",
        source: "cart"
    }, eventData);
    typewriterErrorHandler(typewriter.productMoved, [
        data
    ]);
}
function trackProductDelete(eventData) {
    var data = _object_spread({
        location: "cart"
    }, eventData);
    typewriterErrorHandler(typewriter.productRemoved, [
        data
    ]);
}
var trackPromotionViewed = function(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].promotionViewed, [
        data
    ]);
};
var trackProductsSearched = function(eventData, callback) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData, BASE_PROPERTIES);
    return new Promise(function(resolve) {
        typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].productsSearched, [
            data,
            undefined,
            callback
        ]);
        resolve(true);
    });
};
var trackPromotionClicked = function(eventData, callback) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData);
    return new Promise(function(resolve) {
        typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].promotionClicked, [
            data,
            undefined,
            callback
        ]);
        resolve(true);
    });
};
function trackShippingInfoEntered(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].informationEntered, [
        data
    ]);
}
function trackCouponApplied(eventData) {
    var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData), {
        coupon_name: eventData.coupon
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].couponApplied, [
        data
    ]);
}
function trackCouponDenied(eventData) {
    var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData), {
        coupon_name: eventData.coupon
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].couponDenied, [
        data
    ]);
}
function trackCouponRemoved(eventData) {
    var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData), {
        coupon_name: eventData.coupon
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].couponRemoved, [
        data
    ]);
}
var trackOrderCompleted = function(rawData, email, customerId, customerStatus) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var affiliation = rawData.affiliation, memberId = rawData.memberId, platform = rawData.platform, product = rawData.product, eventData = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(rawData, [
        "affiliation",
        "memberId",
        "platform",
        "product"
    ]);
    var revenue = +((ref = +(eventData === null || eventData === void 0 ? void 0 : eventData.subtotal_ex_tax)) === null || ref === void 0 ? void 0 : ref.toFixed(2));
    var discount = +((ref1 = +(eventData === null || eventData === void 0 ? void 0 : eventData.coupon_discount)) === null || ref1 === void 0 ? void 0 : ref1.toFixed(2));
    var subtotal = revenue - discount;
    var message = {
        products: eventData === null || eventData === void 0 ? void 0 : (ref2 = eventData.products) === null || ref2 === void 0 ? void 0 : ref2.map(function(product, index) {
            try {
                var ref, ref1, ref2;
                var metaOption = product.product_options.find(function(opt) {
                    return /metadata/i.test(opt.display_name);
                });
                var meta = JSON.parse(metaOption.display_value);
                var optionValues = meta === null || meta === void 0 ? void 0 : meta.optionValues;
                var url = (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_6__/* .createAnalyticsUrl */ .bT)(meta === null || meta === void 0 ? void 0 : meta.slug);
                return {
                    product_id: meta === null || meta === void 0 ? void 0 : meta.catalogProductId,
                    sku: meta === null || meta === void 0 ? void 0 : meta.variationId,
                    category: (meta === null || meta === void 0 ? void 0 : meta.productTypeName) || "",
                    name: meta === null || meta === void 0 ? void 0 : meta.productName,
                    price: +(+product.total_ex_tax).toFixed(2),
                    quantity: product.quantity,
                    coupon: (product === null || product === void 0 ? void 0 : (ref = product.applied_discounts) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.code) || "",
                    position: index + 1,
                    url: url,
                    image_url: meta === null || meta === void 0 ? void 0 : (ref2 = meta.productPhotos) === null || ref2 === void 0 ? void 0 : ref2.hero,
                    sample: meta === null || meta === void 0 ? void 0 : meta.isSample,
                    variant: createAnalyticsVariant(optionValues, meta.productCode)
                };
            } catch (e) {
                return null;
            }
        }).filter(Boolean),
        coupon: (eventData === null || eventData === void 0 ? void 0 : (ref3 = eventData.coupons) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.code) || "",
        currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency_code,
        order_id: eventData === null || eventData === void 0 ? void 0 : (ref5 = eventData.id) === null || ref5 === void 0 ? void 0 : ref5.toString(),
        revenue: revenue,
        discount: discount,
        subtotal: subtotal,
        shipping: +((ref6 = +(eventData === null || eventData === void 0 ? void 0 : eventData.shipping_cost_ex_tax)) === null || ref6 === void 0 ? void 0 : ref6.toFixed(2)),
        tax: +((ref7 = +(eventData === null || eventData === void 0 ? void 0 : eventData.subtotal_tax)) === null || ref7 === void 0 ? void 0 : ref7.toFixed(2)),
        total: +((ref8 = +(eventData === null || eventData === void 0 ? void 0 : eventData.total_inc_tax)) === null || ref8 === void 0 ? void 0 : ref8.toFixed(2)),
        affiliation: affiliation,
        platform: platform
    };
    var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, message), {
        email: email,
        affiliation: affiliation,
        memberId: memberId,
        platform: platform,
        product: product
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].orderCompleted, [
        data
    ]);
    (0,_modules_core_services_impact__WEBPACK_IMPORTED_MODULE_7__/* .trackConversionToImpact */ .bj)(data, customerId, customerStatus);
};
function trackMenuInteraction(eventData) {
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        source: "subnav"
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].menuInteraction, [
        data
    ]);
}
function trackCtaClicked(eventData) {
    return _trackCtaClicked.apply(this, arguments);
}
function _trackCtaClicked() {
    _trackCtaClicked = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(eventData) {
        var eventPayload;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            eventPayload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData);
            typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].ctaClicked, [
                eventPayload
            ]);
            return [
                2
            ];
        });
    });
    return _trackCtaClicked.apply(this, arguments);
}
function trackCtaClickedReview(eventData) {
    var eventPayload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        element_clicked: "link",
        location: "review",
        reason: "upsell"
    }, eventData);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].ctaClicked, [
        eventPayload
    ]);
}
function trackQuickLook(eventData) {
    var eventPayload = _object_spread({}, eventData);
    typewriterErrorHandler(typewriter.productQuicklooked, [
        eventPayload
    ]);
}
function trackCouponEntered(eventData) {
    var eventPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, eventData), {
        coupon_name: eventData.coupon
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].couponEntered, [
        eventPayload
    ]);
}
function trackDraftDeleted(trackingData, draft) {
    var portfolioItem = draft.portfolioItem, variation = draft.variation;
    var optionValues = variation === null || variation === void 0 ? void 0 : variation.optionValues;
    var eventPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, trackingData), {
        name: variation.catalogProduct.name,
        draft_id: draft.id,
        price: Number(draft.price),
        quantity: draft.quantity,
        category: variation.catalogProduct.catalogProductType.name,
        url: "".concat("https://www.theknot.com").concat("/paper").concat("/your-drafts"),
        portfolio_item_id: portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.id,
        sample_details: [
            {
                is_sample: variation.isSample,
                personalized: variation.isSample && !!(portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.customizer) || undefined
            }, 
        ],
        product_id: variation === null || variation === void 0 ? void 0 : variation.catalogProduct.externalId,
        sku: variation === null || variation === void 0 ? void 0 : variation.catalogProductSuiteCode,
        variant: createAnalyticsVariant(optionValues, variation.catalogProduct.catalogProductTypeCode),
        location: "drafts"
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].draftDeleted, [
        eventPayload
    ]);
}
function trackCustomizationReviewInitialized(reviewProps, trackingProps) {
    var ref;
    var selectSegmentVariant = function(reviewProps) {
        var ref, ref1, ref2, ref3, ref4;
        var ProductOptionId;
        (function(ProductOptionId) {
            ProductOptionId["ColorTheme"] = "colorThemeCode";
            ProductOptionId["FoilTheme"] = "foilCode";
            ProductOptionId["PaperType"] = "paperTypeCode";
            ProductOptionId["EnvelopePrintingOption"] = "envelopePrintingOptionCode";
            ProductOptionId["TrimShape"] = "trimCode";
        })(ProductOptionId || (ProductOptionId = {}));
        var selectProductOption = function(productOptionId, optionValues) {
            return optionValues === null || optionValues === void 0 ? void 0 : optionValues.find(function(optionValue) {
                return optionValue.optionId === productOptionId;
            });
        };
        return {
            color: ((ref = selectProductOption(ProductOptionId.ColorTheme, reviewProps.variation.optionValues)) === null || ref === void 0 ? void 0 : ref.name) || "",
            foil_color: (ref1 = selectProductOption(ProductOptionId.FoilTheme, reviewProps.variation.optionValues)) === null || ref1 === void 0 ? void 0 : ref1.name,
            format: reviewProps.product.type.name,
            material: ((ref2 = selectProductOption(ProductOptionId.PaperType, reviewProps.variation.optionValues)) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
            printing_options: (ref3 = selectProductOption(ProductOptionId.EnvelopePrintingOption, reviewProps.variation.optionValues)) === null || ref3 === void 0 ? void 0 : ref3.valueId,
            trim_shape: (ref4 = selectProductOption(ProductOptionId.TrimShape, reviewProps.variation.optionValues)) === null || ref4 === void 0 ? void 0 : ref4.name
        };
    };
    var _isSample;
    var data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        category: reviewProps.product.type.name,
        location: "review",
        name: reviewProps.name,
        portfolio_item_id: reviewProps.product.portfolioItemId,
        price: Number((ref = reviewProps.price) === null || ref === void 0 ? void 0 : ref.basePrice),
        product_id: reviewProps.variation.id,
        quantity: reviewProps.quantity,
        sample_details: [
            {
                is_sample: (_isSample = reviewProps.variation.isSample) !== null && _isSample !== void 0 ? _isSample : false,
                personalized: reviewProps.variation.isSample && reviewProps.isCustomized || undefined
            }, 
        ],
        sku: reviewProps.product.type.sku,
        url: "".concat("https://www.theknot.com").concat("/paper", "/").concat(reviewProps.product.slug),
        variant: [
            selectSegmentVariant(reviewProps)
        ]
    }, trackingProps);
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].customizationReviewInitialized, [
        data
    ]);
}
function trackDraftListViewed(trackingProps, drafts) {
    var draftsTracking = drafts.map(function(draft, index) {
        var ref;
        var variation = draft.variation;
        var _isSample;
        return {
            image_url: createHeroImageUrl(variation),
            name: variation.catalogProduct.name,
            position: index + 1,
            price: Number(draft.price),
            product_id: variation.catalogProduct.externalId,
            quantity: draft.quantity,
            sample_details: [
                {
                    is_sample: (_isSample = variation.isSample) !== null && _isSample !== void 0 ? _isSample : false,
                    personalized: variation.isSample && !!((ref = draft.portfolioItem) === null || ref === void 0 ? void 0 : ref.customizer) || undefined
                }, 
            ],
            sku: variation.id,
            url: (0,_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_6__/* .createAnalyticsUrl */ .bT)(variation.catalogProduct.slug),
            variant: createAnalyticsVariant(variation.optionValues, variation.catalogProduct.catalogProductTypeCode)
        };
    });
    var data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, trackingProps), {
        list_id: "drafts",
        drafts: draftsTracking
    });
    typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].draftListViewed, [
        data
    ]);
}
var createHeroImageUrl = function(variation) {
    var ref;
    var heroImage = (ref = variation.images) === null || ref === void 0 ? void 0 : ref.find(function(image) {
        return image.role === "hero";
    });
    return heroImage ? "".concat("https://tkww-paper-designs.s3.amazonaws.com", "/master").concat(heroImage.url) : "";
};
var createAnalyticsVariant = function(optionValues, productCode) {
    return [
        {
            color: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "colorThemeCode") || "",
            format: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getProductFormatBC */ .x)(productCode),
            material: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "paperTypeCode") || "",
            printing_options: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "envelopePrintingOptionCode"),
            foil_color: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "foilCode"),
            flap_type: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "flapTypeCode"),
            paper_color: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "paperColorCode"),
            trim_shape: (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_10__/* .getOptionValueName */ .rY)(optionValues, "trimCode")
        }, 
    ];
};
function isMobileUserAgent() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    // Check if 'Mobi' is present in the user agent
    return /Mobi/.test(userAgent);
}
function trackExperimentStarted(eventData) {
    return _trackExperimentStarted.apply(this, arguments);
}
function _trackExperimentStarted() {
    _trackExperimentStarted = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(eventData) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            typewriterErrorHandler(_modules_core_contexts_CatalogAnalytics_hooks__WEBPACK_IMPORTED_MODULE_3__["default"].experimentStarted, [
                eventData
            ]);
            return [
                2
            ];
        });
    });
    return _trackExperimentStarted.apply(this, arguments);
}



/***/ }),

/***/ 76806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ isTenant; },
/* harmony export */   "k": function() { return /* binding */ CONFIG; }
/* harmony export */ });
var TENANTS = (/* unused pure expression or super */ null && ([
    "tk",
    "ww"
]));
var CONFIG = {
    tenant: {
        shortName: "tk"
    }
};
function isTenant(tenant) {
    return tenant === "tk";
}


/***/ }),

/***/ 51529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g_": function() { return /* binding */ FORMATS_CODE_MAP; },
/* harmony export */   "j$": function() { return /* binding */ BREAKPOINTS; },
/* harmony export */   "o0": function() { return /* binding */ holidayLink; }
/* harmony export */ });
var FORMATS_CODE_MAP = {
    AIO: "All-in-one",
    SDT: "Petite",
    SDM: "Magnet",
    SDP: "Postcard"
};
var BREAKPOINTS = {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 1024,
    xl: 1192,
    xxl: 1360
};
var holidayLink = {
    text: "Holiday",
    href: "#0",
    links: [
        {
            text: "New! Holiday Cards",
            href: "/paper/holiday-cards"
        }, 
    ]
};


/***/ }),

/***/ 96645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ removeQueryParamsFromPathUrl; },
/* harmony export */   "A7": function() { return /* binding */ getCookieByName; },
/* harmony export */   "FM": function() { return /* binding */ handlePageLogout; },
/* harmony export */   "N": function() { return /* binding */ getZendeskLauncher; },
/* harmony export */   "Nn": function() { return /* binding */ updateZendeskTopPosition; },
/* harmony export */   "VJ": function() { return /* binding */ setImageHost; },
/* harmony export */   "WQ": function() { return /* binding */ getProductFormats; },
/* harmony export */   "Z5": function() { return /* binding */ useImageSizes; },
/* harmony export */   "ZA": function() { return /* binding */ buildSrc; },
/* harmony export */   "_y": function() { return /* binding */ throwError; },
/* harmony export */   "gK": function() { return /* binding */ handleRefreshPage; },
/* harmony export */   "h3": function() { return /* binding */ getClientHeaders; },
/* harmony export */   "i7": function() { return /* binding */ serializeCookie; },
/* harmony export */   "rY": function() { return /* binding */ getOptionValueName; },
/* harmony export */   "sb": function() { return /* binding */ basePath; },
/* harmony export */   "tl": function() { return /* binding */ appendRefetch; },
/* harmony export */   "w2": function() { return /* binding */ handleZendeskOnError; },
/* harmony export */   "x": function() { return /* binding */ getProductFormatBC; }
/* harmony export */ });
/* unused harmony exports callHoneybadger, stringifyError, exclusionMap, onEnter, navigateToCart, getProductRelativeUrl, isAioProduct, getProductDetailRelativeUrl, getProductQueryParamsUrl, getProductDetailUrlStructure, getCategoryUrlStructure, getCategoryUrlStructureWW, getCategoryUrlStructureFromUrl, isNotNull, handleSegmentIdentify, getCookieByPattern, buildRequest, removeUndefinedProps, sortByPaperType, isValidUUID */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69354);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58105);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51529);











var CUSTOMIZER_AUTH_COOKIE_PATTERN = /^S?SESS/;
function callHoneybadger(err) {
    return _callHoneybadger.apply(this, arguments);
}
function _callHoneybadger() {
    _callHoneybadger = _async_to_generator(function(err) {
        var ref, hb;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 69354))
                    ];
                case 1:
                    ref = _state.sent(), hb = ref.default;
                    hb.notify(err);
                    return [
                        2
                    ];
            }
        });
    });
    return _callHoneybadger.apply(this, arguments);
}
function stringifyError(target) {
    if (typeof target === "undefined") return "";
    return JSON.stringify(target, Object.getOwnPropertyNames(target));
}
var PAPER_HOST = (/* unused pure expression or super */ null && ("https://www.theknot.com" || 0));
var APP_BASEPATH = (/* unused pure expression or super */ null && ("/paper" || 0));
var APP_PRODUCT_PATH = (/* unused pure expression or super */ null && ("/product"));
var exclusionMap = (/* unused pure expression or super */ null && ([
    "RSVP Cards",
    "Enclosure Cards",
    "Envelope Liners"
]));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var onEnter = function(callback) {
    return function(event) {
        if (event.key === "Enter") {
            callback(event);
        }
    };
};
function navigateToCart() {
    var sourcePath = String("/paper");
    window.location.assign("https://www.theknot.com" + sourcePath + "/cart");
}
var getProductRelativeUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return url.replace("".concat(PAPER_HOST).concat(APP_BASEPATH), "").split("?")[0];
};
var parseQueryParams = function(querystring) {
    var params = new URLSearchParams(querystring);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var obj = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = params.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (params.getAll(key).length > 1) {
                obj[key] = params.getAll(key);
            } else {
                obj[key] = params.get(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
};
var productFormatTranslate = function(format) {
    return (format === null || format === void 0 ? void 0 : format.charAt(0).toUpperCase()) + (format === null || format === void 0 ? void 0 : format.slice(1));
};
var getProductFormats = function(product) {
    var format = product.format;
    if (Array.isArray(format)) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Set(format.map(function(str) {
            return productFormatTranslate(str);
        }))).join(", ");
    } else if (format) {
        return productFormatTranslate(format);
    } else {
        return "";
    }
};
var getProductFormatBC = function(productCode) {
    var _productCode;
    return (_productCode = _constants__WEBPACK_IMPORTED_MODULE_3__/* .FORMATS_CODE_MAP */ .g_[productCode]) !== null && _productCode !== void 0 ? _productCode : "standard";
};
var isAioProduct = function(product) {
    var type = product.type;
    return type.sku === "AIO";
};
var getProductDetailRelativeUrl = function() {
    var slug = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(APP_PRODUCT_PATH, "/").concat(slug.replace("".concat(PAPER_HOST).concat(APP_BASEPATH), "").split("?")[0]);
};
var getProductQueryParamsUrl = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var queryParamsString = url.replace("".concat(PAPER_HOST).concat(APP_BASEPATH), "").split("?")[1];
    return parseQueryParams(queryParamsString);
};
var getProductDetailUrlStructure = function() {
    return "".concat(APP_PRODUCT_PATH, "/[slug]");
};
var getCategoryUrlStructure = function(isChildCategory) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return isChildCategory && !exclusionMap.includes(name) ? "/[category]/[subcategory]" : "/[category]";
};
var getCategoryUrlStructureWW = function(isChildCategory) {
    var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return isChildCategory && !exclusionMap.includes(name) ? "/[subcategory]" : "/[category]";
};
var getCategoryUrlStructureFromUrl = function(url) {
    if (!url) return "";
    var relativeUrl = getProductRelativeUrl(url);
    var categoriesPath = relativeUrl ? relativeUrl.split("/").filter(Boolean) : [];
    var isChildCategory = categoriesPath.length > 1;
    return getCategoryUrlStructure(isChildCategory);
};
/**
 * Builds the relative subcategory url.
 * @param productType : The product type returned from Storefront API
 * @param productCategory : The product category returned from Storefront API
 * @returns : The subcategory relative url. Ex. "/invitations/wedding" or "/rsvp-cards"
 */ var isNotNull = function(item) {
    return !!item;
};
/*
  This checks if the cookie USER_ID exists, if so returns nothing, if it doesn't, it gets created and returns the value in the gp_anon_id cookie.
 */ var handleSegmentIdentify = function() {
    if (!document) {
        return;
    }
    var allCookies = document.cookie;
    var userId = getCookieByName(allCookies, "USER_ID");
    if (userId) {
        return;
    }
    var uid = getCookieByName(allCookies, "gp_anon_id");
    if (!uid) {
        return;
    }
    return uid;
};
var getCookieByName = function(cookiesString, cookieName) {
    var cookies = cookie__WEBPACK_IMPORTED_MODULE_0__.parse(cookiesString);
    var _cookieName;
    return (_cookieName = cookies[cookieName]) !== null && _cookieName !== void 0 ? _cookieName : "";
};
var getCookieByPattern = function(cookiesString) {
    var pattern = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CUSTOMIZER_AUTH_COOKIE_PATTERN;
    var cookies = Cookie.parse(cookiesString);
    var customizerAuthCookieKey = Object.keys(cookies).find(function(key) {
        return pattern.test(key);
    });
    return customizerAuthCookieKey;
};
var serializeCookie = function(cookie) {
    if (!cookie) {
        throw new Error("No cookie provided");
    }
    return Object.entries(cookie).reduce(function(acc, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        if (!value) return acc;
        return acc + key + "=" + encodeURIComponent(value) + ";";
    }, "");
};
var buildRequest = function(ctx) {
    var query = ctx.query, _req = ctx.req, _cookies = _req.cookies, cookies = _cookies === void 0 ? {} : _cookies;
    var customizerAuthCookieKey = Object.keys(cookies).find(function(key) {
        return CUSTOMIZER_AUTH_COOKIE_PATTERN.test(key);
    });
    var customCookies = _object_spread({
        UC: cookies.UC || "",
        USER_ID: cookies.USER_ID || "",
        USER_TIPO: cookies.USER_TIPO || "",
        USER_INFO: cookies.USER_INFO || ""
    }, customizerAuthCookieKey ? _define_property({}, customizerAuthCookieKey, cookies[customizerAuthCookieKey]) : {});
    var token = (cookies === null || cookies === void 0 ? void 0 : cookies.UC) && (cookies === null || cookies === void 0 ? void 0 : cookies.USER_ID) && (cookies === null || cookies === void 0 ? void 0 : cookies.USER_TIPO) ? "UC=".concat(cookies === null || cookies === void 0 ? void 0 : cookies.UC, ";USER_ID=").concat(cookies === null || cookies === void 0 ? void 0 : cookies.USER_ID, ";USER_TIPO=").concat(cookies === null || cookies === void 0 ? void 0 : cookies.USER_TIPO) : "";
    var headers = {
        token: token,
        cookie: serializeCookie(customCookies),
        "user-agent": ctx.req.headers["user-agent"] || undefined,
        "x-user-id": cookies.USER_ID || undefined,
        "x-user-tipo": cookies.USER_TIPO || undefined,
        "x-user-uc": cookies.UC || undefined
    };
    return {
        query: query,
        headers: headers
    };
};
var removeQueryParamsFromPathUrl = function(pathUrl) {
    return "".concat(pathUrl).split("?")[0];
};
var isPath = function(path) {
    var ref;
    return window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname.includes(path);
};
var refresh = function() {
    return window.location.reload();
};
var redirect = function(to) {
    return window.location.assign(to);
};
var basePath = "/paper";
var handleRefreshPage = function() {
    var pathsToRefresh = [
        "".concat(basePath, "/cart"),
        "".concat(basePath, "/checkout"),
        "".concat(basePath, "/your-drafts")
    ];
    if (pathsToRefresh.some(isPath)) {
        refresh();
        return true;
    }
    return false;
};
var handlePageLogout = function() {
    var pathsToRedirect = [
        "".concat(basePath, "/canvas"),
        "/review",
        "".concat(basePath, "/checkout"),
        "".concat(basePath, "/your-orders"),
        "".concat(basePath, "/your-drafts"), 
    ];
    var pathsToRefresh = [
        "".concat(basePath, "/cart")
    ];
    if (pathsToRedirect.some(isPath)) {
        redirect("".concat(basePath, "/products"));
    } else if (pathsToRefresh.some(isPath)) {
        refresh();
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var removeUndefinedProps = function(obj) {
    Object.entries(obj).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (value === undefined) delete obj[key];
    });
    return obj;
};
var getClientHeaders = function() {
    if (true) {
        return {
            cookie: document.cookie,
            "user-agent": window.navigator.userAgent
        };
    }
    return {};
};
function throwError(error, message) {
    var errorMessage = message;
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(error, Error)) {
        errorMessage = error.message;
    }
    throw new Error(errorMessage);
}
var buildSrc = function(path) {
    return "".concat("https://media-api.xogrp.com", "/images/fetch/").concat(path);
};
var appendRefetch = function(path) {
    return "".concat(path, "?refetch=true");
};
var setImageHost = function(path) {
    return path.includes(String("https://tkww-paper-designs.s3.amazonaws.com")) ? path : "".concat("https://tkww-paper-designs.s3.amazonaws.com", "/master/").concat(path);
};
var useImageSizes = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        width: 0,
        height: 0
    }), sizes = ref[0], set = ref[1];
    var setSizes = function(e) {
        return set({
            width: e.naturalWidth,
            height: e.naturalHeight
        });
    };
    return [
        sizes,
        setSizes
    ];
};
var sortByPaperType = function(paperTypes) {
    if (paperTypes.length < 2) {
        return paperTypes;
    }
    var reordered = [];
    reordered.push(paperTypes.filter(function(v) {
        return v.name === "Signature";
    }).pop());
    reordered.push(paperTypes.filter(function(v) {
        return v.name === "Pearlescent";
    }).pop());
    reordered.push(paperTypes.filter(function(v) {
        return v.name === "Recycled";
    }).pop());
    return reordered.filter(function(v) {
        return !!v;
    });
};
/* Option values */ var getOptionValueName = function(optionValues, optionId) {
    var ref;
    return (ref = optionValues === null || optionValues === void 0 ? void 0 : optionValues.find(function(optionValue) {
        return optionValue["optionId"] === optionId;
    })) === null || ref === void 0 ? void 0 : ref.name;
};
var handleZendeskOnError = function(error, location) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(error, Error)) {
        var ref;
        var isZendeskWidgetLoaded = !!window.zE;
        var widgetType = (ref = window.zE) === null || ref === void 0 ? void 0 : ref.widget;
        var message = "Zendesk widget failed to load";
        _modules_core_services_honeybadger_service__WEBPACK_IMPORTED_MODULE_6__["default"].notify(error, message, {
            context: {
                isZendeskWidgetLoaded: isZendeskWidgetLoaded,
                widgetType: widgetType,
                location: location
            }
        });
    }
};
function getZendeskLauncher() {
    return document.getElementById("zendeskLauncher");
}
function updateZendeskTopPosition(updateOffset, topOffset) {
    var screenHeight = window.innerHeight;
    var zendeskLauncher = getZendeskLauncher();
    if (!zendeskLauncher) return;
    var offset = screenHeight - topOffset;
    if (updateOffset) {
        zendeskLauncher.style.top = "".concat(offset, "px");
    } else {
        zendeskLauncher.style.top = "";
    }
}
function isValidUUID(uuid) {
    if (!uuid) return false;
    var uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidPattern.test(uuid);
}


/***/ }),

/***/ 59837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Layouts": function() { return /* binding */ Layouts; },
/* harmony export */   "getIOSSnippet": function() { return /* binding */ getIOSSnippet; },
/* harmony export */   "getLayout": function() { return /* binding */ getLayout; },
/* harmony export */   "getLayoutType": function() { return /* binding */ getLayoutType; },
/* harmony export */   "isAndroidApp": function() { return /* binding */ isAndroidApp; },
/* harmony export */   "isIOSWebview": function() { return /* binding */ isIOSWebview; },
/* harmony export */   "isWeddingWireApp": function() { return /* binding */ isWeddingWireApp; },
/* harmony export */   "isiOSApp": function() { return /* binding */ isiOSApp; },
/* harmony export */   "parseAnonymousUserToken": function() { return /* binding */ parseAnonymousUserToken; },
/* harmony export */   "parseXOMembershipToken": function() { return /* binding */ parseXOMembershipToken; },
/* harmony export */   "withLayout": function() { return /* binding */ withLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72730);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58105);
/* harmony import */ var _services_storefront_drafts_drafts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55288);






var Layouts = {
    Web: "Web",
    WebView: "WebView"
};
var hasWebViewCookie = function(headers) {
    if (headers) {
        var parsedCookie = cookie__WEBPACK_IMPORTED_MODULE_0__.parse((headers === null || headers === void 0 ? void 0 : headers.cookie) || "");
        return Boolean(parsedCookie["FROM_WEBVIEW"]);
    }
    return false;
};
var isAndroidApp = function(headers) {
    if (headers) {
        var isAndroid = headers["x-app-users-android"], isAndroid2 = headers.http_x_app_users_android;
        return Boolean(isAndroid) || Boolean(isAndroid2) || hasWebViewCookie(headers);
    }
    return false;
};
var isiOSApp = function(headers) {
    if (headers) {
        var isIOS = headers["x-app-users-ios"], isIOS2 = headers.http_x_app_users_ios;
        return Boolean(isIOS) || Boolean(isIOS2) || hasWebViewCookie(headers);
    }
    return false;
};
var isIOSWebview = function(headers) {
    var iOSWebviewUA = "TKPlanner-iOS";
    var ref = headers || {}, ua = ref["user-agent"];
    var ref1;
    return (ref1 = ua === null || ua === void 0 ? void 0 : ua.includes(iOSWebviewUA)) !== null && ref1 !== void 0 ? ref1 : false;
};
var withFn = function(callback) {
    return function(nextCallback) {
        return function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(context) {
                var ref, callbackProps, nextCallbackProps, _, _tmp;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _ = Promise.all;
                            return [
                                4,
                                callback(context)
                            ];
                        case 1:
                            _tmp = [
                                _state.sent()
                            ];
                            return [
                                4,
                                nextCallback(context)
                            ];
                        case 2:
                            return [
                                4,
                                _.apply(Promise, [
                                    _tmp.concat(_state.sent())
                                ])
                            ];
                        case 3:
                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), callbackProps = ref[0], nextCallbackProps = ref[1];
                            if ((callbackProps === null || callbackProps === void 0 ? void 0 : callbackProps.redirect) || (nextCallbackProps === null || nextCallbackProps === void 0 ? void 0 : nextCallbackProps.redirect)) {
                                return [
                                    2,
                                    {
                                        redirect: nextCallbackProps.redirect
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    props: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, callbackProps === null || callbackProps === void 0 ? void 0 : callbackProps.props, nextCallbackProps === null || nextCallbackProps === void 0 ? void 0 : nextCallbackProps.props)
                                }
                            ];
                    }
                });
            });
            return function(context) {
                return _ref.apply(this, arguments);
            };
        }();
    };
};
var parseAnonymousUserToken = function(storefrontTokenName, cookie) {
    try {
        var parsedCookie = cookie__WEBPACK_IMPORTED_MODULE_0__.parse(cookie);
        return parsedCookie[storefrontTokenName];
    } catch (error) {
        console.log(error);
    }
};
var parseXOMembershipToken = function(cookie) {
    try {
        var ref = cookie__WEBPACK_IMPORTED_MODULE_0__.parse(cookie), token = ref["xo-session-token"];
        return token;
    } catch (error) {
        console.log(error);
    }
};
var generateIOSSnippet = function(headers, itemCounters) {
    return JSON.stringify({
        tkWebview: {
            count: {
                orders: 1,
                itemsInCart: itemCounters.cart
            },
            drafts: {
                active: true,
                count: itemCounters.drafts
            },
            userAgent: headers === null || headers === void 0 ? void 0 : headers["user-agent"]
        }
    });
};
function getLayout() {
    return _getLayout.apply(this, arguments);
}
function _getLayout() {
    _getLayout = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var headers, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    _tmp = [
                        {},
                        getLayoutType(headers)
                    ];
                    return [
                        4,
                        getIOSSnippet(headers)
                    ];
                case 1:
                    return [
                        2,
                        _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, _tmp.concat(_state.sent()))
                    ];
            }
        });
    });
    return _getLayout.apply(this, arguments);
}
var getLayoutType = function() {
    var headers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var name = isIOSWebview(headers) ? "WebView" : "Web";
    return {
        name: name
    };
};
var getIOSSnippet = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var headers, name, isLoggedIn, includeDrafts, itemCounters, commerceDataSnippet;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    headers = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    name = isIOSWebview(headers) ? "WebView" : "Web";
                    isLoggedIn = parseXOMembershipToken((headers === null || headers === void 0 ? void 0 : headers.cookie) || "");
                    includeDrafts = Boolean(+"1") && !!isLoggedIn;
                    return [
                        4,
                        (0,_services_storefront_drafts_drafts__WEBPACK_IMPORTED_MODULE_5__/* .getCartDraftsCounters */ .TB)(includeDrafts, headers)
                    ];
                case 1:
                    itemCounters = _state.sent();
                    commerceDataSnippet = name === "WebView" && generateIOSSnippet(headers, itemCounters);
                    return [
                        2,
                        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            itemCounters: itemCounters
                        }, commerceDataSnippet ? {
                            snippets: {
                                commerceDataSnippet: commerceDataSnippet
                            }
                        } : {})
                    ];
            }
        });
    });
    return function getIOSSnippet() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @deprecated
 * getLayout is being invoked in _app.tsx
 */ var withLayout = withFn(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(context) {
        var layout;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getLayout(context.req.headers)
                    ];
                case 1:
                    layout = _state.sent();
                    return [
                        2,
                        {
                            props: {
                                layout: layout
                            }
                        }
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}());
var isWeddingWireApp = function(headers) {
    return isAndroidApp(headers) || isiOSApp(headers) || hasWebViewCookie(headers);
};


/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	0;
})(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

	function getDefaultExportFromCjs (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function getAugmentedNamespace(n) {
	  var f = n.default;
		if (typeof f == "function") {
			var a = function () {
				return f.apply(this, arguments);
			};
			a.prototype = f.prototype;
	  } else a = {};
	  Object.defineProperty(a, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	var browser$1 = {};

	var src = {};

	var events = {};

	var util$1 = {};

	var UNKNOWN_FUNCTION = '<unknown>';
	/**
	 * This parses the different stack traces and puts them into one format
	 * This borrows heavily from TraceKit (https://github.com/csnover/TraceKit)
	 */

	function parse(stackString) {
	  var lines = stackString.split('\n');
	  return lines.reduce(function (stack, line) {
	    var parseResult = parseChrome(line) || parseWinjs(line) || parseGecko(line) || parseNode(line) || parseJSC(line);

	    if (parseResult) {
	      stack.push(parseResult);
	    }

	    return stack;
	  }, []);
	}
	var chromeRe = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/|[a-z]:\\|\\\\).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	var chromeEvalRe = /\((\S*)(?::(\d+))(?::(\d+))\)/;

	function parseChrome(line) {
	  var parts = chromeRe.exec(line);

	  if (!parts) {
	    return null;
	  }

	  var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line

	  var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

	  var submatch = chromeEvalRe.exec(parts[2]);

	  if (isEval && submatch != null) {
	    // throw out eval line/column and use top-most line/column number
	    parts[2] = submatch[1]; // url

	    parts[3] = submatch[2]; // line

	    parts[4] = submatch[3]; // column
	  }

	  return {
	    file: !isNative ? parts[2] : null,
	    methodName: parts[1] || UNKNOWN_FUNCTION,
	    arguments: isNative ? [parts[2]] : [],
	    lineNumber: parts[3] ? +parts[3] : null,
	    column: parts[4] ? +parts[4] : null
	  };
	}

	var winjsRe = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

	function parseWinjs(line) {
	  var parts = winjsRe.exec(line);

	  if (!parts) {
	    return null;
	  }

	  return {
	    file: parts[2],
	    methodName: parts[1] || UNKNOWN_FUNCTION,
	    arguments: [],
	    lineNumber: +parts[3],
	    column: parts[4] ? +parts[4] : null
	  };
	}

	var geckoRe = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
	var geckoEvalRe = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

	function parseGecko(line) {
	  var parts = geckoRe.exec(line);

	  if (!parts) {
	    return null;
	  }

	  var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	  var submatch = geckoEvalRe.exec(parts[3]);

	  if (isEval && submatch != null) {
	    // throw out eval line/column and use top-most line number
	    parts[3] = submatch[1];
	    parts[4] = submatch[2];
	    parts[5] = null; // no column when eval
	  }

	  return {
	    file: parts[3],
	    methodName: parts[1] || UNKNOWN_FUNCTION,
	    arguments: parts[2] ? parts[2].split(',') : [],
	    lineNumber: parts[4] ? +parts[4] : null,
	    column: parts[5] ? +parts[5] : null
	  };
	}

	var javaScriptCoreRe = /^\s*(?:([^@]*)(?:\((.*?)\))?@)?(\S.*?):(\d+)(?::(\d+))?\s*$/i;

	function parseJSC(line) {
	  var parts = javaScriptCoreRe.exec(line);

	  if (!parts) {
	    return null;
	  }

	  return {
	    file: parts[3],
	    methodName: parts[1] || UNKNOWN_FUNCTION,
	    arguments: [],
	    lineNumber: +parts[4],
	    column: parts[5] ? +parts[5] : null
	  };
	}

	var nodeRe = /^\s*at (?:((?:\[object object\])?[^\\/]+(?: \[as \S+\])?) )?\(?(.*?):(\d+)(?::(\d+))?\)?\s*$/i;

	function parseNode(line) {
	  var parts = nodeRe.exec(line);

	  if (!parts) {
	    return null;
	  }

	  return {
	    file: parts[2],
	    methodName: parts[1] || UNKNOWN_FUNCTION,
	    arguments: [],
	    lineNumber: +parts[3],
	    column: parts[4] ? +parts[4] : null
	  };
	}

	var stackTraceParser_esm = /*#__PURE__*/Object.freeze({
		__proto__: null,
		parse: parse
	});

	var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(stackTraceParser_esm);

	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
		    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
		    return new (P || (P = Promise))(function (resolve, reject) {
		        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		        step((generator = generator.apply(thisArg, _arguments || [])).next());
		    });
		};
		var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
		    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
		    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
		    function verb(n) { return function (v) { return step([n, v]); }; }
		    function step(op) {
		        if (f) throw new TypeError("Generator is already executing.");
		        while (_) try {
		            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
		            if (y = 0, t) op = [op[0] & 2, t.value];
		            switch (op[0]) {
		                case 0: case 1: t = op; break;
		                case 4: _.label++; return { value: op[1], done: false };
		                case 5: _.label++; y = op[1]; op = [0]; continue;
		                case 7: op = _.ops.pop(); _.trys.pop(); continue;
		                default:
		                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
		                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
		                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
		                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
		                    if (t[2]) _.ops.pop();
		                    _.trys.pop(); continue;
		            }
		            op = body.call(thisArg, _);
		        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
		        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
		    }
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.logDeprecatedMethod = exports.globalThisOrWindow = exports.isBrowserConfig = exports.clone = exports.formatCGIData = exports.filterUrl = exports.filter = exports.generateStackTrace = exports.endpoint = exports.instrumentConsole = exports.instrument = exports.isErrorObject = exports.makeNotice = exports.logger = exports.sanitize = exports.shallowClone = exports.runAfterNotifyHandlers = exports.runBeforeNotifyHandlers = exports.getSourceForBacktrace = exports.getCauses = exports.calculateBacktraceShift = exports.DEFAULT_BACKTRACE_SHIFT = exports.makeBacktrace = exports.objectIsExtensible = exports.objectIsEmpty = exports.mergeNotice = exports.merge = void 0;
		/* eslint-disable prefer-rest-params */
		var stackTraceParser = __importStar(require$$0$1);
		function merge(obj1, obj2) {
		    var result = {};
		    for (var k in obj1) {
		        result[k] = obj1[k];
		    }
		    for (var k in obj2) {
		        result[k] = obj2[k];
		    }
		    return result;
		}
		exports.merge = merge;
		function mergeNotice(notice1, notice2) {
		    var result = merge(notice1, notice2);
		    if (notice1.context && notice2.context) {
		        result.context = merge(notice1.context, notice2.context);
		    }
		    return result;
		}
		exports.mergeNotice = mergeNotice;
		function objectIsEmpty(obj) {
		    for (var k in obj) {
		        if (Object.prototype.hasOwnProperty.call(obj, k)) {
		            return false;
		        }
		    }
		    return true;
		}
		exports.objectIsEmpty = objectIsEmpty;
		function objectIsExtensible(obj) {
		    if (typeof Object.isExtensible !== 'function') {
		        return true;
		    }
		    return Object.isExtensible(obj);
		}
		exports.objectIsExtensible = objectIsExtensible;
		function makeBacktrace(stack, filterHbSourceCode, logger) {
		    if (filterHbSourceCode === void 0) { filterHbSourceCode = false; }
		    if (logger === void 0) { logger = console; }
		    if (!stack) {
		        return [];
		    }
		    try {
		        var backtrace = stackTraceParser
		            .parse(stack)
		            .map(function (line) {
		            return {
		                file: line.file,
		                method: line.methodName,
		                number: line.lineNumber,
		                column: line.column
		            };
		        });
		        if (filterHbSourceCode) {
		            backtrace.splice(0, calculateBacktraceShift(backtrace));
		        }
		        return backtrace;
		    }
		    catch (err) {
		        logger.debug(err);
		        return [];
		    }
		}
		exports.makeBacktrace = makeBacktrace;
		function isFrameFromHbSourceCode(frame) {
		    var hasHbFile = false;
		    var hasHbMethod = false;
		    if (frame.file) {
		        hasHbFile = frame.file.toLowerCase().indexOf('@honeybadger-io') > -1;
		    }
		    if (frame.method) {
		        hasHbMethod = frame.method.toLowerCase().indexOf('@honeybadger-io') > -1;
		    }
		    return hasHbFile || hasHbMethod;
		}
		exports.DEFAULT_BACKTRACE_SHIFT = 3;
		/**
		 * If {@link generateStackTrace} is used, we want to exclude frames that come from
		 * Honeybadger's source code.
		 *
		 * Logic:
		 * - For each frame, increment the shift if source code is from Honeybadger
		 * - If a frame from an <anonymous> file is encountered increment the shift ONLY if between Honeybadger source code
		 *   (i.e. previous and next frames are from Honeybadger)
		 * - Exit when frame encountered is not from Honeybadger source code
		 *
		 * Note: this will not always work, especially in browser versions where code
		 *       is minified, uglified and bundled.
		 *       For those cases we default to 3:
		 *       - generateStackTrace
		 *       - makeNotice
		 *       - notify
		 */
		function calculateBacktraceShift(backtrace) {
		    var shift = 0;
		    for (var i = 0; i < backtrace.length; i++) {
		        var frame = backtrace[i];
		        if (isFrameFromHbSourceCode(frame)) {
		            shift++;
		            continue;
		        }
		        if (!frame.file || frame.file === '<anonymous>') {
		            var nextFrame = backtrace[i + 1];
		            if (nextFrame && isFrameFromHbSourceCode(nextFrame)) {
		                shift++;
		                continue;
		            }
		        }
		        break;
		    }
		    return shift || exports.DEFAULT_BACKTRACE_SHIFT;
		}
		exports.calculateBacktraceShift = calculateBacktraceShift;
		function getCauses(notice, logger) {
		    if (notice.cause) {
		        var causes = [];
		        var cause = notice;
		        // @ts-ignore this throws an error if tsconfig.json has strict: true
		        while (causes.length < 3 && (cause = cause.cause)) {
		            causes.push({
		                class: cause.name,
		                message: cause.message,
		                backtrace: typeof cause.stack == 'string' ? makeBacktrace(cause.stack, false, logger) : null
		            });
		        }
		        return causes;
		    }
		    return [];
		}
		exports.getCauses = getCauses;
		function getSourceForBacktrace(backtrace, getSourceFileHandler) {
		    return __awaiter(this, void 0, void 0, function () {
		        var result, index, trace, fileContent;
		        return __generator(this, function (_a) {
		            switch (_a.label) {
		                case 0:
		                    result = [];
		                    if (!getSourceFileHandler || !backtrace || !backtrace.length) {
		                        return [2 /*return*/, result];
		                    }
		                    index = 0;
		                    _a.label = 1;
		                case 1:
		                    if (!backtrace.length) return [3 /*break*/, 3];
		                    trace = backtrace.splice(0)[index];
		                    return [4 /*yield*/, getSourceFileHandler(trace.file)];
		                case 2:
		                    fileContent = _a.sent();
		                    result[index] = getSourceCodeSnippet(fileContent, trace.number);
		                    index++;
		                    return [3 /*break*/, 1];
		                case 3: return [2 /*return*/, result];
		            }
		        });
		    });
		}
		exports.getSourceForBacktrace = getSourceForBacktrace;
		function runBeforeNotifyHandlers(notice, handlers) {
		    var results = [];
		    var result = true;
		    for (var i = 0, len = handlers.length; i < len; i++) {
		        var handler = handlers[i];
		        var handlerResult = handler(notice);
		        if (handlerResult === false) {
		            result = false;
		        }
		        results.push(handlerResult);
		    }
		    return {
		        results: results,
		        result: result
		    };
		}
		exports.runBeforeNotifyHandlers = runBeforeNotifyHandlers;
		function runAfterNotifyHandlers(notice, handlers, error) {
		    if (notice && notice.afterNotify) {
		        notice.afterNotify(error, notice);
		    }
		    for (var i = 0, len = handlers.length; i < len; i++) {
		        handlers[i](error, notice);
		    }
		    return true;
		}
		exports.runAfterNotifyHandlers = runAfterNotifyHandlers;
		// Returns a new object with properties from other object.
		function shallowClone(obj) {
		    if (typeof (obj) !== 'object' || obj === null) {
		        return {};
		    }
		    var result = {};
		    for (var k in obj) {
		        result[k] = obj[k];
		    }
		    return result;
		}
		exports.shallowClone = shallowClone;
		function sanitize(obj, maxDepth) {
		    if (maxDepth === void 0) { maxDepth = 8; }
		    var seenObjects = [];
		    function seen(obj) {
		        if (!obj || typeof (obj) !== 'object') {
		            return false;
		        }
		        for (var i = 0; i < seenObjects.length; i++) {
		            var value = seenObjects[i];
		            if (value === obj) {
		                return true;
		            }
		        }
		        seenObjects.push(obj);
		        return false;
		    }
		    function canSerialize(obj) {
		        var typeOfObj = typeof obj;
		        // Functions are TMI
		        if (/function/.test(typeOfObj)) {
		            // Let special toJSON method pass as it's used by JSON.stringify (#722)
		            return obj.name === 'toJSON';
		        }
		        // Symbols can't convert to strings.
		        if (/symbol/.test(typeOfObj)) {
		            return false;
		        }
		        if (obj === null) {
		            return false;
		        }
		        // No prototype, likely created with `Object.create(null)`.
		        if (typeof obj === 'object' && typeof obj.hasOwnProperty === 'undefined') {
		            return false;
		        }
		        return true;
		    }
		    function serialize(obj, depth) {
		        if (depth === void 0) { depth = 0; }
		        if (depth >= maxDepth) {
		            return '[DEPTH]';
		        }
		        // Inspect invalid types
		        if (!canSerialize(obj)) {
		            return Object.prototype.toString.call(obj);
		        }
		        // Halt circular references
		        if (seen(obj)) {
		            return '[RECURSION]';
		        }
		        // Serialize inside arrays
		        if (Array.isArray(obj)) {
		            return obj.map(function (o) { return safeSerialize(o, depth + 1); });
		        }
		        // Serialize inside objects
		        if (typeof (obj) === 'object') {
		            var ret = {};
		            for (var k in obj) {
		                var v = obj[k];
		                if (Object.prototype.hasOwnProperty.call(obj, k) && (k != null) && (v != null)) {
		                    ret[k] = safeSerialize(v, depth + 1);
		                }
		            }
		            return ret;
		        }
		        // Return everything else untouched
		        return obj;
		    }
		    function safeSerialize(obj, depth) {
		        if (depth === void 0) { depth = 0; }
		        try {
		            return serialize(obj, depth);
		        }
		        catch (e) {
		            return "[ERROR] ".concat(e);
		        }
		    }
		    return safeSerialize(obj);
		}
		exports.sanitize = sanitize;
		function logger(client) {
		    var log = function (method) {
		        return function () {
		            var _a;
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            if (method === 'debug') {
		                if (!client.config.debug) {
		                    return;
		                }
		                // Log at default level so that you don't need to also enable verbose
		                // logging in Chrome.
		                method = 'log';
		            }
		            args.unshift('[Honeybadger]');
		            (_a = client.config.logger)[method].apply(_a, args);
		        };
		    };
		    return {
		        log: log('log'),
		        info: log('info'),
		        debug: log('debug'),
		        warn: log('warn'),
		        error: log('error')
		    };
		}
		exports.logger = logger;
		/**
		 * Converts any object into a notice object (which at minimum has the same
		 * properties as Error, but supports additional Honeybadger properties.)
		 */
		function makeNotice(thing) {
		    var notice;
		    if (!thing) {
		        notice = {};
		    }
		    else if (isErrorObject(thing)) {
		        var e = thing;
		        notice = merge(thing, { name: e.name, message: e.message, stack: e.stack, cause: e.cause });
		    }
		    else if (typeof thing === 'object') {
		        notice = shallowClone(thing);
		    }
		    else {
		        var m = String(thing);
		        notice = { message: m };
		    }
		    return notice;
		}
		exports.makeNotice = makeNotice;
		function isErrorObject(thing) {
		    return thing instanceof Error
		        || Object.prototype.toString.call(thing) === '[object Error]'; // Important for cross-realm objects
		}
		exports.isErrorObject = isErrorObject;
		/**
		 * Instrument an existing function inside an object (usually global).
		 * @param {!Object} object
		 * @param {!String} name
		 * @param {!Function} replacement
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function instrument(object, name, replacement) {
		    if (!object || !name || !replacement || !(name in object)) {
		        return;
		    }
		    try {
		        var original = object[name];
		        while (original && original.__hb_original) {
		            original = original.__hb_original;
		        }
		        object[name] = replacement(original);
		        object[name].__hb_original = original;
		    }
		    catch (_e) {
		        // Ignores errors where "original" is a restricted object (see #1001)
		        // Uncaught Error: Permission denied to access property "__hb_original"
		        // Also ignores:
		        //   Error: TypeError: Cannot set property onunhandledrejection of [object Object] which has only a getter
		        //   User-Agent: Mozilla/5.0 (Linux; Android 10; SAMSUNG SM-G960F) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/12.1 Chrome/79.0.3945.136 Mobile Safari/537.36
		    }
		}
		exports.instrument = instrument;
		var _consoleAlreadyInstrumented = false;
		var listeners = [];
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function instrumentConsole(_window, handler) {
		    if (!_window || !_window.console || !handler) {
		        return;
		    }
		    listeners.push(handler);
		    if (_consoleAlreadyInstrumented) {
		        return;
		    }
		    _consoleAlreadyInstrumented = true;
		    ['debug', 'info', 'warn', 'error', 'log'].forEach(function (level) {
		        instrument(_window.console, level, function hbLogger(original) {
		            return function () {
		                var args = Array.prototype.slice.call(arguments);
		                listeners.forEach(function (listener) {
		                    try {
		                        listener(level, args);
		                    }
		                    catch (_e) {
		                        // ignore
		                        // should never reach here because instrument method already wraps with try/catch block
		                    }
		                });
		                if (typeof original === 'function') {
		                    Function.prototype.apply.call(original, _window.console, arguments);
		                }
		            };
		        });
		    });
		}
		exports.instrumentConsole = instrumentConsole;
		function endpoint(base, path) {
		    var endpoint = base.trim().replace(/\/$/, '');
		    path = path.trim().replace(/(^\/|\/$)/g, '');
		    return "".concat(endpoint, "/").concat(path);
		}
		exports.endpoint = endpoint;
		function generateStackTrace() {
		    try {
		        throw new Error('');
		    }
		    catch (e) {
		        if (e.stack) {
		            return e.stack;
		        }
		    }
		    var maxStackSize = 10;
		    var stack = [];
		    var curr = arguments.callee;
		    while (curr && stack.length < maxStackSize) {
		        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
		            stack.push(RegExp.$1 || '<anonymous>');
		        }
		        else {
		            stack.push('<anonymous>');
		        }
		        try {
		            curr = curr.caller;
		        }
		        catch (e) {
		            break;
		        }
		    }
		    return stack.join('\n');
		}
		exports.generateStackTrace = generateStackTrace;
		function filter(obj, filters) {
		    if (!is('Object', obj)) {
		        return;
		    }
		    if (!is('Array', filters)) {
		        filters = [];
		    }
		    var seen = [];
		    function filter(obj) {
		        var k, newObj;
		        if (is('Object', obj) || is('Array', obj)) {
		            if (seen.indexOf(obj) !== -1) {
		                return '[CIRCULAR DATA STRUCTURE]';
		            }
		            seen.push(obj);
		        }
		        if (is('Object', obj)) {
		            newObj = {};
		            for (k in obj) {
		                if (filterMatch(k, filters)) {
		                    newObj[k] = '[FILTERED]';
		                }
		                else {
		                    newObj[k] = filter(obj[k]);
		                }
		            }
		            return newObj;
		        }
		        if (is('Array', obj)) {
		            return obj.map(function (v) {
		                return filter(v);
		            });
		        }
		        if (is('Function', obj)) {
		            return '[FUNC]';
		        }
		        return obj;
		    }
		    return filter(obj);
		}
		exports.filter = filter;
		function filterMatch(key, filters) {
		    for (var i = 0; i < filters.length; i++) {
		        if (key.toLowerCase().indexOf(filters[i].toLowerCase()) !== -1) {
		            return true;
		        }
		    }
		    return false;
		}
		function is(type, obj) {
		    var klass = Object.prototype.toString.call(obj).slice(8, -1);
		    return obj !== undefined && obj !== null && klass === type;
		}
		function filterUrl(url, filters) {
		    if (!filters) {
		        return url;
		    }
		    if (typeof url !== 'string') {
		        return url;
		    }
		    var query = url.split(/\?/, 2)[1];
		    if (!query) {
		        return url;
		    }
		    var result = url;
		    query.split(/[&]\s?/).forEach(function (pair) {
		        var _a = pair.split('=', 2), key = _a[0], value = _a[1];
		        if (filterMatch(key, filters)) {
		            result = result.replace("".concat(key, "=").concat(value), "".concat(key, "=[FILTERED]"));
		        }
		    });
		    return result;
		}
		exports.filterUrl = filterUrl;
		function formatCGIData(vars, prefix) {
		    if (prefix === void 0) { prefix = ''; }
		    var formattedVars = {};
		    Object.keys(vars).forEach(function (key) {
		        var formattedKey = prefix + key.replace(/\W/g, '_').toUpperCase();
		        formattedVars[formattedKey] = vars[key];
		    });
		    return formattedVars;
		}
		exports.formatCGIData = formatCGIData;
		function clone(obj) {
		    return JSON.parse(JSON.stringify(obj));
		}
		exports.clone = clone;
		function getSourceCodeSnippet(fileData, lineNumber, sourceRadius) {
		    if (sourceRadius === void 0) { sourceRadius = 2; }
		    if (!fileData) {
		        return null;
		    }
		    var lines = fileData.split('\n');
		    // add one empty line because array index starts from 0, but error line number is counted from 1
		    lines.unshift('');
		    var start = lineNumber - sourceRadius;
		    var end = lineNumber + sourceRadius;
		    var result = {};
		    for (var i = start; i <= end; i++) {
		        var line = lines[i];
		        if (typeof line === 'string') {
		            result[i] = line;
		        }
		    }
		    return result;
		}
		function isBrowserConfig(config) {
		    return config.async !== undefined;
		}
		exports.isBrowserConfig = isBrowserConfig;
		/** globalThis has fairly good support. But just in case, lets check its defined.
		 * @see {https://caniuse.com/?search=globalThis}
		 */
		function globalThisOrWindow() {
		    if (typeof globalThis !== 'undefined') {
		        return globalThis;
		    }
		    if (typeof self !== 'undefined') {
		        return self;
		    }
		    return window;
		}
		exports.globalThisOrWindow = globalThisOrWindow;
		var _deprecatedMethodCalls = {};
		/**
		 * Logs a deprecation warning, every X calls to the method.
		 */
		function logDeprecatedMethod(logger, oldMethod, newMethod, callCountThreshold) {
		    if (callCountThreshold === void 0) { callCountThreshold = 100; }
		    var key = "".concat(oldMethod, "-").concat(newMethod);
		    if (typeof _deprecatedMethodCalls[key] === 'undefined') {
		        _deprecatedMethodCalls[key] = 0;
		    }
		    if (_deprecatedMethodCalls[key] % callCountThreshold !== 0) {
		        _deprecatedMethodCalls[key]++;
		        return;
		    }
		    var msg = "Deprecation warning: ".concat(oldMethod, " has been deprecated; please use ").concat(newMethod, " instead.");
		    logger.warn(msg);
		    _deprecatedMethodCalls[key]++;
		}
		exports.logDeprecatedMethod = logDeprecatedMethod;
		
	} (util$1));

	Object.defineProperty(events, "__esModule", { value: true });
	var util_1$4 = util$1;
	function default_1$4(_window) {
	    if (_window === void 0) { _window = (0, util_1$4.globalThisOrWindow)(); }
	    return {
	        shouldReloadOnConfigure: false,
	        load: function (client) {
	            function sendEventsToInsights() {
	                return client.config.eventsEnabled;
	            }
	            if (!sendEventsToInsights()) {
	                return;
	            }
	            (0, util_1$4.instrumentConsole)(_window, function (level, args) {
	                if (!sendEventsToInsights()) {
	                    return;
	                }
	                if (args.length === 0) {
	                    return;
	                }
	                var data = {
	                    severity: level,
	                };
	                if (typeof args[0] === 'string') {
	                    data.message = args[0];
	                    data.args = args.slice(1);
	                }
	                else {
	                    data.args = args;
	                }
	                client.event('log', data);
	            });
	        }
	    };
	}
	events.default = default_1$4;

	var client = {};

	var store = {};

	Object.defineProperty(store, "__esModule", { value: true });
	store.GlobalStore = void 0;
	var util_1$3 = util$1;
	var GlobalStore = /** @class */ (function () {
	    function GlobalStore(contents, breadcrumbsLimit) {
	        this.contents = contents;
	        this.breadcrumbsLimit = breadcrumbsLimit;
	    }
	    GlobalStore.create = function (contents, breadcrumbsLimit) {
	        return new GlobalStore(contents, breadcrumbsLimit);
	    };
	    GlobalStore.prototype.available = function () {
	        return true;
	    };
	    GlobalStore.prototype.getContents = function (key) {
	        var value = key ? this.contents[key] : this.contents;
	        return JSON.parse(JSON.stringify(value));
	    };
	    GlobalStore.prototype.setContext = function (context) {
	        this.contents.context = (0, util_1$3.merge)(this.contents.context, context || {});
	    };
	    GlobalStore.prototype.addBreadcrumb = function (breadcrumb) {
	        if (this.contents.breadcrumbs.length == this.breadcrumbsLimit) {
	            this.contents.breadcrumbs.shift();
	        }
	        this.contents.breadcrumbs.push(breadcrumb);
	    };
	    GlobalStore.prototype.clear = function () {
	        this.contents.context = {};
	        this.contents.breadcrumbs = [];
	    };
	    GlobalStore.prototype.run = function (callback) {
	        return callback();
	    };
	    return GlobalStore;
	}());
	store.GlobalStore = GlobalStore;

	var throttled_events_logger = {};

	class NdJson {
	    static parse(data) {
	        const lines = data.trim().split('\n');
	        return lines.map(line => JSON.parse(line));
	    }
	    static stringify(data) {
	        return data.map(item => JSON.stringify(item)).join('\n');
	    }
	}

	var module = /*#__PURE__*/Object.freeze({
		__proto__: null,
		NdJson: NdJson
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(module);

	var defaults = {};

	Object.defineProperty(defaults, "__esModule", { value: true });
	defaults.CONFIG = void 0;
	defaults.CONFIG = {
	    apiKey: null,
	    endpoint: 'https://api.honeybadger.io',
	    environment: null,
	    hostname: null,
	    projectRoot: null,
	    component: null,
	    action: null,
	    revision: null,
	    reportData: null,
	    breadcrumbsEnabled: true,
	    // we could decide the value of eventsEnabled based on `env` and `developmentEnvironments`
	    eventsEnabled: false,
	    maxBreadcrumbs: 40,
	    maxObjectDepth: 8,
	    logger: console,
	    developmentEnvironments: ['dev', 'development', 'test'],
	    debug: false,
	    tags: null,
	    enableUncaught: true,
	    enableUnhandledRejection: true,
	    afterUncaught: function () { return true; },
	    filters: ['creditcard', 'password'],
	    __plugins: [],
	};

	var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign$1 = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$1.apply(this, arguments);
	};
	var __awaiter$2 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator$2 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(throttled_events_logger, "__esModule", { value: true });
	throttled_events_logger.ThrottledEventsLogger = void 0;
	var json_nd_1 = require$$0;
	var util_1$2 = util$1;
	var defaults_1$1 = defaults;
	var ThrottledEventsLogger = /** @class */ (function () {
	    function ThrottledEventsLogger(config, transport) {
	        this.config = config;
	        this.transport = transport;
	        this.queue = [];
	        this.isProcessing = false;
	        this.config = __assign$1(__assign$1({}, defaults_1$1.CONFIG), config);
	        this.logger = this.originalLogger();
	    }
	    ThrottledEventsLogger.prototype.configure = function (opts) {
	        for (var k in opts) {
	            this.config[k] = opts[k];
	        }
	    };
	    ThrottledEventsLogger.prototype.log = function (payload) {
	        this.queue.push(payload);
	        if (!this.isProcessing) {
	            this.processQueue();
	        }
	    };
	    ThrottledEventsLogger.prototype.processQueue = function () {
	        var _this = this;
	        if (this.queue.length === 0 || this.isProcessing) {
	            return;
	        }
	        this.isProcessing = true;
	        var eventsData = this.queue.slice();
	        this.queue = [];
	        var data = json_nd_1.NdJson.stringify(eventsData);
	        this.makeHttpRequest(data)
	            .then(function () {
	            setTimeout(function () {
	                _this.isProcessing = false;
	                _this.processQueue();
	            }, 50);
	        })
	            .catch(function (error) {
	            _this.logger.error('[Honeybadger] Error making HTTP request:', error);
	            // Continue processing the queue even if there's an error
	            setTimeout(function () {
	                _this.isProcessing = false;
	                _this.processQueue();
	            }, 50);
	        });
	    };
	    ThrottledEventsLogger.prototype.makeHttpRequest = function (data) {
	        return __awaiter$2(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator$2(this, function (_a) {
	                return [2 /*return*/, this.transport
	                        .send({
	                        headers: {
	                            'X-API-Key': this.config.apiKey,
	                            'Content-Type': 'application/json',
	                        },
	                        method: 'POST',
	                        endpoint: (0, util_1$2.endpoint)(this.config.endpoint, '/v1/events'),
	                        maxObjectDepth: this.config.maxObjectDepth,
	                        logger: this.logger,
	                    }, data)
	                        .then(function () {
	                        if (_this.config.debug) {
	                            _this.logger.debug('[Honeybadger] Events sent successfully');
	                        }
	                    })
	                        .catch(function (err) {
	                        _this.logger.error("[Honeybadger] Error sending events: ".concat(err.message));
	                    })];
	            });
	        });
	    };
	    /**
	     * todo: improve this
	     *
	     * The EventsLogger overrides the console methods to enable automatic instrumentation
	     * of console logs to the Honeybadger API.
	     * So if we want to log something in here we need to use the original methods.
	     */
	    ThrottledEventsLogger.prototype.originalLogger = function () {
	        var _a, _b, _c, _d, _e;
	        return {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            log: (_a = console.log.__hb_original) !== null && _a !== void 0 ? _a : console.log,
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            info: (_b = console.info.__hb_original) !== null && _b !== void 0 ? _b : console.info,
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            debug: (_c = console.debug.__hb_original) !== null && _c !== void 0 ? _c : console.debug,
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            warn: (_d = console.warn.__hb_original) !== null && _d !== void 0 ? _d : console.warn,
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            error: (_e = console.error.__hb_original) !== null && _e !== void 0 ? _e : console.error,
	        };
	    };
	    return ThrottledEventsLogger;
	}());
	throttled_events_logger.ThrottledEventsLogger = ThrottledEventsLogger;

	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator$1 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(client, "__esModule", { value: true });
	client.Client = void 0;
	var util_1$1 = util$1;
	var store_1 = store;
	var throttled_events_logger_1 = throttled_events_logger;
	var defaults_1 = defaults;
	// Split at commas and spaces
	var TAG_SEPARATOR = /,|\s+/;
	// Checks for non-blank characters
	var NOT_BLANK = /\S/;
	var Client = /** @class */ (function () {
	    function Client(opts, transport) {
	        if (opts === void 0) { opts = {}; }
	        this.__pluginsLoaded = false;
	        this.__store = null;
	        this.__beforeNotifyHandlers = [];
	        this.__afterNotifyHandlers = [];
	        this.__notifier = {
	            name: '@honeybadger-io/core',
	            url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/core',
	            version: '6.9.3'
	        };
	        this.config = __assign(__assign({}, defaults_1.CONFIG), opts);
	        this.__initStore();
	        this.__transport = transport;
	        this.__eventsLogger = new throttled_events_logger_1.ThrottledEventsLogger(this.config, this.__transport);
	        this.logger = (0, util_1$1.logger)(this);
	    }
	    Client.prototype.getVersion = function () {
	        return this.__notifier.version;
	    };
	    Client.prototype.getNotifier = function () {
	        return this.__notifier;
	    };
	    /**
	     * CAREFUL: When adding a new notifier or updating the name of an existing notifier,
	     * the Honeybadger rails project may need its mappings updated.
	     * See https://github.com/honeybadger-io/honeybadger/blob/master/app/presenters/breadcrumbs_presenter.rb
	     *     https://github.com/honeybadger-io/honeybadger/blob/master/app/models/parser/java_script.rb
	     *     https://github.com/honeybadger-io/honeybadger/blob/master/app/models/language.rb
	     **/
	    Client.prototype.setNotifier = function (notifier) {
	        this.__notifier = notifier;
	    };
	    Client.prototype.configure = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        for (var k in opts) {
	            this.config[k] = opts[k];
	        }
	        this.__eventsLogger.configure(this.config);
	        this.loadPlugins();
	        return this;
	    };
	    Client.prototype.loadPlugins = function () {
	        var _this = this;
	        var pluginsToLoad = this.__pluginsLoaded
	            ? this.config.__plugins.filter(function (plugin) { return plugin.shouldReloadOnConfigure; })
	            : this.config.__plugins;
	        pluginsToLoad.forEach(function (plugin) { return plugin.load(_this); });
	        this.__pluginsLoaded = true;
	    };
	    Client.prototype.__initStore = function () {
	        this.__store = new store_1.GlobalStore({ context: {}, breadcrumbs: [] }, this.config.maxBreadcrumbs);
	    };
	    Client.prototype.beforeNotify = function (handler) {
	        this.__beforeNotifyHandlers.push(handler);
	        return this;
	    };
	    Client.prototype.afterNotify = function (handler) {
	        this.__afterNotifyHandlers.push(handler);
	        return this;
	    };
	    Client.prototype.setContext = function (context) {
	        if (typeof context === 'object' && context != null) {
	            this.__store.setContext(context);
	        }
	        return this;
	    };
	    Client.prototype.resetContext = function (context) {
	        this.logger.warn('Deprecation warning: `Honeybadger.resetContext()` has been deprecated; please use `Honeybadger.clear()` instead.');
	        this.__store.clear();
	        if (typeof context === 'object' && context !== null) {
	            this.__store.setContext(context);
	        }
	        return this;
	    };
	    Client.prototype.clear = function () {
	        this.__store.clear();
	        return this;
	    };
	    Client.prototype.notify = function (noticeable, name, extra) {
	        var _this = this;
	        if (name === void 0) { name = undefined; }
	        if (extra === void 0) { extra = undefined; }
	        var notice = this.makeNotice(noticeable, name, extra);
	        // we need to have the source file data before the beforeNotifyHandlers,
	        // in case they modify them
	        var sourceCodeData = notice && notice.backtrace ? notice.backtrace.map(function (trace) { return (0, util_1$1.shallowClone)(trace); }) : null;
	        var preConditionsResult = this.__runPreconditions(notice);
	        if (preConditionsResult instanceof Error) {
	            (0, util_1$1.runAfterNotifyHandlers)(notice, this.__afterNotifyHandlers, preConditionsResult);
	            return false;
	        }
	        if (preConditionsResult instanceof Promise) {
	            preConditionsResult.then(function (result) {
	                if (result instanceof Error) {
	                    (0, util_1$1.runAfterNotifyHandlers)(notice, _this.__afterNotifyHandlers, result);
	                    return false;
	                }
	                return _this.__send(notice, sourceCodeData);
	            });
	            return true;
	        }
	        this.__send(notice, sourceCodeData).catch(function (_err) { });
	        return true;
	    };
	    /**
	     * An async version of {@link notify} that resolves only after the notice has been reported to Honeybadger.
	     * Implemented using the {@link afterNotify} hook.
	     * Rejects if for any reason the report failed to be reported.
	     * Useful in serverless environments (AWS Lambda).
	     */
	    Client.prototype.notifyAsync = function (noticeable, name, extra) {
	        var _this = this;
	        if (name === void 0) { name = undefined; }
	        if (extra === void 0) { extra = undefined; }
	        return new Promise(function (resolve, reject) {
	            var applyAfterNotify = function (partialNotice) {
	                var originalAfterNotify = partialNotice.afterNotify;
	                partialNotice.afterNotify = function (err) {
	                    originalAfterNotify === null || originalAfterNotify === void 0 ? void 0 : originalAfterNotify.call(_this, err);
	                    if (err) {
	                        return reject(err);
	                    }
	                    resolve();
	                };
	            };
	            // We have to respect any afterNotify hooks that come from the arguments
	            var objectToOverride;
	            if (noticeable.afterNotify) {
	                objectToOverride = noticeable;
	            }
	            else if (name && name.afterNotify) {
	                objectToOverride = name;
	            }
	            else if (extra && extra.afterNotify) {
	                objectToOverride = extra;
	            }
	            else if (name && typeof name === 'object') {
	                objectToOverride = name;
	            }
	            else if (extra) {
	                objectToOverride = extra;
	            }
	            else {
	                objectToOverride = name = {};
	            }
	            applyAfterNotify(objectToOverride);
	            _this.notify(noticeable, name, extra);
	        });
	    };
	    Client.prototype.makeNotice = function (noticeable, name, extra) {
	        if (name === void 0) { name = undefined; }
	        if (extra === void 0) { extra = undefined; }
	        var notice = (0, util_1$1.makeNotice)(noticeable);
	        if (name && !(typeof name === 'object')) {
	            var n = String(name);
	            name = { name: n };
	        }
	        if (name) {
	            notice = (0, util_1$1.mergeNotice)(notice, name);
	        }
	        if (typeof extra === 'object' && extra !== null) {
	            notice = (0, util_1$1.mergeNotice)(notice, extra);
	        }
	        if ((0, util_1$1.objectIsEmpty)(notice)) {
	            return null;
	        }
	        var context = this.__store.getContents('context');
	        var noticeTags = this.__constructTags(notice.tags);
	        var contextTags = this.__constructTags(context['tags']);
	        var configTags = this.__constructTags(this.config.tags);
	        // Turning into a Set will remove duplicates
	        var tags = noticeTags.concat(contextTags).concat(configTags);
	        var uniqueTags = tags.filter(function (item, index) { return tags.indexOf(item) === index; });
	        notice = (0, util_1$1.merge)(notice, {
	            name: notice.name || 'Error',
	            context: (0, util_1$1.merge)(context, notice.context),
	            projectRoot: notice.projectRoot || this.config.projectRoot,
	            environment: notice.environment || this.config.environment,
	            component: notice.component || this.config.component,
	            action: notice.action || this.config.action,
	            revision: notice.revision || this.config.revision,
	            tags: uniqueTags,
	        });
	        // If we're passed a custom backtrace array, use it
	        // Otherwise we make one.
	        if (!Array.isArray(notice.backtrace) || !notice.backtrace.length) {
	            if (typeof notice.stack !== 'string' || !notice.stack.trim()) {
	                notice.stack = (0, util_1$1.generateStackTrace)();
	                notice.backtrace = (0, util_1$1.makeBacktrace)(notice.stack, true, this.logger);
	            }
	            else {
	                notice.backtrace = (0, util_1$1.makeBacktrace)(notice.stack, false, this.logger);
	            }
	        }
	        return notice;
	    };
	    Client.prototype.addBreadcrumb = function (message, opts) {
	        if (!this.config.breadcrumbsEnabled) {
	            return;
	        }
	        opts = opts || {};
	        var metadata = (0, util_1$1.shallowClone)(opts.metadata);
	        var category = opts.category || 'custom';
	        var timestamp = new Date().toISOString();
	        this.__store.addBreadcrumb({
	            category: category,
	            message: message,
	            metadata: metadata,
	            timestamp: timestamp
	        });
	        return this;
	    };
	    /**
	     * @deprecated Use {@link event} instead.
	     */
	    Client.prototype.logEvent = function (data) {
	        (0, util_1$1.logDeprecatedMethod)(this.logger, 'Honeybadger.logEvent', 'Honeybadger.event');
	        this.event('log', data);
	    };
	    Client.prototype.event = function (type, data) {
	        var _a;
	        if (typeof type === 'object') {
	            data = type;
	            type = (_a = type['event_type']) !== null && _a !== void 0 ? _a : undefined;
	        }
	        this.__eventsLogger.log(__assign({ event_type: type, ts: new Date().toISOString() }, data));
	    };
	    Client.prototype.__getBreadcrumbs = function () {
	        return this.__store.getContents('breadcrumbs').slice();
	    };
	    Client.prototype.__getContext = function () {
	        return this.__store.getContents('context');
	    };
	    Client.prototype.__developmentMode = function () {
	        if (this.config.reportData === true) {
	            return false;
	        }
	        return (this.config.environment && this.config.developmentEnvironments.includes(this.config.environment));
	    };
	    Client.prototype.__buildPayload = function (notice) {
	        var headers = (0, util_1$1.filter)(notice.headers, this.config.filters) || {};
	        var cgiData = (0, util_1$1.filter)(__assign(__assign({}, notice.cgiData), (0, util_1$1.formatCGIData)(headers, 'HTTP_')), this.config.filters);
	        return {
	            notifier: this.__notifier,
	            breadcrumbs: {
	                enabled: !!this.config.breadcrumbsEnabled,
	                trail: notice.__breadcrumbs || []
	            },
	            error: {
	                class: notice.name,
	                message: notice.message,
	                backtrace: notice.backtrace,
	                fingerprint: notice.fingerprint,
	                tags: notice.tags,
	                causes: (0, util_1$1.getCauses)(notice, this.logger),
	            },
	            request: {
	                url: (0, util_1$1.filterUrl)(notice.url, this.config.filters),
	                component: notice.component,
	                action: notice.action,
	                context: notice.context,
	                cgi_data: cgiData,
	                params: (0, util_1$1.filter)(notice.params, this.config.filters) || {},
	                session: (0, util_1$1.filter)(notice.session, this.config.filters) || {}
	            },
	            server: {
	                project_root: notice.projectRoot,
	                environment_name: notice.environment,
	                revision: notice.revision,
	                hostname: this.config.hostname,
	                time: new Date().toUTCString()
	            },
	            details: notice.details || {}
	        };
	    };
	    Client.prototype.__constructTags = function (tags) {
	        if (!tags) {
	            return [];
	        }
	        return tags.toString().split(TAG_SEPARATOR).filter(function (tag) { return NOT_BLANK.test(tag); });
	    };
	    Client.prototype.__runPreconditions = function (notice) {
	        var _this = this;
	        var preConditionError = null;
	        if (!notice) {
	            this.logger.debug('failed to build error report');
	            preConditionError = new Error('failed to build error report');
	        }
	        if (this.config.reportData === false) {
	            this.logger.debug('skipping error report: honeybadger.js is disabled', notice);
	            preConditionError = new Error('honeybadger.js is disabled');
	        }
	        if (this.__developmentMode()) {
	            this.logger.log('honeybadger.js is in development mode; the following error report will be sent in production.', notice);
	            preConditionError = new Error('honeybadger.js is in development mode');
	        }
	        if (!this.config.apiKey) {
	            this.logger.warn('could not send error report: no API key has been configured', notice);
	            preConditionError = new Error('missing API key');
	        }
	        var beforeNotifyResult = (0, util_1$1.runBeforeNotifyHandlers)(notice, this.__beforeNotifyHandlers);
	        if (!preConditionError && !beforeNotifyResult.result) {
	            this.logger.debug('skipping error report: one or more beforeNotify handlers returned false', notice);
	            preConditionError = new Error('beforeNotify handlers returned false');
	        }
	        if (beforeNotifyResult.results.length && beforeNotifyResult.results.some(function (result) { return result instanceof Promise; })) {
	            return Promise.allSettled(beforeNotifyResult.results)
	                .then(function (results) {
	                if (!preConditionError && (results.some(function (result) { return result.status === 'rejected' || result.value === false; }))) {
	                    _this.logger.debug('skipping error report: one or more beforeNotify handlers returned false', notice);
	                    preConditionError = new Error('beforeNotify handlers (async) returned false');
	                }
	                if (preConditionError) {
	                    return preConditionError;
	                }
	            });
	        }
	        return preConditionError;
	    };
	    Client.prototype.__send = function (notice, originalBacktrace) {
	        var _this = this;
	        if (this.config.breadcrumbsEnabled) {
	            this.addBreadcrumb('Honeybadger Notice', {
	                category: 'notice',
	                metadata: {
	                    message: notice.message,
	                    name: notice.name,
	                    stack: notice.stack
	                }
	            });
	            notice.__breadcrumbs = this.__store.getContents('breadcrumbs');
	        }
	        else {
	            notice.__breadcrumbs = [];
	        }
	        return (0, util_1$1.getSourceForBacktrace)(originalBacktrace, this.__getSourceFileHandler)
	            .then(function (sourcePerTrace) { return __awaiter$1(_this, void 0, void 0, function () {
	            var payload;
	            return __generator$1(this, function (_a) {
	                sourcePerTrace.forEach(function (source, index) {
	                    notice.backtrace[index].source = source;
	                });
	                payload = this.__buildPayload(notice);
	                return [2 /*return*/, this.__transport
	                        .send({
	                        headers: {
	                            'X-API-Key': this.config.apiKey,
	                            'Content-Type': 'application/json',
	                            'Accept': 'text/json, application/json'
	                        },
	                        method: 'POST',
	                        endpoint: (0, util_1$1.endpoint)(this.config.endpoint, '/v1/notices/js'),
	                        maxObjectDepth: this.config.maxObjectDepth,
	                        logger: this.logger,
	                    }, payload)];
	            });
	        }); })
	            .then(function (res) {
	            if (res.statusCode !== 201) {
	                (0, util_1$1.runAfterNotifyHandlers)(notice, _this.__afterNotifyHandlers, new Error("Bad HTTP response: ".concat(res.statusCode)));
	                _this.logger.warn("Error report failed: unknown response from server. code=".concat(res.statusCode));
	                return false;
	            }
	            var uuid = JSON.parse(res.body).id;
	            (0, util_1$1.runAfterNotifyHandlers)((0, util_1$1.merge)(notice, {
	                id: uuid
	            }), _this.__afterNotifyHandlers);
	            _this.logger.info("Error report sent \u26A1 https://app.honeybadger.io/notice/".concat(uuid));
	            return true;
	        })
	            .catch(function (err) {
	            _this.logger.error('Error report failed: an unknown error occurred.', "message=".concat(err.message));
	            (0, util_1$1.runAfterNotifyHandlers)(notice, _this.__afterNotifyHandlers, err);
	            return false;
	        });
	    };
	    return Client;
	}());
	client.Client = Client;

	var types = {};

	Object.defineProperty(types, "__esModule", { value: true });

	(function (exports) {
		var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    var desc = Object.getOwnPropertyDescriptor(m, k);
		    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
		      desc = { enumerable: true, get: function() { return m[k]; } };
		    }
		    Object.defineProperty(o, k2, desc);
		}) : (function(o, m, k, k2) {
		    if (k2 === undefined) k2 = k;
		    o[k2] = m[k];
		}));
		var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
		    Object.defineProperty(o, "default", { enumerable: true, value: v });
		}) : function(o, v) {
		    o["default"] = v;
		});
		var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
		    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
		};
		var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
		    if (mod && mod.__esModule) return mod;
		    var result = {};
		    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
		    __setModuleDefault(result, mod);
		    return result;
		};
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Plugins = exports.Util = exports.Types = exports.Client = void 0;
		var events_1 = __importDefault(events);
		var client_1 = client;
		Object.defineProperty(exports, "Client", { enumerable: true, get: function () { return client_1.Client; } });
		__exportStar(store, exports);
		exports.Types = __importStar(types);
		exports.Util = __importStar(util$1);
		exports.Plugins = {
		    events: events_1.default
		};
		
	} (src));

	var util = {};

	Object.defineProperty(util, "__esModule", { value: true });
	util.preferCatch = util.encodeCookie = util.decodeCookie = util.localURLPathname = util.parseURL = util.nativeFetch = util.stringTextOfElement = util.stringSelectorOfElement = util.stringNameOfElement = void 0;
	var core_1$6 = src;
	var globalThisOrWindow$6 = core_1$6.Util.globalThisOrWindow;
	/**
	 * Converts an HTMLElement into a human-readable string.
	 * @param {!HTMLElement} element
	 * @return {string}
	 */
	function stringNameOfElement(element) {
	    if (!element || !element.tagName) {
	        return '';
	    }
	    var name = element.tagName.toLowerCase();
	    // Ignore the root <html> element in selectors and events.
	    if (name === 'html') {
	        return '';
	    }
	    if (element.id) {
	        name += "#".concat(element.id);
	    }
	    var stringClassNames = element.getAttribute('class');
	    if (stringClassNames) {
	        stringClassNames.split(/\s+/).forEach(function (className) {
	            name += ".".concat(className);
	        });
	    }
	    ['alt', 'name', 'title', 'type'].forEach(function (attrName) {
	        var attr = element.getAttribute(attrName);
	        if (attr) {
	            name += "[".concat(attrName, "=\"").concat(attr, "\"]");
	        }
	    });
	    var siblings = getSiblings(element);
	    if (siblings.length > 1) {
	        name += ":nth-child(".concat(Array.prototype.indexOf.call(siblings, element) + 1, ")");
	    }
	    return name;
	}
	util.stringNameOfElement = stringNameOfElement;
	function stringSelectorOfElement(element) {
	    var name = stringNameOfElement(element);
	    if (element.parentNode && element.parentNode.tagName) {
	        var parentName = stringSelectorOfElement(element.parentNode);
	        if (parentName.length > 0) {
	            return "".concat(parentName, " > ").concat(name);
	        }
	    }
	    return name;
	}
	util.stringSelectorOfElement = stringSelectorOfElement;
	function stringTextOfElement(element) {
	    var text = element.textContent || element.innerText || '';
	    if (!text && (element.type === 'submit' || element.type === 'button')) {
	        text = element.value;
	    }
	    return truncate(text.trim(), 300);
	}
	util.stringTextOfElement = stringTextOfElement;
	function nativeFetch() {
	    var global = globalThisOrWindow$6();
	    if (!global.fetch) {
	        return false;
	    }
	    if (isNative(global.fetch)) {
	        return true;
	    }
	    if (typeof document === 'undefined') {
	        return false;
	    }
	    // If fetch isn't native, it may be wrapped by someone else. Try to get
	    // a pristine function from an iframe.
	    try {
	        var sandbox = document.createElement('iframe');
	        sandbox.style.display = 'none';
	        document.head.appendChild(sandbox);
	        var result = sandbox.contentWindow.fetch && isNative(sandbox.contentWindow.fetch);
	        document.head.removeChild(sandbox);
	        return result;
	    }
	    catch (err) {
	        if (console && console.warn) {
	            console.warn('failed to detect native fetch via iframe: ' + err);
	        }
	    }
	    return false;
	}
	util.nativeFetch = nativeFetch;
	function isNative(func) {
	    return func.toString().indexOf('native') !== -1;
	}
	function parseURL(url) {
	    // Regexp: https://tools.ietf.org/html/rfc3986#appendix-B
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/) || {};
	    return {
	        protocol: match[2],
	        host: match[4],
	        pathname: match[5]
	    };
	}
	util.parseURL = parseURL;
	function localURLPathname(url) {
	    var parsed = parseURL(url);
	    var parsedDocURL = parseURL(document.URL);
	    // URL must be relative
	    if (!parsed.host || !parsed.protocol) {
	        return parsed.pathname;
	    }
	    // Same domain
	    if (parsed.protocol === parsedDocURL.protocol && parsed.host === parsedDocURL.host) {
	        return parsed.pathname;
	    }
	    // x-domain
	    return "".concat(parsed.protocol, "://").concat(parsed.host).concat(parsed.pathname);
	}
	util.localURLPathname = localURLPathname;
	function decodeCookie(string) {
	    var result = {};
	    string.split(/[;,]\s?/).forEach(function (pair) {
	        var _a = pair.split('=', 2), key = _a[0], value = _a[1];
	        result[key] = value;
	    });
	    return result;
	}
	util.decodeCookie = decodeCookie;
	function encodeCookie(object) {
	    if (typeof object !== 'object') {
	        return undefined;
	    }
	    var cookies = [];
	    for (var k in object) {
	        cookies.push(k + '=' + object[k]);
	    }
	    return cookies.join(';');
	}
	util.encodeCookie = encodeCookie;
	// Helpers
	function getSiblings(element) {
	    try {
	        var nodes = element.parentNode.childNodes;
	        var siblings_1 = [];
	        Array.prototype.forEach.call(nodes, function (node) {
	            if (node.tagName && node.tagName === element.tagName) {
	                siblings_1.push(node);
	            }
	        });
	        return siblings_1;
	    }
	    catch (e) {
	        return [];
	    }
	}
	function truncate(string, length) {
	    if (string.length > length) {
	        string = string.substr(0, length) + '...';
	    }
	    return string;
	}
	// Used to decide which error handling method to use when wrapping async
	// handlers: try/catch, or `window.onerror`. When available, `window.onerror`
	// will provide more information in modern browsers.
	util.preferCatch = (function () {
	    var preferCatch = true;
	    // In case we're in an environment without access to "window", lets make sure theres a window.
	    if (typeof window === 'undefined')
	        return preferCatch;
	    // IE < 10
	    if (!window.atob) {
	        preferCatch = false;
	    }
	    // Modern browsers support the full ErrorEvent API
	    // See https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
	    if (window.ErrorEvent) {
	        try {
	            if ((new window.ErrorEvent('')).colno === 0) {
	                preferCatch = false;
	            }
	            // eslint-disable-next-line no-empty
	        }
	        catch (_e) { }
	    }
	    return preferCatch;
	})();

	var onerror = {};

	Object.defineProperty(onerror, "__esModule", { value: true });
	onerror.onError = onerror.ignoreNextOnError = void 0;
	/* eslint-disable prefer-rest-params */
	var core_1$5 = src;
	var instrument$4 = core_1$5.Util.instrument, makeNotice = core_1$5.Util.makeNotice, globalThisOrWindow$5 = core_1$5.Util.globalThisOrWindow;
	var ignoreOnError = 0;
	var currentTimeout;
	function ignoreNextOnError() {
	    ignoreOnError += 1;
	    clearTimeout(currentTimeout);
	    currentTimeout = setTimeout(function () {
	        ignoreOnError = 0;
	    });
	}
	onerror.ignoreNextOnError = ignoreNextOnError;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function onError(_window) {
	    if (_window === void 0) { _window = globalThisOrWindow$5(); }
	    return {
	        load: function (client) {
	            instrument$4(_window, 'onerror', function (original) {
	                var onerror = function (msg, url, line, col, err) {
	                    client.logger.debug('window.onerror callback invoked', arguments);
	                    if (ignoreOnError > 0) {
	                        client.logger.debug('Ignoring window.onerror (error likely reported earlier)', arguments);
	                        ignoreOnError -= 1;
	                        return;
	                    }
	                    // See https://developer.mozilla.org/en/docs/Web/API/GlobalEventHandlers/onerror#Notes
	                    if (line === 0 && /Script error\.?/.test(msg)) {
	                        if (client.config.enableUncaught) {
	                            // Log only if the user wants to report uncaught errors
	                            client.logger.warn('Ignoring cross-domain script error: enable CORS to track these types of errors', arguments);
	                        }
	                        return;
	                    }
	                    var notice = makeNotice(err);
	                    if (!notice.name) {
	                        notice.name = 'window.onerror';
	                    }
	                    if (!notice.message) {
	                        notice.message = msg;
	                    }
	                    if (!notice.stack) {
	                        // Simulate v8 stack
	                        notice.stack = [notice.message, '\n    at ? (', url || 'unknown', ':', line || 0, ':', col || 0, ')'].join('');
	                    }
	                    client.addBreadcrumb((notice.name === 'window.onerror' || !notice.name) ? 'window.onerror' : "window.onerror: ".concat(notice.name), {
	                        category: 'error',
	                        metadata: {
	                            name: notice.name,
	                            message: notice.message,
	                            stack: notice.stack
	                        }
	                    });
	                    if (client.config.enableUncaught) {
	                        client.notify(notice);
	                    }
	                };
	                return function (msg, url, line, col, err) {
	                    onerror(msg, url, line, col, err);
	                    if (typeof original === 'function') {
	                        return original.apply(_window, arguments);
	                    }
	                    return false;
	                };
	            });
	        }
	    };
	}
	onerror.onError = onError;

	var onunhandledrejection = {};

	Object.defineProperty(onunhandledrejection, "__esModule", { value: true });
	/* eslint-disable prefer-rest-params */
	var core_1$4 = src;
	var instrument$3 = core_1$4.Util.instrument, globalThisOrWindow$4 = core_1$4.Util.globalThisOrWindow;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function default_1$3(_window) {
	    if (_window === void 0) { _window = globalThisOrWindow$4(); }
	    return {
	        load: function (client) {
	            if (!client.config.enableUnhandledRejection) {
	                return;
	            }
	            instrument$3(_window, 'onunhandledrejection', function (original) {
	                // See https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
	                function onunhandledrejection(promiseRejectionEvent) {
	                    var _a;
	                    client.logger.debug('window.onunhandledrejection callback invoked', arguments);
	                    if (!client.config.enableUnhandledRejection) {
	                        return;
	                    }
	                    var reason = promiseRejectionEvent.reason;
	                    if (reason instanceof Error) {
	                        // simulate v8 stack
	                        // const fileName = reason.fileName || 'unknown'
	                        // const lineNumber = reason.lineNumber || 0
	                        var fileName = 'unknown';
	                        var lineNumber = 0;
	                        var stackFallback = "".concat(reason.message, "\n    at ? (").concat(fileName, ":").concat(lineNumber, ")");
	                        var stack = reason.stack || stackFallback;
	                        var err = {
	                            name: reason.name,
	                            message: "UnhandledPromiseRejectionWarning: ".concat(reason),
	                            stack: stack
	                        };
	                        client.addBreadcrumb("window.onunhandledrejection: ".concat(err.name), {
	                            category: 'error',
	                            metadata: err
	                        });
	                        client.notify(err);
	                        return;
	                    }
	                    var message = typeof reason === 'string' ? reason : ((_a = JSON.stringify(reason)) !== null && _a !== void 0 ? _a : 'Unspecified reason');
	                    client.notify({
	                        name: 'window.onunhandledrejection',
	                        message: "UnhandledPromiseRejectionWarning: ".concat(message)
	                    });
	                }
	                return function (promiseRejectionEvent) {
	                    onunhandledrejection(promiseRejectionEvent);
	                    if (typeof original === 'function') {
	                        original.apply(this, arguments);
	                    }
	                };
	            });
	        }
	    };
	}
	onunhandledrejection.default = default_1$3;

	var breadcrumbs = {};

	Object.defineProperty(breadcrumbs, "__esModule", { value: true });
	/* eslint-disable prefer-rest-params */
	var core_1$3 = src;
	var util_1 = util;
	var sanitize$1 = core_1$3.Util.sanitize, instrument$2 = core_1$3.Util.instrument, instrumentConsole = core_1$3.Util.instrumentConsole, globalThisOrWindow$3 = core_1$3.Util.globalThisOrWindow;
	function default_1$2(_window) {
	    if (_window === void 0) { _window = globalThisOrWindow$3(); }
	    return {
	        load: function (client) {
	            function breadcrumbsEnabled(type) {
	                if (client.config.breadcrumbsEnabled === true) {
	                    return true;
	                }
	                if (type) {
	                    return client.config.breadcrumbsEnabled[type] === true;
	                }
	                return client.config.breadcrumbsEnabled !== false;
	            }
	            // Breadcrumbs: instrument console
	            (function () {
	                if (!breadcrumbsEnabled('console')) {
	                    return;
	                }
	                function inspectArray(obj) {
	                    if (!Array.isArray(obj)) {
	                        return '';
	                    }
	                    return obj.map(function (value) {
	                        try {
	                            return String(value);
	                        }
	                        catch (e) {
	                            return '[unknown]';
	                        }
	                    }).join(' ');
	                }
	                instrumentConsole(_window, function (level, args) {
	                    var message = inspectArray(args);
	                    var opts = {
	                        category: 'log',
	                        metadata: {
	                            level: level,
	                            arguments: sanitize$1(args, 3)
	                        }
	                    };
	                    client.addBreadcrumb(message, opts);
	                });
	            })();
	            // Breadcrumbs: instrument click events
	            (function () {
	                if (!breadcrumbsEnabled('dom')) {
	                    return;
	                }
	                if (typeof _window.addEventListener !== 'function') {
	                    return;
	                }
	                _window.addEventListener('click', function (event) {
	                    var message, selector, text;
	                    try {
	                        message = (0, util_1.stringNameOfElement)(event.target);
	                        selector = (0, util_1.stringSelectorOfElement)(event.target);
	                        text = (0, util_1.stringTextOfElement)(event.target);
	                    }
	                    catch (e) {
	                        message = 'UI Click';
	                        selector = '[unknown]';
	                        text = '[unknown]';
	                    }
	                    // There's nothing to display
	                    if (message.length === 0) {
	                        return;
	                    }
	                    client.addBreadcrumb(message, {
	                        category: 'ui.click',
	                        metadata: {
	                            selector: selector,
	                            text: text,
	                            event: event
	                        }
	                    });
	                }, _window.location ? true : false); // In CloudFlare workers useCapture must be false. window.location is a hacky way to detect it.
	            })();
	            // Breadcrumbs: instrument XMLHttpRequest
	            (function () {
	                if (!breadcrumbsEnabled('network')) {
	                    return;
	                }
	                // Some environments may not support XMLHttpRequest.
	                if (typeof XMLHttpRequest === 'undefined') {
	                    return;
	                }
	                // -- On xhr.open: capture initial metadata
	                instrument$2(XMLHttpRequest.prototype, 'open', function (original) {
	                    return function () {
	                        // eslint-disable-next-line @typescript-eslint/no-this-alias
	                        var xhr = this;
	                        var rawUrl = arguments[1];
	                        // in case of url being URL object (which is valid input) we need to stringify it
	                        var url = typeof rawUrl === 'string' ? rawUrl : String(rawUrl);
	                        var method = typeof arguments[0] === 'string' ? arguments[0].toUpperCase() : arguments[0];
	                        var message = "".concat(method, " ").concat((0, util_1.localURLPathname)(url));
	                        this.__hb_xhr = {
	                            type: 'xhr',
	                            method: method,
	                            url: url,
	                            message: message
	                        };
	                        if (typeof original === 'function') {
	                            original.apply(xhr, arguments);
	                        }
	                    };
	                });
	                // -- On xhr.send: set up xhr.onreadystatechange to report breadcrumb
	                instrument$2(XMLHttpRequest.prototype, 'send', function (original) {
	                    return function () {
	                        // eslint-disable-next-line @typescript-eslint/no-this-alias
	                        var xhr = this;
	                        function onreadystatechangeHandler() {
	                            if (xhr.readyState === 4) {
	                                var message = void 0;
	                                if (xhr.__hb_xhr) {
	                                    xhr.__hb_xhr.status_code = xhr.status;
	                                    message = xhr.__hb_xhr.message;
	                                    delete xhr.__hb_xhr.message;
	                                }
	                                client.addBreadcrumb(message || 'XMLHttpRequest', {
	                                    category: 'request',
	                                    metadata: xhr.__hb_xhr
	                                });
	                            }
	                        }
	                        if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                            instrument$2(xhr, 'onreadystatechange', function (original) {
	                                return function () {
	                                    onreadystatechangeHandler();
	                                    if (typeof original === 'function') {
	                                        // eslint-disable-next-line prefer-rest-params
	                                        original.apply(this, arguments);
	                                    }
	                                };
	                            });
	                        }
	                        else {
	                            xhr.onreadystatechange = onreadystatechangeHandler;
	                        }
	                        if (typeof original === 'function') {
	                            // eslint-disable-next-line prefer-rest-params
	                            original.apply(xhr, arguments);
	                        }
	                    };
	                });
	            })();
	            // Breadcrumbs: instrument fetch
	            (function () {
	                if (!breadcrumbsEnabled('network')) {
	                    return;
	                }
	                if (!(0, util_1.nativeFetch)()) {
	                    // Polyfills use XHR.
	                    return;
	                }
	                instrument$2(_window, 'fetch', function (original) {
	                    return function () {
	                        // eslint-disable-next-line prefer-rest-params
	                        var input = arguments[0];
	                        var method = 'GET';
	                        var url;
	                        if (typeof input === 'string') {
	                            url = input;
	                        }
	                        else if ('Request' in _window && input instanceof Request) {
	                            url = input.url;
	                            if (input.method) {
	                                method = input.method;
	                            }
	                        }
	                        else {
	                            url = String(input);
	                        }
	                        if (arguments[1] && arguments[1].method) {
	                            method = arguments[1].method;
	                        }
	                        if (typeof method === 'string') {
	                            method = method.toUpperCase();
	                        }
	                        // localURLPathname cant be constructed for CF workers due to reliance on "document".
	                        var message = "".concat(method, " ").concat(typeof document === 'undefined' ? url : (0, util_1.localURLPathname)(url));
	                        var metadata = {
	                            type: 'fetch',
	                            method: method,
	                            url: url
	                        };
	                        return original
	                            .apply(this, arguments)
	                            .then(function (response) {
	                            metadata['status_code'] = response.status;
	                            client.addBreadcrumb(message, {
	                                category: 'request',
	                                metadata: metadata
	                            });
	                            return response;
	                        })
	                            .catch(function (error) {
	                            client.addBreadcrumb('fetch error', {
	                                category: 'error',
	                                metadata: metadata
	                            });
	                            throw error;
	                        });
	                    };
	                });
	            })();
	            // Breadcrumbs: instrument navigation
	            (function () {
	                if (!breadcrumbsEnabled('navigation')) {
	                    return;
	                }
	                if (_window.location == null) {
	                    // Most likely in a CF worker, we should be listening to fetch requests instead.
	                    return;
	                }
	                // The last known href of the current page
	                var lastHref = _window.location.href;
	                function recordUrlChange(from, to) {
	                    lastHref = to;
	                    client.addBreadcrumb('Page changed', {
	                        category: 'navigation',
	                        metadata: {
	                            from: from,
	                            to: to
	                        }
	                    });
	                }
	                if (typeof addEventListener === 'function') {
	                    addEventListener('popstate', function (_event) {
	                        recordUrlChange(lastHref, _window.location.href);
	                    });
	                }
	                if (typeof _window.history === 'undefined') {
	                    return;
	                }
	                // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
	                // https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
	                function historyWrapper(original) {
	                    return function () {
	                        var url = arguments.length > 2 ? arguments[2] : undefined;
	                        if (url) {
	                            recordUrlChange(lastHref, String(url));
	                        }
	                        return original.apply(this, arguments);
	                    };
	                }
	                instrument$2(_window.history, 'pushState', historyWrapper);
	                instrument$2(_window.history, 'replaceState', historyWrapper);
	            })();
	        }
	    };
	}
	breadcrumbs.default = default_1$2;

	var timers = {};

	Object.defineProperty(timers, "__esModule", { value: true });
	/* eslint-disable prefer-rest-params */
	var core_1$2 = src;
	var instrument$1 = core_1$2.Util.instrument, globalThisOrWindow$2 = core_1$2.Util.globalThisOrWindow;
	function default_1$1(_window) {
	    if (_window === void 0) { _window = globalThisOrWindow$2(); }
	    return {
	        load: function (client) {
	            // Wrap timers
	            (function () {
	                function instrumentTimer(wrapOpts) {
	                    return function (original) {
	                        // See https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout
	                        return function (func, delay) {
	                            if (typeof func === 'function') {
	                                var args_1 = Array.prototype.slice.call(arguments, 2);
	                                func = client.__wrap(func, wrapOpts);
	                                return original(function () {
	                                    func.apply(void 0, args_1);
	                                }, delay);
	                            }
	                            else {
	                                return original(func, delay);
	                            }
	                        };
	                    };
	                }
	                instrument$1(_window, 'setTimeout', instrumentTimer({ component: 'setTimeout' }));
	                instrument$1(_window, 'setInterval', instrumentTimer({ component: 'setInterval' }));
	            })();
	        }
	    };
	}
	timers.default = default_1$1;

	var event_listeners = {};

	Object.defineProperty(event_listeners, "__esModule", { value: true });
	var core_1$1 = src;
	var instrument = core_1$1.Util.instrument, globalThisOrWindow$1 = core_1$1.Util.globalThisOrWindow;
	function default_1(_window) {
	    if (_window === void 0) { _window = globalThisOrWindow$1(); }
	    return {
	        load: function (client) {
	            // Wrap event listeners
	            // Event targets borrowed from bugsnag-js:
	            // See https://github.com/bugsnag/bugsnag-js/blob/d55af916a4d3c7757f979d887f9533fe1a04cc93/src/bugsnag.js#L542
	            var targets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	            targets.forEach(function (prop) {
	                var prototype = _window[prop] && _window[prop].prototype;
	                if (prototype && Object.prototype.hasOwnProperty.call(prototype, 'addEventListener')) {
	                    instrument(prototype, 'addEventListener', function (original) {
	                        var wrapOpts = { component: "".concat(prop, ".prototype.addEventListener") };
	                        // See https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	                        return function (type, listener, useCapture, wantsUntrusted) {
	                            try {
	                                if (listener && listener.handleEvent != null) {
	                                    listener.handleEvent = client.__wrap(listener.handleEvent, wrapOpts);
	                                }
	                            }
	                            catch (e) {
	                                // Ignore 'Permission denied to access property "handleEvent"' errors.
	                                client.logger.error(e);
	                            }
	                            return original.call(this, type, client.__wrap(listener, wrapOpts), useCapture, wantsUntrusted);
	                        };
	                    });
	                    instrument(prototype, 'removeEventListener', function (original) {
	                        return function (type, listener, useCapture, wantsUntrusted) {
	                            original.call(this, type, listener, useCapture, wantsUntrusted);
	                            return original.call(this, type, client.__wrap(listener), useCapture, wantsUntrusted);
	                        };
	                    });
	                }
	            });
	        }
	    };
	}
	event_listeners.default = default_1;

	var transport = {};

	var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(transport, "__esModule", { value: true });
	transport.BrowserTransport = void 0;
	var core_1 = src;
	var sanitize = core_1.Util.sanitize, globalThisOrWindow = core_1.Util.globalThisOrWindow;
	/**
	 * Helper function to get typesafe Object.entries()
	 * https://twitter.com/mattpocockuk/status/1502264005251018754?lang=en
	 */
	function objectEntries(obj) {
	    return Object.entries(obj);
	}
	var BrowserTransport = /** @class */ (function () {
	    function BrowserTransport(headers) {
	        if (headers === void 0) { headers = {}; }
	        this.headers = {};
	        this.headers = headers;
	    }
	    BrowserTransport.prototype.defaultHeaders = function () {
	        return this.headers;
	    };
	    BrowserTransport.prototype.send = function (options, payload) {
	        return __awaiter(this, void 0, void 0, function () {
	            var headerArray, headers, requestInit, response, body;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        headerArray = options.headers ? objectEntries(options.headers) : [];
	                        headers = this.defaultHeaders();
	                        headerArray.forEach(function (_a) {
	                            var key = _a[0], value = _a[1];
	                            if (key != null && value != null) {
	                                headers[String(key)] = String(value);
	                            }
	                        });
	                        requestInit = {
	                            method: options.method,
	                            headers: headers
	                        };
	                        // GET methods cannot have a body.
	                        if (options.method === 'POST' && payload) {
	                            requestInit.body = typeof payload === 'string' ? payload : JSON.stringify(sanitize(payload, options.maxObjectDepth));
	                        }
	                        return [4 /*yield*/, globalThisOrWindow().fetch(options.endpoint, requestInit)];
	                    case 1:
	                        response = _a.sent();
	                        return [4 /*yield*/, response.text()];
	                    case 2:
	                        body = _a.sent();
	                        return [2 /*return*/, Promise.resolve({ statusCode: response.status, body: body })];
	                }
	            });
	        });
	    };
	    return BrowserTransport;
	}());
	transport.BrowserTransport = BrowserTransport;

	(function (exports) {
		var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
		    var extendStatics = function (d, b) {
		        extendStatics = Object.setPrototypeOf ||
		            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
		            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
		        return extendStatics(d, b);
		    };
		    return function (d, b) {
		        if (typeof b !== "function" && b !== null)
		            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
		        extendStatics(d, b);
		        function __() { this.constructor = d; }
		        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		    };
		})();
		var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
		    __assign = Object.assign || function(t) {
		        for (var s, i = 1, n = arguments.length; i < n; i++) {
		            s = arguments[i];
		            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
		                t[p] = s[p];
		        }
		        return t;
		    };
		    return __assign.apply(this, arguments);
		};
		var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
		    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
		    return new (P || (P = Promise))(function (resolve, reject) {
		        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		        step((generator = generator.apply(thisArg, _arguments || [])).next());
		    });
		};
		var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
		    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
		    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
		    function verb(n) { return function (v) { return step([n, v]); }; }
		    function step(op) {
		        if (f) throw new TypeError("Generator is already executing.");
		        while (_) try {
		            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
		            if (y = 0, t) op = [op[0] & 2, t.value];
		            switch (op[0]) {
		                case 0: case 1: t = op; break;
		                case 4: _.label++; return { value: op[1], done: false };
		                case 5: _.label++; y = op[1]; op = [0]; continue;
		                case 7: op = _.ops.pop(); _.trys.pop(); continue;
		                default:
		                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
		                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
		                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
		                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
		                    if (t[2]) _.ops.pop();
		                    _.trys.pop(); continue;
		            }
		            op = body.call(thisArg, _);
		        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
		        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
		    }
		};
		var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
		    return (mod && mod.__esModule) ? mod : { "default": mod };
		};
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Types = exports.getUserFeedbackScriptUrl = void 0;
		var core_1 = src;
		var util_1 = util;
		var onerror_1 = onerror;
		var onunhandledrejection_1 = __importDefault(onunhandledrejection);
		var breadcrumbs_1 = __importDefault(breadcrumbs);
		var timers_1 = __importDefault(timers);
		var event_listeners_1 = __importDefault(event_listeners);
		var transport_1 = transport;
		var merge = core_1.Util.merge, filter = core_1.Util.filter, objectIsExtensible = core_1.Util.objectIsExtensible, globalThisOrWindow = core_1.Util.globalThisOrWindow;
		var getProjectRoot = function () {
		    var global = globalThisOrWindow();
		    var projectRoot = '';
		    // Cloudflare workers do not have access to location API.
		    if (global.location != null) {
		        projectRoot = global.location.protocol + '//' + global.location.host;
		    }
		    return projectRoot;
		};
		var getUserFeedbackScriptUrl = function (version) {
		    var majorMinorVersion = version.split('.').slice(0, 2).join('.');
		    return "https://js.honeybadger.io/v".concat(majorMinorVersion, "/honeybadger-feedback-form.js");
		};
		exports.getUserFeedbackScriptUrl = getUserFeedbackScriptUrl;
		var Honeybadger = /** @class */ (function (_super) {
		    __extends(Honeybadger, _super);
		    function Honeybadger(opts) {
		        if (opts === void 0) { opts = {}; }
		        var _this = _super.call(this, __assign({ userFeedbackEndpoint: 'https://api.honeybadger.io/v2/feedback', async: true, maxErrors: null, projectRoot: getProjectRoot() }, opts), new transport_1.BrowserTransport({
		            'User-Agent': userAgent(),
		        })) || this;
		        /** @internal */
		        _this.__errorsSent = 0;
		        /** @internal */
		        _this.__lastWrapErr = undefined;
		        /** @internal */
		        _this.__lastNoticeId = undefined;
		        /** @internal */
		        _this.__beforeNotifyHandlers = [
		            function (notice) {
		                if (_this.__exceedsMaxErrors()) {
		                    _this.logger.debug('Dropping notice: max errors exceeded', notice);
		                    return false;
		                }
		                if (notice && !notice.url && typeof document !== 'undefined') {
		                    notice.url = document.URL;
		                }
		                _this.__incrementErrorsCount();
		                return true;
		            }
		        ];
		        _this.__afterNotifyHandlers = [
		            function (_error, notice) {
		                if (notice) {
		                    _this.__lastNoticeId = notice.id;
		                }
		            }
		        ];
		        return _this;
		    }
		    Honeybadger.prototype.configure = function (opts) {
		        if (opts === void 0) { opts = {}; }
		        return _super.prototype.configure.call(this, opts);
		    };
		    Honeybadger.prototype.resetMaxErrors = function () {
		        return (this.__errorsSent = 0);
		    };
		    Honeybadger.prototype.factory = function (opts) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        var clone = new Honeybadger(opts);
		        clone.setNotifier(this.getNotifier());
		        return clone;
		    };
		    Honeybadger.prototype.checkIn = function (_id) {
		        throw new Error('Honeybadger.checkIn() is not supported on the browser');
		    };
		    Honeybadger.prototype.showUserFeedbackForm = function (options) {
		        if (options === void 0) { options = {}; }
		        return __awaiter(this, void 0, void 0, function () {
		            var global;
		            return __generator(this, function (_a) {
		                if (!this.config || !this.config.apiKey) {
		                    this.logger.debug('Client not initialized');
		                    return [2 /*return*/];
		                }
		                if (!this.__lastNoticeId) {
		                    this.logger.debug("Can't show user feedback form without a notice already reported");
		                    return [2 /*return*/];
		                }
		                global = globalThisOrWindow();
		                if (typeof global.document === 'undefined') {
		                    this.logger.debug('global.document is undefined. Cannot attach script');
		                    return [2 /*return*/];
		                }
		                if (this.isUserFeedbackScriptUrlAlreadyVisible()) {
		                    this.logger.debug('User feedback form is already visible');
		                    return [2 /*return*/];
		                }
		                global['honeybadgerUserFeedbackOptions'] = __assign(__assign({}, options), { apiKey: this.config.apiKey, endpoint: this.config.userFeedbackEndpoint, noticeId: this.__lastNoticeId });
		                this.appendUserFeedbackScriptTag(global, options);
		                return [2 /*return*/];
		            });
		        });
		    };
		    Honeybadger.prototype.appendUserFeedbackScriptTag = function (window, options) {
		        if (options === void 0) { options = {}; }
		        var script = window.document.createElement('script');
		        script.setAttribute('src', this.getUserFeedbackSubmitUrl());
		        script.setAttribute('async', 'true');
		        if (options.onLoad) {
		            script.onload = options.onLoad;
		        }
		        (commonjsGlobal.document.head || commonjsGlobal.document.body).appendChild(script);
		    };
		    Honeybadger.prototype.isUserFeedbackScriptUrlAlreadyVisible = function () {
		        var global = globalThisOrWindow();
		        var feedbackScriptUrl = this.getUserFeedbackSubmitUrl();
		        for (var i = 0; i < global.document.scripts.length; i++) {
		            var script = global.document.scripts[i];
		            if (script.src === feedbackScriptUrl) {
		                return true;
		            }
		        }
		        return false;
		    };
		    Honeybadger.prototype.getUserFeedbackSubmitUrl = function () {
		        return (0, exports.getUserFeedbackScriptUrl)(this.getVersion());
		    };
		    /** @internal */
		    Honeybadger.prototype.__buildPayload = function (notice) {
		        var cgiData = {
		            HTTP_USER_AGENT: undefined,
		            HTTP_REFERER: undefined,
		            HTTP_COOKIE: undefined
		        };
		        if (typeof navigator !== 'undefined' && navigator.userAgent) {
		            cgiData.HTTP_USER_AGENT = navigator.userAgent;
		        }
		        if (typeof document !== 'undefined' && document.referrer.match(/\S/)) {
		            cgiData.HTTP_REFERER = document.referrer;
		        }
		        var cookiesObject;
		        if (typeof notice.cookies === 'string') {
		            cookiesObject = (0, util_1.decodeCookie)(notice.cookies);
		        }
		        else {
		            cookiesObject = notice.cookies;
		        }
		        if (cookiesObject) {
		            cgiData.HTTP_COOKIE = (0, util_1.encodeCookie)(filter(cookiesObject, this.config.filters));
		        }
		        var payload = _super.prototype.__buildPayload.call(this, notice);
		        payload.request.cgi_data = merge(cgiData, payload.request.cgi_data);
		        return payload;
		    };
		    /**
		     * wrap always returns the same function so that callbacks can be removed via
		     * removeEventListener.
		     * @internal
		     */
		    Honeybadger.prototype.__wrap = function (f, opts) {
		        if (opts === void 0) { opts = {}; }
		        var func = f;
		        if (!opts) {
		            opts = {};
		        }
		        try {
		            if (typeof func !== 'function') {
		                return func;
		            }
		            if (!objectIsExtensible(func)) {
		                return func;
		            }
		            if (!func.___hb) {
		                // eslint-disable-next-line @typescript-eslint/no-this-alias
		                var client_1 = this;
		                func.___hb = function () {
		                    if (util_1.preferCatch) {
		                        try {
		                            // eslint-disable-next-line prefer-rest-params
		                            return func.apply(this, arguments);
		                        }
		                        catch (err) {
		                            if (client_1.__lastWrapErr === err) {
		                                throw (err);
		                            }
		                            client_1.__lastWrapErr = err;
		                            (0, onerror_1.ignoreNextOnError)();
		                            client_1.addBreadcrumb(opts.component ? "".concat(opts.component, ": ").concat(err.name) : err.name, {
		                                category: 'error',
		                                metadata: {
		                                    message: err.message,
		                                    name: err.name,
		                                    stack: err.stack
		                                }
		                            });
		                            if (client_1.config.enableUncaught) {
		                                client_1.notify(err);
		                            }
		                            throw (err);
		                        }
		                    }
		                    else {
		                        // eslint-disable-next-line prefer-rest-params
		                        return func.apply(this, arguments);
		                    }
		                };
		            }
		            func.___hb.___hb = func.___hb;
		            return func.___hb;
		        }
		        catch (_e) {
		            return func;
		        }
		    };
		    /** @internal */
		    Honeybadger.prototype.__incrementErrorsCount = function () {
		        return this.__errorsSent++;
		    };
		    /** @internal */
		    Honeybadger.prototype.__exceedsMaxErrors = function () {
		        return this.config.maxErrors && this.__errorsSent >= this.config.maxErrors;
		    };
		    return Honeybadger;
		}(core_1.Client));
		var NOTIFIER = {
		    name: '@honeybadger-io/js',
		    url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/js',
		    version: '6.9.3'
		};
		var userAgent = function () {
		    if (typeof navigator !== 'undefined') {
		        return "Honeybadger JS Browser Client ".concat(NOTIFIER.version, "; ").concat(navigator.userAgent);
		    }
		    return "Honeybadger JS Browser Client ".concat(NOTIFIER.version, "; n/a; n/a");
		};
		var singleton = new Honeybadger({
		    __plugins: [
		        (0, onerror_1.onError)(),
		        (0, onunhandledrejection_1.default)(),
		        (0, timers_1.default)(),
		        (0, event_listeners_1.default)(),
		        (0, breadcrumbs_1.default)(),
		        core_1.Plugins.events(),
		    ]
		});
		singleton.setNotifier(NOTIFIER);
		var core_2 = src;
		Object.defineProperty(exports, "Types", { enumerable: true, get: function () { return core_2.Types; } });
		exports.default = singleton;
		
	} (browser$1));

	var browser = /*@__PURE__*/getDefaultExportFromCjs(browser$1);

	return browser;

}));
//# sourceMappingURL=honeybadger.js.map


/***/ }),

/***/ 37627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ HoneybadgerErrorBoundary; }
/* harmony export */ });
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5417);
/* harmony import */ var _honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99084);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61820);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





// eslint-disable-next-line @typescript-eslint/ban-types
class DefaultErrorComponent extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
    render() {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", { className: 'error' },
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, "An Error Occurred"),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, JSON.stringify(this.props.error, null, 2)),
            react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", null, this.props.info ? JSON.stringify(this.props.info, null, 2) : '')));
    }
}
DefaultErrorComponent.propTypes = {
    error: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object),
    info: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
};

class HoneybadgerErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_1__.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            info: null,
            errorOccurred: false
        };
        this.props.honeybadger.afterNotify((error, _notice) => {
            if (!error && this.props.showUserFeedbackFormOnError) {
                this.props.honeybadger.showUserFeedbackForm();
            }
        });
    }
    static getDerivedStateFromError(error) {
        return { error: error, errorOccurred: true, info: null };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ errorOccurred: true, error: error, info: errorInfo });
        this.props.honeybadger.notify(error, { context: errorInfo });
    }
    getErrorComponent() {
        return this.props.ErrorComponent
            ? react__WEBPACK_IMPORTED_MODULE_1__.createElement(this.props.ErrorComponent, this.state)
            : react__WEBPACK_IMPORTED_MODULE_1__.createElement(DefaultErrorComponent, { ...this.state });
    }
    render() {
        return (react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, this.state.errorOccurred
            ? this.getErrorComponent()
            : this.props.children));
    }
}
HoneybadgerErrorBoundary.propTypes = {
    honeybadger: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object.isRequired),
    showUserFeedbackFormOnError: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().element),
    ErrorComponent: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().element), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)])
};
HoneybadgerErrorBoundary.defaultProps = {
    showUserFeedbackFormOnError: false
};

const NOTIFIER = {
    name: '@honeybadger-io/react',
    url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/react',
    version: '6.1.23'
};
_honeybadger_io_js__WEBPACK_IMPORTED_MODULE_0___default().setNotifier(NOTIFIER);


//# sourceMappingURL=honeybadger-react.esm.js.map


/***/ }),

/***/ 30301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19857);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48557);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_css_index_css__WEBPACK_IMPORTED_MODULE_2__);





const Overlay = _ref => {
  let {
    as: ComponentToRender,
    children,
    color,
    className,
    fixedToRelative,
    enabled,
    visible,
    animation,
    ...props
  } = _ref;
  const positionClass = fixedToRelative ? (_css_index_css__WEBPACK_IMPORTED_MODULE_2___default()["fixed-to-relative"]) : (_css_index_css__WEBPACK_IMPORTED_MODULE_2___default()["fixed-to-page"]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentToRender, (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__["default"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_css_index_css__WEBPACK_IMPORTED_MODULE_2___default().overlay), (_css_index_css__WEBPACK_IMPORTED_MODULE_2___default())[`color-${color}`], positionClass, className, {
      [(_css_index_css__WEBPACK_IMPORTED_MODULE_2___default()["not-enabled"])]: !enabled,
      [(_css_index_css__WEBPACK_IMPORTED_MODULE_2___default()["not-visible"])]: !visible,
      [(_css_index_css__WEBPACK_IMPORTED_MODULE_2___default().animated)]: animation
    })
  }, props), children);
};
 false ? 0 : void 0;
Overlay.defaultProps = {
  as: 'aside',
  color: 'dark',
  className: '',
  fixedToRelative: false,
  enabled: true,
  visible: true,
  animation: true
};

/***/ }),

/***/ 15771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70509);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99084);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59087);
/* harmony import */ var _css_index_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_index_css__WEBPACK_IMPORTED_MODULE_1__);




const Spinner = _ref => {
  let {
    className,
    size,
    ...props
  } = _ref;
  const sizeClass = size ? (_css_index_css__WEBPACK_IMPORTED_MODULE_1___default())[`size-${size}`] : (_css_index_css__WEBPACK_IMPORTED_MODULE_1___default()["size-default"]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_corejs3_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__["default"])({
    className: `${(_css_index_css__WEBPACK_IMPORTED_MODULE_1___default().loading)} ${sizeClass} ${className}`,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: (_css_index_css__WEBPACK_IMPORTED_MODULE_1___default().spinner),
    cx: "50%",
    cy: "50%",
    r: "10",
    strokeDasharray: "0",
    strokeDashoffset: "0"
  }));
};
 false ? 0 : void 0;
Spinner.defaultProps = {
  className: '',
  size: null
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);

/***/ }),

/***/ 58105:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} str
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 12398:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(96360);

module.exports = parent;


/***/ }),

/***/ 56596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(53466);

module.exports = parent;


/***/ }),

/***/ 93657:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(65450);
var entryVirtual = __webpack_require__(65974);

module.exports = entryVirtual('Function').bind;


/***/ }),

/***/ 85593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(59433);
var method = __webpack_require__(93657);

var FunctionPrototype = Function.prototype;

module.exports = function (it) {
  var own = it.bind;
  return it === FunctionPrototype || (isPrototypeOf(FunctionPrototype, it) && own === FunctionPrototype.bind) ? method : own;
};


/***/ }),

/***/ 77512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(48582);
var path = __webpack_require__(3999);

module.exports = path.Object.assign;


/***/ }),

/***/ 22783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(12398);

module.exports = parent;


/***/ }),

/***/ 86708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(56596);

module.exports = parent;


/***/ }),

/***/ 23188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(64960);
var tryToString = __webpack_require__(4101);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 33903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(49949);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 17407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(69693);
var toAbsoluteIndex = __webpack_require__(47952);
var lengthOfArrayLike = __webpack_require__(48368);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 59497:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 74965:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 58835:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14406);
var definePropertyModule = __webpack_require__(54926);
var createPropertyDescriptor = __webpack_require__(54007);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 54007:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 27448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 14406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(19699);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 19900:
/***/ (function(module) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 12751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);
var isObject = __webpack_require__(49949);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 82182:
/***/ (function(module) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 59483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);
var userAgent = __webpack_require__(82182);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 65974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(3999);

module.exports = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};


/***/ }),

/***/ 89105:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 37377:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41614);
var apply = __webpack_require__(5043);
var uncurryThis = __webpack_require__(97028);
var isCallable = __webpack_require__(64960);
var getOwnPropertyDescriptor = (__webpack_require__(86038).f);
var isForced = __webpack_require__(79725);
var path = __webpack_require__(3999);
var bind = __webpack_require__(2733);
var createNonEnumerableProperty = __webpack_require__(58835);
var hasOwn = __webpack_require__(42031);

var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return apply(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwn(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;

    // bind methods to global for calling from export context
    if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
    // wrap global constructors for prevent changes in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && isCallable(sourceProperty)) resultProperty = uncurryThis(sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwn(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};


/***/ }),

/***/ 19699:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 5043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(38772);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 2733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(97028);
var aCallable = __webpack_require__(23188);
var NATIVE_BIND = __webpack_require__(38772);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 38772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(19699);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 66681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(21481);
var aCallable = __webpack_require__(23188);
var isObject = __webpack_require__(49949);
var hasOwn = __webpack_require__(42031);
var arraySlice = __webpack_require__(59497);
var NATIVE_BIND = __webpack_require__(38772);

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ 85837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(38772);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 97028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classofRaw = __webpack_require__(74965);
var uncurryThis = __webpack_require__(21481);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 21481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(38772);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 39602:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(3999);
var global = __webpack_require__(41614);
var isCallable = __webpack_require__(64960);

var aFunction = function (variable) {
  return isCallable(variable) ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 8516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(23188);
var isNullOrUndefined = __webpack_require__(42283);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 41614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 42031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);
var toObject = __webpack_require__(77020);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 19656:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 45512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14406);
var fails = __webpack_require__(19699);
var createElement = __webpack_require__(12751);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 89281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);
var fails = __webpack_require__(19699);
var classof = __webpack_require__(74965);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 64960:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var $documentAll = __webpack_require__(19900);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 79725:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(19699);
var isCallable = __webpack_require__(64960);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 42283:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 49949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(64960);
var $documentAll = __webpack_require__(19900);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 53720:
/***/ (function(module) {

module.exports = true;


/***/ }),

/***/ 32974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(39602);
var isCallable = __webpack_require__(64960);
var isPrototypeOf = __webpack_require__(59433);
var USE_SYMBOL_AS_UID = __webpack_require__(14511);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 48368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(55371);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 80340:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 17335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14406);
var uncurryThis = __webpack_require__(21481);
var call = __webpack_require__(85837);
var fails = __webpack_require__(19699);
var objectKeys = __webpack_require__(11783);
var getOwnPropertySymbolsModule = __webpack_require__(42429);
var propertyIsEnumerableModule = __webpack_require__(64793);
var toObject = __webpack_require__(77020);
var IndexedObject = __webpack_require__(89281);

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 54926:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14406);
var IE8_DOM_DEFINE = __webpack_require__(45512);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(54163);
var anObject = __webpack_require__(33903);
var toPropertyKey = __webpack_require__(68887);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 86038:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14406);
var call = __webpack_require__(85837);
var propertyIsEnumerableModule = __webpack_require__(64793);
var createPropertyDescriptor = __webpack_require__(54007);
var toIndexedObject = __webpack_require__(69693);
var toPropertyKey = __webpack_require__(68887);
var hasOwn = __webpack_require__(42031);
var IE8_DOM_DEFINE = __webpack_require__(45512);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 42429:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 59433:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 36224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);
var hasOwn = __webpack_require__(42031);
var toIndexedObject = __webpack_require__(69693);
var indexOf = (__webpack_require__(17407).indexOf);
var hiddenKeys = __webpack_require__(19656);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 11783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(36224);
var enumBugKeys = __webpack_require__(89105);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 64793:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 20674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(85837);
var isCallable = __webpack_require__(64960);
var isObject = __webpack_require__(49949);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3999:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 30849:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(42283);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 40604:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);
var defineGlobalProperty = __webpack_require__(27448);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 64268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(53720);
var store = __webpack_require__(40604);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 69728:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(59483);
var fails = __webpack_require__(19699);
var global = __webpack_require__(41614);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 47952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(28955);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 69693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(89281);
var requireObjectCoercible = __webpack_require__(30849);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 28955:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(80340);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 55371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(28955);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 77020:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(30849);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 60820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(85837);
var isObject = __webpack_require__(49949);
var isSymbol = __webpack_require__(32974);
var getMethod = __webpack_require__(8516);
var ordinaryToPrimitive = __webpack_require__(20674);
var wellKnownSymbol = __webpack_require__(81132);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 68887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(60820);
var isSymbol = __webpack_require__(32974);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 4101:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 84809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(21481);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 14511:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(69728);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 54163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14406);
var fails = __webpack_require__(19699);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 81132:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(41614);
var shared = __webpack_require__(64268);
var hasOwn = __webpack_require__(42031);
var uid = __webpack_require__(84809);
var NATIVE_SYMBOL = __webpack_require__(69728);
var USE_SYMBOL_AS_UID = __webpack_require__(14511);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 65450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove from `core-js@4`
var $ = __webpack_require__(37377);
var bind = __webpack_require__(66681);

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});


/***/ }),

/***/ 48582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(37377);
var assign = __webpack_require__(17335);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 96360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(85593);

module.exports = parent;


/***/ }),

/***/ 53466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parent = __webpack_require__(77512);

module.exports = parent;


/***/ }),

/***/ 26367:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 83245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = camelCase;


/***/ }),

/***/ 64233:
/***/ (function(module) {

var __dirname = "/";
(()=>{"use strict";if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var e={};(()=>{var r=e;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */r.parse=parse;r.serialize=serialize;var i=decodeURIComponent;var t=encodeURIComponent;var a=/; */;var n=/^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;function parse(e,r){if(typeof e!=="string"){throw new TypeError("argument str must be a string")}var t={};var n=r||{};var o=e.split(a);var s=n.decode||i;for(var p=0;p<o.length;p++){var f=o[p];var u=f.indexOf("=");if(u<0){continue}var v=f.substr(0,u).trim();var c=f.substr(++u,f.length).trim();if('"'==c[0]){c=c.slice(1,-1)}if(undefined==t[v]){t[v]=tryDecode(c,s)}}return t}function serialize(e,r,i){var a=i||{};var o=a.encode||t;if(typeof o!=="function"){throw new TypeError("option encode is invalid")}if(!n.test(e)){throw new TypeError("argument name is invalid")}var s=o(r);if(s&&!n.test(s)){throw new TypeError("argument val is invalid")}var p=e+"="+s;if(null!=a.maxAge){var f=a.maxAge-0;if(isNaN(f)||!isFinite(f)){throw new TypeError("option maxAge is invalid")}p+="; Max-Age="+Math.floor(f)}if(a.domain){if(!n.test(a.domain)){throw new TypeError("option domain is invalid")}p+="; Domain="+a.domain}if(a.path){if(!n.test(a.path)){throw new TypeError("option path is invalid")}p+="; Path="+a.path}if(a.expires){if(typeof a.expires.toUTCString!=="function"){throw new TypeError("option expires is invalid")}p+="; Expires="+a.expires.toUTCString()}if(a.httpOnly){p+="; HttpOnly"}if(a.secure){p+="; Secure"}if(a.sameSite){var u=typeof a.sameSite==="string"?a.sameSite.toLowerCase():a.sameSite;switch(u){case true:p+="; SameSite=Strict";break;case"lax":p+="; SameSite=Lax";break;case"strict":p+="; SameSite=Strict";break;case"none":p+="; SameSite=None";break;default:throw new TypeError("option sameSite is invalid")}}return p}function tryDecode(e,r){try{return r(e)}catch(r){return e}}})();module.exports=e})();

/***/ }),

/***/ 62490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = getCookieParser;
__webpack_unused_export__ = sendStatusCode;
__webpack_unused_export__ = redirect;
__webpack_unused_export__ = checkIsManualRevalidate;
__webpack_unused_export__ = clearPreviewData;
__webpack_unused_export__ = sendError;
__webpack_unused_export__ = setLazyProp;
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
function getCookieParser(headers) {
    return function parseCookie() {
        const header = headers.cookie;
        if (!header) {
            return {};
        }
        const { parse: parseCookieFn  } = __webpack_require__(64233);
        return parseCookieFn(Array.isArray(header) ? header.join(";") : header);
    };
}
function sendStatusCode(res, statusCode) {
    res.statusCode = statusCode;
    return res;
}
function redirect(res, statusOrUrl, url) {
    if (typeof statusOrUrl === "string") {
        url = statusOrUrl;
        statusOrUrl = 307;
    }
    if (typeof statusOrUrl !== "number" || typeof url !== "string") {
        throw new Error(`Invalid redirect arguments. Please use a single argument URL, e.g. res.redirect('/destination') or use a status code and URL, e.g. res.redirect(307, '/destination').`);
    }
    res.writeHead(statusOrUrl, {
        Location: url
    });
    res.write(url);
    res.end();
    return res;
}
const PRERENDER_REVALIDATE_HEADER = "x-prerender-revalidate";
__webpack_unused_export__ = PRERENDER_REVALIDATE_HEADER;
const PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER = "x-prerender-revalidate-if-generated";
__webpack_unused_export__ = PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER;
function checkIsManualRevalidate(req, previewProps) {
    return {
        isManualRevalidate: req.headers[PRERENDER_REVALIDATE_HEADER] === previewProps.previewModeId,
        revalidateOnlyGenerated: !!req.headers[PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER]
    };
}
const COOKIE_NAME_PRERENDER_BYPASS = `__prerender_bypass`;
__webpack_unused_export__ = COOKIE_NAME_PRERENDER_BYPASS;
const COOKIE_NAME_PRERENDER_DATA = `__next_preview_data`;
__webpack_unused_export__ = COOKIE_NAME_PRERENDER_DATA;
const RESPONSE_LIMIT_DEFAULT = 4 * 1024 * 1024;
__webpack_unused_export__ = RESPONSE_LIMIT_DEFAULT;
const SYMBOL_PREVIEW_DATA = Symbol(COOKIE_NAME_PRERENDER_DATA);
__webpack_unused_export__ = SYMBOL_PREVIEW_DATA;
const SYMBOL_CLEARED_COOKIES = Symbol(COOKIE_NAME_PRERENDER_BYPASS);
__webpack_unused_export__ = SYMBOL_CLEARED_COOKIES;
function clearPreviewData(res, options = {}) {
    if (SYMBOL_CLEARED_COOKIES in res) {
        return res;
    }
    const { serialize  } = __webpack_require__(64233);
    const previous = res.getHeader("Set-Cookie");
    res.setHeader(`Set-Cookie`, [
        ...typeof previous === "string" ? [
            previous
        ] : Array.isArray(previous) ? previous : [],
        serialize(COOKIE_NAME_PRERENDER_BYPASS, "", {
            // To delete a cookie, set `expires` to a date in the past:
            // https://tools.ietf.org/html/rfc6265#section-4.1.1
            // `Max-Age: 0` is not valid, thus ignored, and the cookie is persisted.
            expires: new Date(0),
            httpOnly: true,
            sameSite:  true ? "none" : 0,
            secure: "production" !== "development",
            path: "/",
            ...options.path !== undefined ? {
                path: options.path
            } : undefined
        }),
        serialize(COOKIE_NAME_PRERENDER_DATA, "", {
            // To delete a cookie, set `expires` to a date in the past:
            // https://tools.ietf.org/html/rfc6265#section-4.1.1
            // `Max-Age: 0` is not valid, thus ignored, and the cookie is persisted.
            expires: new Date(0),
            httpOnly: true,
            sameSite:  true ? "none" : 0,
            secure: "production" !== "development",
            path: "/",
            ...options.path !== undefined ? {
                path: options.path
            } : undefined
        }), 
    ]);
    Object.defineProperty(res, SYMBOL_CLEARED_COOKIES, {
        value: true,
        enumerable: false
    });
    return res;
}
class ApiError extends Error {
    constructor(statusCode, message){
        super(message);
        this.statusCode = statusCode;
    }
}
exports.MS = ApiError;
function sendError(res, statusCode, message) {
    res.statusCode = statusCode;
    res.statusMessage = message;
    res.end(message);
}
function setLazyProp({ req  }, prop, getter) {
    const opts = {
        configurable: true,
        enumerable: true
    };
    const optsReset = {
        ...opts,
        writable: true
    };
    Object.defineProperty(req, prop, {
        ...opts,
        get: ()=>{
            const value = getter();
            // we set the property on the object to avoid recalculating it
            Object.defineProperty(req, prop, {
                ...optsReset,
                value
            });
            return value;
        },
        set: (value)=>{
            Object.defineProperty(req, prop, {
                ...optsReset,
                value
            });
        }
    });
}

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 41414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7339)


/***/ }),

/***/ 20158:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94896)


/***/ }),

/***/ 48069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4795)


/***/ }),

/***/ 37082:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 28754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(43694);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 61820:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(28754)();
}


/***/ }),

/***/ 43694:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 87005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(32319);var f=__webpack_require__(99084),g=60103;exports.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");exports.Fragment=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 72491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(87005);
} else {}


/***/ }),

/***/ 16248:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(99084);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 9118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(16248);
} else {}


/***/ }),

/***/ 19857:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 70024:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cn": function() { return /* binding */ esm_atom; },
  "KO": function() { return /* binding */ useAtom; },
  "Dv": function() { return /* binding */ useAtomValue; },
  "b9": function() { return /* binding */ useSetAtom; }
});

// UNUSED EXPORTS: Provider, SECRET_INTERNAL_getScopeContext, SECRET_INTERNAL_registerPromiseAbort, unstable_createStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(99084);
;// CONCATENATED MODULE: ./node_modules/jotai/esm/vanilla.mjs
let keyCount = 0;
function atom(read, write) {
  const key = `atom${++keyCount}`;
  const config = {
    toString: () => key
  };
  if (typeof read === "function") {
    config.read = read;
  } else {
    config.init = read;
    config.read = (get) => get(config);
    config.write = (get, set, arg) => set(
      config,
      typeof arg === "function" ? arg(get(config)) : arg
    );
  }
  if (write) {
    config.write = write;
  }
  return config;
}

const hasInitialValue = (atom) => "init" in atom;
const isActuallyWritableAtom = (atom) => !!atom.write;
const cancelPromiseMap = /* @__PURE__ */ new WeakMap();
const registerCancelPromise = (promise, cancel) => {
  cancelPromiseMap.set(promise, cancel);
  promise.catch(() => {
  }).finally(() => cancelPromiseMap.delete(promise));
};
const cancelPromise = (promise, next) => {
  const cancel = cancelPromiseMap.get(promise);
  if (cancel) {
    cancelPromiseMap.delete(promise);
    cancel(next);
  }
};
const resolvePromise = (promise, value) => {
  promise.status = "fulfilled";
  promise.value = value;
};
const rejectPromise = (promise, e) => {
  promise.status = "rejected";
  promise.reason = e;
};
const isEqualAtomValue = (a, b) => "v" in a && "v" in b && Object.is(a.v, b.v);
const isEqualAtomError = (a, b) => "e" in a && "e" in b && Object.is(a.e, b.e);
const hasPromiseAtomValue = (a) => "v" in a && a.v instanceof Promise;
const returnAtomValue = (atomState) => {
  if ("e" in atomState) {
    throw atomState.e;
  }
  return atomState.v;
};
const createStore = () => {
  const atomStateMap = /* @__PURE__ */ new WeakMap();
  const mountedMap = /* @__PURE__ */ new WeakMap();
  const pendingMap = /* @__PURE__ */ new Map();
  let stateListeners;
  let mountedAtoms;
  if (true) {
    stateListeners = /* @__PURE__ */ new Set();
    mountedAtoms = /* @__PURE__ */ new Set();
  }
  const getAtomState = (atom) => atomStateMap.get(atom);
  const setAtomState = (atom, atomState) => {
    if (true) {
      Object.freeze(atomState);
    }
    const prevAtomState = atomStateMap.get(atom);
    atomStateMap.set(atom, atomState);
    if (!pendingMap.has(atom)) {
      pendingMap.set(atom, prevAtomState);
    }
    if (prevAtomState && hasPromiseAtomValue(prevAtomState)) {
      const next = "v" in atomState ? atomState.v instanceof Promise ? atomState.v : Promise.resolve(atomState.v) : Promise.reject(atomState.e);
      cancelPromise(prevAtomState.v, next);
    }
  };
  const updateDependencies = (atom, nextAtomState, depSet) => {
    const dependencies = /* @__PURE__ */ new Map();
    let changed = false;
    depSet.forEach((a) => {
      const aState = a === atom ? nextAtomState : getAtomState(a);
      if (aState) {
        dependencies.set(a, aState);
        if (nextAtomState.d.get(a) !== aState) {
          changed = true;
        }
      } else if (true) {
        console.warn("[Bug] atom state not found");
      }
    });
    if (changed || nextAtomState.d.size !== dependencies.size) {
      nextAtomState.d = dependencies;
    }
  };
  const setAtomValue = (atom, value, depSet) => {
    const prevAtomState = getAtomState(atom);
    const nextAtomState = {
      d: (prevAtomState == null ? void 0 : prevAtomState.d) || /* @__PURE__ */ new Map(),
      v: value
    };
    if (depSet) {
      updateDependencies(atom, nextAtomState, depSet);
    }
    if (prevAtomState && isEqualAtomValue(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) {
      return prevAtomState;
    }
    setAtomState(atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomError = (atom, error, depSet) => {
    const prevAtomState = getAtomState(atom);
    const nextAtomState = {
      d: (prevAtomState == null ? void 0 : prevAtomState.d) || /* @__PURE__ */ new Map(),
      e: error
    };
    if (depSet) {
      updateDependencies(atom, nextAtomState, depSet);
    }
    if (prevAtomState && isEqualAtomError(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) {
      return prevAtomState;
    }
    setAtomState(atom, nextAtomState);
    return nextAtomState;
  };
  const readAtomState = (atom) => {
    const atomState = getAtomState(atom);
    if (atomState) {
      atomState.d.forEach((_, a) => {
        if (a !== atom && !mountedMap.has(a)) {
          readAtomState(a);
        }
      });
      if (Array.from(atomState.d).every(
        ([a, s]) => a === atom || getAtomState(a) === s
      )) {
        return atomState;
      }
    }
    const depSet = /* @__PURE__ */ new Set();
    let isSync = true;
    const getter = (a) => {
      depSet.add(a);
      if (a === atom) {
        const aState2 = getAtomState(a);
        if (aState2) {
          return returnAtomValue(aState2);
        }
        if (hasInitialValue(a)) {
          return a.init;
        }
        throw new Error("no atom init");
      }
      const aState = readAtomState(a);
      return returnAtomValue(aState);
    };
    let controller;
    let setSelf;
    const options = {
      get signal() {
        if (!controller) {
          controller = new AbortController();
        }
        return controller.signal;
      },
      get setSelf() {
        if ( true && !isActuallyWritableAtom(atom)) {
          console.warn("setSelf function cannot be used with read-only atom");
        }
        if (!setSelf && isActuallyWritableAtom(atom)) {
          setSelf = (...args) => {
            if ( true && isSync) {
              console.warn("setSelf function cannot be called in sync");
            }
            if (!isSync) {
              return writeAtom(atom, ...args);
            }
          };
        }
        return setSelf;
      }
    };
    try {
      const value = atom.read(getter, options);
      if (value instanceof Promise) {
        let continuePromise;
        const promise = new Promise((resolve, reject) => {
          let settled = false;
          value.then(
            (v) => {
              if (!settled) {
                resolvePromise(promise, v);
                resolve(v);
              }
            },
            (e) => {
              if (!settled) {
                rejectPromise(promise, e);
                reject(e);
              }
            }
          ).finally(() => {
            if (!settled) {
              settled = true;
              setAtomValue(atom, promise, depSet);
            }
          });
          continuePromise = (next) => {
            if (!settled) {
              settled = true;
              next.then(
                (v) => resolvePromise(promise, v),
                (e) => rejectPromise(promise, e)
              );
              resolve(next);
            }
          };
        });
        promise.status = "pending";
        registerCancelPromise(promise, (next) => {
          if (next) {
            continuePromise(next);
          }
          controller == null ? void 0 : controller.abort();
        });
        return setAtomValue(atom, promise, depSet);
      }
      return setAtomValue(atom, value, depSet);
    } catch (error) {
      return setAtomError(atom, error, depSet);
    } finally {
      isSync = false;
    }
  };
  const readAtom = (atom) => returnAtomValue(readAtomState(atom));
  const addAtom = (atom) => {
    let mounted = mountedMap.get(atom);
    if (!mounted) {
      mounted = mountAtom(atom);
    }
    return mounted;
  };
  const canUnmountAtom = (atom, mounted) => !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
  const delAtom = (atom) => {
    const mounted = mountedMap.get(atom);
    if (mounted && canUnmountAtom(atom, mounted)) {
      unmountAtom(atom);
    }
  };
  const recomputeDependents = (atom) => {
    const mounted = mountedMap.get(atom);
    mounted == null ? void 0 : mounted.t.forEach((dependent) => {
      if (dependent !== atom) {
        const prevAtomState = getAtomState(dependent);
        const nextAtomState = readAtomState(dependent);
        if (!prevAtomState || !isEqualAtomValue(prevAtomState, nextAtomState)) {
          recomputeDependents(dependent);
        }
      }
    });
  };
  const writeAtomState = (atom, ...args) => {
    let isSync = true;
    const getter = (a) => returnAtomValue(readAtomState(a));
    const setter = (a, ...args2) => {
      let r;
      if (a === atom) {
        if (!hasInitialValue(a)) {
          throw new Error("atom not writable");
        }
        const prevAtomState = getAtomState(a);
        const nextAtomState = setAtomValue(a, args2[0]);
        if (!prevAtomState || !isEqualAtomValue(prevAtomState, nextAtomState)) {
          recomputeDependents(a);
        }
      } else {
        r = writeAtomState(a, ...args2);
      }
      if (!isSync) {
        flushPending();
      }
      return r;
    };
    const result = atom.write(getter, setter, ...args);
    isSync = false;
    return result;
  };
  const writeAtom = (atom, ...args) => {
    const result = writeAtomState(atom, ...args);
    flushPending();
    return result;
  };
  const mountAtom = (atom, initialDependent) => {
    const mounted = {
      t: new Set(initialDependent && [initialDependent]),
      l: /* @__PURE__ */ new Set()
    };
    mountedMap.set(atom, mounted);
    if (true) {
      mountedAtoms.add(atom);
    }
    readAtomState(atom).d.forEach((_, a) => {
      const aMounted = mountedMap.get(a);
      if (aMounted) {
        aMounted.t.add(atom);
      } else {
        if (a !== atom) {
          mountAtom(a, atom);
        }
      }
    });
    readAtomState(atom);
    if (isActuallyWritableAtom(atom) && atom.onMount) {
      const onUnmount = atom.onMount((...args) => writeAtom(atom, ...args));
      if (onUnmount) {
        mounted.u = onUnmount;
      }
    }
    return mounted;
  };
  const unmountAtom = (atom) => {
    var _a;
    const onUnmount = (_a = mountedMap.get(atom)) == null ? void 0 : _a.u;
    if (onUnmount) {
      onUnmount();
    }
    mountedMap.delete(atom);
    if (true) {
      mountedAtoms.delete(atom);
    }
    const atomState = getAtomState(atom);
    if (atomState) {
      if (hasPromiseAtomValue(atomState)) {
        cancelPromise(atomState.v);
      }
      atomState.d.forEach((_, a) => {
        if (a !== atom) {
          const mounted = mountedMap.get(a);
          if (mounted) {
            mounted.t.delete(atom);
            if (canUnmountAtom(a, mounted)) {
              unmountAtom(a);
            }
          }
        }
      });
    } else if (true) {
      console.warn("[Bug] could not find atom state to unmount", atom);
    }
  };
  const mountDependencies = (atom, atomState, prevDependencies) => {
    const depSet = new Set(atomState.d.keys());
    prevDependencies == null ? void 0 : prevDependencies.forEach((_, a) => {
      if (depSet.has(a)) {
        depSet.delete(a);
        return;
      }
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.delete(atom);
        if (canUnmountAtom(a, mounted)) {
          unmountAtom(a);
        }
      }
    });
    depSet.forEach((a) => {
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.add(atom);
      } else if (mountedMap.has(atom)) {
        mountAtom(a, atom);
      }
    });
  };
  const flushPending = () => {
    while (pendingMap.size) {
      const pending = Array.from(pendingMap);
      pendingMap.clear();
      pending.forEach(([atom, prevAtomState]) => {
        const atomState = getAtomState(atom);
        if (atomState) {
          if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
            mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
          }
          const mounted = mountedMap.get(atom);
          if (mounted && !// TODO This seems pretty hacky. Hope to fix it.
          // Maybe we could `mountDependencies` in `setAtomState`?
          (prevAtomState && !hasPromiseAtomValue(prevAtomState) && (isEqualAtomValue(prevAtomState, atomState) || isEqualAtomError(prevAtomState, atomState)))) {
            mounted.l.forEach((listener) => listener());
          }
        } else if (true) {
          console.warn("[Bug] no atom state to flush");
        }
      });
    }
    if (true) {
      stateListeners.forEach((l) => l());
    }
  };
  const subscribeAtom = (atom, listener) => {
    const mounted = addAtom(atom);
    flushPending();
    const listeners = mounted.l;
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
      delAtom(atom);
    };
  };
  if (true) {
    return {
      get: readAtom,
      set: writeAtom,
      sub: subscribeAtom,
      // store dev methods (these are tentative and subject to change)
      dev_subscribe_state: (l) => {
        stateListeners.add(l);
        return () => {
          stateListeners.delete(l);
        };
      },
      dev_get_mounted_atoms: () => mountedAtoms.values(),
      dev_get_atom_state: (a) => atomStateMap.get(a),
      dev_get_mounted: (a) => mountedMap.get(a),
      dev_restore_atoms: (values) => {
        for (const [atom, value] of values) {
          if (hasInitialValue(atom)) {
            setAtomValue(atom, value);
            recomputeDependents(atom);
          }
        }
        flushPending();
      }
    };
  }
  return {
    get: readAtom,
    set: writeAtom,
    sub: subscribeAtom
  };
};
let defaultStore;
const getDefaultStore = () => {
  if (!defaultStore) {
    defaultStore = createStore();
  }
  return defaultStore;
};



;// CONCATENATED MODULE: ./node_modules/jotai/esm/index.mjs



const SUSPENSE_PROMISE = Symbol();
const isSuspensePromise = (promise) => !!promise[SUSPENSE_PROMISE];
const isSuspensePromiseAlreadyCancelled = (suspensePromise) => !suspensePromise[SUSPENSE_PROMISE].c;
const cancelSuspensePromise = (suspensePromise) => {
  var _a;
  const { b: basePromise, c: cancelPromise } = suspensePromise[SUSPENSE_PROMISE];
  if (cancelPromise) {
    cancelPromise();
    (_a = promiseAbortMap.get(basePromise)) == null ? void 0 : _a();
  }
};
const isEqualSuspensePromise = (oldSuspensePromise, newSuspensePromise) => {
  const oldOriginalPromise = oldSuspensePromise[SUSPENSE_PROMISE].o;
  const newOriginalPromise = newSuspensePromise[SUSPENSE_PROMISE].o;
  return oldOriginalPromise === newOriginalPromise || oldSuspensePromise === newOriginalPromise || isSuspensePromise(oldOriginalPromise) && isEqualSuspensePromise(oldOriginalPromise, newSuspensePromise);
};
const createSuspensePromise = (basePromise, promise) => {
  const suspensePromiseExtra = {
    b: basePromise,
    o: promise,
    c: null
  };
  const suspensePromise = new Promise((resolve) => {
    suspensePromiseExtra.c = () => {
      suspensePromiseExtra.c = null;
      resolve();
    };
    promise.finally(suspensePromiseExtra.c);
  });
  suspensePromise[SUSPENSE_PROMISE] = suspensePromiseExtra;
  return suspensePromise;
};
const copySuspensePromise = (suspensePromise) => createSuspensePromise(
  suspensePromise[SUSPENSE_PROMISE].b,
  suspensePromise[SUSPENSE_PROMISE].o
);
const promiseAbortMap = /* @__PURE__ */ new WeakMap();
const registerPromiseAbort = (basePromise, abort) => {
  promiseAbortMap.set(basePromise, abort);
};

const esm_hasInitialValue = (atom) => "init" in atom;
const READ_ATOM = "r";
const WRITE_ATOM = "w";
const COMMIT_ATOM = "c";
const SUBSCRIBE_ATOM = "s";
const RESTORE_ATOMS = "h";
const DEV_SUBSCRIBE_STATE = "n";
const DEV_GET_MOUNTED_ATOMS = "l";
const DEV_GET_ATOM_STATE = "a";
const DEV_GET_MOUNTED = "m";
const esm_createStore = (initialValues) => {
  const committedAtomStateMap = /* @__PURE__ */ new WeakMap();
  const mountedMap = /* @__PURE__ */ new WeakMap();
  const pendingMap = /* @__PURE__ */ new Map();
  let stateListeners;
  let mountedAtoms;
  if (true) {
    stateListeners = /* @__PURE__ */ new Set();
    mountedAtoms = /* @__PURE__ */ new Set();
  }
  if (initialValues) {
    for (const [atom, value] of initialValues) {
      const atomState = {
        v: value,
        r: 0,
        y: true,
        // not invalidated
        d: /* @__PURE__ */ new Map()
      };
      if (true) {
        Object.freeze(atomState);
        if (!esm_hasInitialValue(atom)) {
          console.warn(
            "Found initial value for derived atom which can cause unexpected behavior",
            atom
          );
        }
      }
      committedAtomStateMap.set(atom, atomState);
    }
  }
  const suspensePromiseCacheMap = /* @__PURE__ */ new WeakMap();
  const addSuspensePromiseToCache = (version, atom, suspensePromise) => {
    let cache = suspensePromiseCacheMap.get(atom);
    if (!cache) {
      cache = /* @__PURE__ */ new Map();
      suspensePromiseCacheMap.set(atom, cache);
    }
    suspensePromise.then(() => {
      if (cache.get(version) === suspensePromise) {
        cache.delete(version);
        if (!cache.size) {
          suspensePromiseCacheMap.delete(atom);
        }
      }
    });
    cache.set(version, suspensePromise);
  };
  const cancelAllSuspensePromiseInCache = (atom) => {
    const versionSet = /* @__PURE__ */ new Set();
    const cache = suspensePromiseCacheMap.get(atom);
    if (cache) {
      suspensePromiseCacheMap.delete(atom);
      cache.forEach((suspensePromise, version) => {
        cancelSuspensePromise(suspensePromise);
        versionSet.add(version);
      });
    }
    return versionSet;
  };
  const versionedAtomStateMapMap = /* @__PURE__ */ new WeakMap();
  const getVersionedAtomStateMap = (version) => {
    let versionedAtomStateMap = versionedAtomStateMapMap.get(version);
    if (!versionedAtomStateMap) {
      versionedAtomStateMap = /* @__PURE__ */ new Map();
      versionedAtomStateMapMap.set(version, versionedAtomStateMap);
    }
    return versionedAtomStateMap;
  };
  const getAtomState = (version, atom) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      let atomState = versionedAtomStateMap.get(atom);
      if (!atomState) {
        atomState = getAtomState(version.p, atom);
        if (atomState && "p" in atomState && isSuspensePromiseAlreadyCancelled(atomState.p)) {
          atomState = void 0;
        }
        if (atomState) {
          versionedAtomStateMap.set(atom, atomState);
        }
      }
      return atomState;
    }
    return committedAtomStateMap.get(atom);
  };
  const setAtomState = (version, atom, atomState) => {
    if (true) {
      Object.freeze(atomState);
    }
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.set(atom, atomState);
    } else {
      const prevAtomState = committedAtomStateMap.get(atom);
      committedAtomStateMap.set(atom, atomState);
      if (!pendingMap.has(atom)) {
        pendingMap.set(atom, prevAtomState);
      }
    }
  };
  const createReadDependencies = (version, prevReadDependencies = /* @__PURE__ */ new Map(), dependencies) => {
    if (!dependencies) {
      return prevReadDependencies;
    }
    const readDependencies = /* @__PURE__ */ new Map();
    let changed = false;
    dependencies.forEach((atom) => {
      var _a;
      const revision = ((_a = getAtomState(version, atom)) == null ? void 0 : _a.r) || 0;
      readDependencies.set(atom, revision);
      if (prevReadDependencies.get(atom) !== revision) {
        changed = true;
      }
    });
    if (prevReadDependencies.size === readDependencies.size && !changed) {
      return prevReadDependencies;
    }
    return readDependencies;
  };
  const setAtomValue = (version, atom, value, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      v: value,
      r: (atomState == null ? void 0 : atomState.r) || 0,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    let changed = !(atomState == null ? void 0 : atomState.y);
    if (!atomState || !("v" in atomState) || // new value, or
    !Object.is(atomState.v, value)) {
      changed = true;
      ++nextAtomState.r;
      if (nextAtomState.d.has(atom)) {
        nextAtomState.d = new Map(nextAtomState.d).set(atom, nextAtomState.r);
      }
    } else if (nextAtomState.d !== atomState.d && (nextAtomState.d.size !== atomState.d.size || !Array.from(nextAtomState.d.keys()).every((a) => atomState.d.has(a)))) {
      changed = true;
      Promise.resolve().then(() => {
        flushPending(version);
      });
    }
    if (atomState && !changed) {
      return atomState;
    }
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomReadError = (version, atom, error, dependencies, suspensePromise) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if (suspensePromise && (!("p" in atomState) || !isEqualSuspensePromise(atomState.p, suspensePromise))) {
        return atomState;
      }
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
    }
    const nextAtomState = {
      e: error,
      // set read error
      r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomSuspensePromise = (version, atom, suspensePromise, dependencies) => {
    const atomState = getAtomState(version, atom);
    if (atomState && "p" in atomState) {
      if (isEqualSuspensePromise(atomState.p, suspensePromise) && !isSuspensePromiseAlreadyCancelled(atomState.p)) {
        if (!atomState.y) {
          return { ...atomState, y: true };
        }
        return atomState;
      }
      cancelSuspensePromise(atomState.p);
    }
    addSuspensePromiseToCache(version, atom, suspensePromise);
    const nextAtomState = {
      p: suspensePromise,
      r: ((atomState == null ? void 0 : atomState.r) || 0) + 1,
      y: true,
      // not invalidated
      d: createReadDependencies(version, atomState == null ? void 0 : atomState.d, dependencies)
    };
    setAtomState(version, atom, nextAtomState);
    return nextAtomState;
  };
  const setAtomPromiseOrValue = (version, atom, promiseOrValue, dependencies) => {
    if (promiseOrValue instanceof Promise) {
      const suspensePromise = createSuspensePromise(
        promiseOrValue,
        promiseOrValue.then((value) => {
          setAtomValue(version, atom, value, dependencies, suspensePromise);
        }).catch((e) => {
          if (e instanceof Promise) {
            if (isSuspensePromise(e)) {
              return e.then(() => {
                readAtomState(version, atom, true);
              });
            }
            return e;
          }
          setAtomReadError(version, atom, e, dependencies, suspensePromise);
        })
      );
      return setAtomSuspensePromise(
        version,
        atom,
        suspensePromise,
        dependencies
      );
    }
    return setAtomValue(
      version,
      atom,
      promiseOrValue,
      dependencies
    );
  };
  const setAtomInvalidated = (version, atom) => {
    const atomState = getAtomState(version, atom);
    if (atomState) {
      const nextAtomState = {
        ...atomState,
        // copy everything
        y: false
        // invalidated
      };
      setAtomState(version, atom, nextAtomState);
    } else if (true) {
      console.warn("[Bug] could not invalidate non existing atom", atom);
    }
  };
  const readAtomState = (version, atom, force) => {
    if (!force) {
      const atomState = getAtomState(version, atom);
      if (atomState) {
        if (atomState.y && // not invalidated
        "p" in atomState && !isSuspensePromiseAlreadyCancelled(atomState.p)) {
          return atomState;
        }
        atomState.d.forEach((_, a) => {
          if (a !== atom) {
            if (!mountedMap.has(a)) {
              readAtomState(version, a);
            } else {
              const aState = getAtomState(version, a);
              if (aState && !aState.y) {
                readAtomState(version, a);
              }
            }
          }
        });
        if (Array.from(atomState.d).every(([a, r]) => {
          const aState = getAtomState(version, a);
          return aState && !("p" in aState) && // has no suspense promise
          aState.r === r;
        })) {
          if (!atomState.y) {
            return { ...atomState, y: true };
          }
          return atomState;
        }
      }
    }
    const dependencies = /* @__PURE__ */ new Set();
    try {
      const promiseOrValue = atom.read((a) => {
        dependencies.add(a);
        const aState = a === atom ? getAtomState(version, a) : readAtomState(version, a);
        if (aState) {
          if ("e" in aState) {
            throw aState.e;
          }
          if ("p" in aState) {
            throw aState.p;
          }
          return aState.v;
        }
        if (esm_hasInitialValue(a)) {
          return a.init;
        }
        throw new Error("no atom init");
      });
      return setAtomPromiseOrValue(version, atom, promiseOrValue, dependencies);
    } catch (errorOrPromise) {
      if (errorOrPromise instanceof Promise) {
        const suspensePromise = isSuspensePromise(errorOrPromise) && isSuspensePromiseAlreadyCancelled(errorOrPromise) ? copySuspensePromise(errorOrPromise) : createSuspensePromise(errorOrPromise, errorOrPromise);
        return setAtomSuspensePromise(
          version,
          atom,
          suspensePromise,
          dependencies
        );
      }
      return setAtomReadError(version, atom, errorOrPromise, dependencies);
    }
  };
  const readAtom = (readingAtom, version) => {
    const atomState = readAtomState(version, readingAtom);
    return atomState;
  };
  const addAtom = (version, addingAtom) => {
    let mounted = mountedMap.get(addingAtom);
    if (!mounted) {
      mounted = mountAtom(version, addingAtom);
    }
    return mounted;
  };
  const canUnmountAtom = (atom, mounted) => !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
  const delAtom = (version, deletingAtom) => {
    const mounted = mountedMap.get(deletingAtom);
    if (mounted && canUnmountAtom(deletingAtom, mounted)) {
      unmountAtom(version, deletingAtom);
    }
  };
  const invalidateDependents = (version, atom) => {
    const mounted = mountedMap.get(atom);
    mounted == null ? void 0 : mounted.t.forEach((dependent) => {
      if (dependent !== atom) {
        setAtomInvalidated(version, dependent);
        invalidateDependents(version, dependent);
      }
    });
  };
  const writeAtomState = (version, atom, update) => {
    let isSync = true;
    const writeGetter = (a, options) => {
      const aState = readAtomState(version, a);
      if ("e" in aState) {
        throw aState.e;
      }
      if ("p" in aState) {
        if (options == null ? void 0 : options.unstable_promise) {
          return aState.p.then(() => {
            const s = getAtomState(version, a);
            if (s && "p" in s && s.p === aState.p) {
              return new Promise((resolve) => setTimeout(resolve)).then(
                () => writeGetter(a, options)
              );
            }
            return writeGetter(a, options);
          });
        }
        if (true) {
          console.info(
            "Reading pending atom state in write operation. We throw a promise for now.",
            a
          );
        }
        throw aState.p;
      }
      if ("v" in aState) {
        return aState.v;
      }
      if (true) {
        console.warn(
          "[Bug] no value found while reading atom in write operation. This is probably a bug.",
          a
        );
      }
      throw new Error("no value found");
    };
    const setter = (a, v) => {
      let promiseOrVoid2;
      if (a === atom) {
        if (!esm_hasInitialValue(a)) {
          throw new Error("atom not writable");
        }
        const versionSet = cancelAllSuspensePromiseInCache(a);
        versionSet.forEach((cancelledVersion) => {
          if (cancelledVersion !== version) {
            setAtomPromiseOrValue(cancelledVersion, a, v);
          }
        });
        const prevAtomState = getAtomState(version, a);
        const nextAtomState = setAtomPromiseOrValue(version, a, v);
        if (prevAtomState !== nextAtomState) {
          invalidateDependents(version, a);
        }
      } else {
        promiseOrVoid2 = writeAtomState(version, a, v);
      }
      if (!isSync) {
        flushPending(version);
      }
      return promiseOrVoid2;
    };
    const promiseOrVoid = atom.write(writeGetter, setter, update);
    isSync = false;
    return promiseOrVoid;
  };
  const writeAtom = (writingAtom, update, version) => {
    const promiseOrVoid = writeAtomState(version, writingAtom, update);
    flushPending(version);
    return promiseOrVoid;
  };
  const isActuallyWritableAtom = (atom) => !!atom.write;
  const mountAtom = (version, atom, initialDependent) => {
    const mounted = {
      t: new Set(initialDependent && [initialDependent]),
      l: /* @__PURE__ */ new Set()
    };
    mountedMap.set(atom, mounted);
    if (true) {
      mountedAtoms.add(atom);
    }
    const atomState = readAtomState(void 0, atom);
    atomState.d.forEach((_, a) => {
      const aMounted = mountedMap.get(a);
      if (aMounted) {
        aMounted.t.add(atom);
      } else {
        if (a !== atom) {
          mountAtom(version, a, atom);
        }
      }
    });
    if (isActuallyWritableAtom(atom) && atom.onMount) {
      const setAtom = (update) => writeAtom(atom, update, version);
      const onUnmount = atom.onMount(setAtom);
      version = void 0;
      if (onUnmount) {
        mounted.u = onUnmount;
      }
    }
    return mounted;
  };
  const unmountAtom = (version, atom) => {
    var _a;
    const onUnmount = (_a = mountedMap.get(atom)) == null ? void 0 : _a.u;
    if (onUnmount) {
      onUnmount();
    }
    mountedMap.delete(atom);
    if (true) {
      mountedAtoms.delete(atom);
    }
    const atomState = getAtomState(version, atom);
    if (atomState) {
      if ("p" in atomState) {
        cancelSuspensePromise(atomState.p);
      }
      atomState.d.forEach((_, a) => {
        if (a !== atom) {
          const mounted = mountedMap.get(a);
          if (mounted) {
            mounted.t.delete(atom);
            if (canUnmountAtom(a, mounted)) {
              unmountAtom(version, a);
            }
          }
        }
      });
    } else if (true) {
      console.warn("[Bug] could not find atom state to unmount", atom);
    }
  };
  const mountDependencies = (version, atom, atomState, prevReadDependencies) => {
    const dependencies = new Set(atomState.d.keys());
    prevReadDependencies == null ? void 0 : prevReadDependencies.forEach((_, a) => {
      if (dependencies.has(a)) {
        dependencies.delete(a);
        return;
      }
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.delete(atom);
        if (canUnmountAtom(a, mounted)) {
          unmountAtom(version, a);
        }
      }
    });
    dependencies.forEach((a) => {
      const mounted = mountedMap.get(a);
      if (mounted) {
        mounted.t.add(atom);
      } else if (mountedMap.has(atom)) {
        mountAtom(version, a, atom);
      }
    });
  };
  const flushPending = (version) => {
    if (version) {
      const versionedAtomStateMap = getVersionedAtomStateMap(version);
      versionedAtomStateMap.forEach((atomState, atom) => {
        const committedAtomState = committedAtomStateMap.get(atom);
        if (atomState !== committedAtomState) {
          const mounted = mountedMap.get(atom);
          mounted == null ? void 0 : mounted.l.forEach((listener) => listener(version));
        }
      });
      return;
    }
    while (pendingMap.size) {
      const pending = Array.from(pendingMap);
      pendingMap.clear();
      pending.forEach(([atom, prevAtomState]) => {
        const atomState = getAtomState(void 0, atom);
        if (atomState && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(void 0, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
        if (prevAtomState && !prevAtomState.y && // invalidated
        (atomState == null ? void 0 : atomState.y)) {
          return;
        }
        const mounted = mountedMap.get(atom);
        mounted == null ? void 0 : mounted.l.forEach((listener) => listener());
      });
    }
    if (true) {
      stateListeners.forEach((l) => l());
    }
  };
  const commitVersionedAtomStateMap = (version) => {
    const versionedAtomStateMap = getVersionedAtomStateMap(version);
    versionedAtomStateMap.forEach((atomState, atom) => {
      const prevAtomState = committedAtomStateMap.get(atom);
      if (!prevAtomState || atomState.r > prevAtomState.r || atomState.y !== prevAtomState.y || atomState.r === prevAtomState.r && atomState.d !== prevAtomState.d) {
        committedAtomStateMap.set(atom, atomState);
        if (atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) {
          mountDependencies(version, atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
        }
      }
    });
  };
  const commitAtom = (_atom, version) => {
    if (version) {
      commitVersionedAtomStateMap(version);
    }
    flushPending(void 0);
  };
  const subscribeAtom = (atom, callback, version) => {
    const mounted = addAtom(version, atom);
    const listeners = mounted.l;
    listeners.add(callback);
    return () => {
      listeners.delete(callback);
      delAtom(version, atom);
    };
  };
  const restoreAtoms = (values, version) => {
    for (const [atom, value] of values) {
      if (esm_hasInitialValue(atom)) {
        setAtomPromiseOrValue(version, atom, value);
        invalidateDependents(version, atom);
      }
    }
    flushPending(version);
  };
  if (true) {
    return {
      [READ_ATOM]: readAtom,
      [WRITE_ATOM]: writeAtom,
      [COMMIT_ATOM]: commitAtom,
      [SUBSCRIBE_ATOM]: subscribeAtom,
      [RESTORE_ATOMS]: restoreAtoms,
      [DEV_SUBSCRIBE_STATE]: (l) => {
        stateListeners.add(l);
        return () => {
          stateListeners.delete(l);
        };
      },
      [DEV_GET_MOUNTED_ATOMS]: () => mountedAtoms.values(),
      [DEV_GET_ATOM_STATE]: (a) => committedAtomStateMap.get(a),
      [DEV_GET_MOUNTED]: (a) => mountedMap.get(a)
    };
  }
  return {
    [READ_ATOM]: readAtom,
    [WRITE_ATOM]: writeAtom,
    [COMMIT_ATOM]: commitAtom,
    [SUBSCRIBE_ATOM]: subscribeAtom,
    [RESTORE_ATOMS]: restoreAtoms
  };
};
const createStoreForExport = (initialValues) => {
  const store = esm_createStore(initialValues);
  const get = (atom) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      return void 0;
    }
    return atomState.v;
  };
  const asyncGet = (atom) => new Promise((resolve, reject) => {
    const atomState = store[READ_ATOM](atom);
    if ("e" in atomState) {
      reject(atomState.e);
    } else if ("p" in atomState) {
      resolve(atomState.p.then(() => asyncGet(atom)));
    } else {
      resolve(atomState.v);
    }
  });
  const set = (atom, update) => store[WRITE_ATOM](atom, update);
  const sub = (atom, callback) => store[SUBSCRIBE_ATOM](atom, callback);
  return {
    get,
    asyncGet,
    set,
    sub,
    SECRET_INTERNAL_store: store
  };
};

const createScopeContainer = (initialValues, unstable_createStore) => {
  const store = unstable_createStore ? unstable_createStore(initialValues).SECRET_INTERNAL_store : esm_createStore(initialValues);
  return { s: store };
};
const ScopeContextMap = /* @__PURE__ */ new Map();
const getScopeContext = (scope) => {
  if (!ScopeContextMap.has(scope)) {
    ScopeContextMap.set(scope, (0,react.createContext)(createScopeContainer()));
  }
  return ScopeContextMap.get(scope);
};

const Provider = ({
  children,
  initialValues,
  scope,
  unstable_createStore,
  unstable_enableVersionedWrite
}) => {
  const [version, setVersion] = useState({});
  useEffect(() => {
    const scopeContainer = scopeContainerRef.current;
    if (scopeContainer.w) {
      scopeContainer.s[COMMIT_ATOM](null, version);
      delete version.p;
      scopeContainer.v = version;
    }
  }, [version]);
  const scopeContainerRef = useRef();
  if (!scopeContainerRef.current) {
    const scopeContainer = createScopeContainer(
      initialValues,
      unstable_createStore
    );
    if (unstable_enableVersionedWrite) {
      let retrying = 0;
      scopeContainer.w = (write) => {
        setVersion((parentVersion) => {
          const nextVersion = retrying ? parentVersion : { p: parentVersion };
          write(nextVersion);
          return nextVersion;
        });
      };
      scopeContainer.v = version;
      scopeContainer.r = (fn) => {
        ++retrying;
        fn();
        --retrying;
      };
    }
    scopeContainerRef.current = scopeContainer;
  }
  const ScopeContainerContext = getScopeContext(scope);
  return createElement(
    ScopeContainerContext.Provider,
    {
      value: scopeContainerRef.current
    },
    children
  );
};

function esm_atom(read, write) {
  return atom(read, write);
}

function useAtomValue(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const scopeContainer = (0,react.useContext)(ScopeContext);
  const { s: store, v: versionFromProvider } = scopeContainer;
  const getAtomValue = (version2) => {
    const atomState = store[READ_ATOM](atom, version2);
    if ( true && !atomState.y) {
      throw new Error("should not be invalidated");
    }
    if ("e" in atomState) {
      throw atomState.e;
    }
    if ("p" in atomState) {
      throw atomState.p;
    }
    if ("v" in atomState) {
      return atomState.v;
    }
    throw new Error("no atom value");
  };
  const [[version, valueFromReducer, atomFromReducer], rerenderIfChanged] = (0,react.useReducer)(
    (prev, nextVersion) => {
      const nextValue = getAtomValue(nextVersion);
      if (Object.is(prev[1], nextValue) && prev[2] === atom) {
        return prev;
      }
      return [nextVersion, nextValue, atom];
    },
    versionFromProvider,
    (initialVersion) => {
      const initialValue = getAtomValue(initialVersion);
      return [initialVersion, initialValue, atom];
    }
  );
  let value = valueFromReducer;
  if (atomFromReducer !== atom) {
    rerenderIfChanged(version);
    value = getAtomValue(version);
  }
  (0,react.useEffect)(() => {
    const { v: versionFromProvider2 } = scopeContainer;
    if (versionFromProvider2) {
      store[COMMIT_ATOM](atom, versionFromProvider2);
    }
    const unsubscribe = store[SUBSCRIBE_ATOM](
      atom,
      rerenderIfChanged,
      versionFromProvider2
    );
    rerenderIfChanged(versionFromProvider2);
    return unsubscribe;
  }, [store, atom, scopeContainer]);
  (0,react.useEffect)(() => {
    store[COMMIT_ATOM](atom, version);
  });
  (0,react.useDebugValue)(value);
  return value;
}

function useSetAtom(atom, scope) {
  const ScopeContext = getScopeContext(scope);
  const { s: store, w: versionedWrite } = (0,react.useContext)(ScopeContext);
  const setAtom = (0,react.useCallback)(
    (update) => {
      if ( true && !("write" in atom)) {
        throw new Error("not writable atom");
      }
      const write = (version) => store[WRITE_ATOM](atom, update, version);
      return versionedWrite ? versionedWrite(write) : write();
    },
    [store, versionedWrite, atom]
  );
  return setAtom;
}

function useAtom(atom, scope) {
  if ("scope" in atom) {
    console.warn(
      "atom.scope is deprecated. Please do useAtom(atom, scope) instead."
    );
    scope = atom.scope;
  }
  return [
    useAtomValue(atom, scope),
    // We do wrong type assertion here, which results in throwing an error.
    useSetAtom(atom, scope)
  ];
}




/***/ }),

/***/ 70509:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _extends; }
/* harmony export */ });
/* harmony import */ var core_js_pure_features_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86708);
/* harmony import */ var core_js_pure_features_instance_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22783);


function _extends() {
  var _context;
  return _extends = core_js_pure_features_object_assign_js__WEBPACK_IMPORTED_MODULE_0__ ? core_js_pure_features_instance_bind_js__WEBPACK_IMPORTED_MODULE_1__(_context = core_js_pure_features_object_assign_js__WEBPACK_IMPORTED_MODULE_0__).call(_context) : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 1604:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ z; },
/* harmony export */   "z": function() { return /* binding */ z; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodCatch, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPipeline, ZodPromise, ZodReadonly, ZodRecord, ZodSchema, ZodSet, ZodString, ZodSymbol, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, boolean, coerce, custom, date, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, literal, makeIssue, map, nan, nativeEnum, never, null, nullable, number, object, objectUtil, oboolean, onumber, optional, ostring, pipeline, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, string, symbol, transformer, tuple, undefined, union, unknown, util, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [179], function() { return __webpack_exec__(6840), __webpack_exec__(4795); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);